(function() {
  'use strict';

  angular
    .module('inspinia', 
      [
        'ngAnimate', 
        'ngCookies', 
        'ngTouch', 
        'ngSanitize', 
        'ngMessages', 
        'ngAria', 
        'ngResource', 
        'ui.router',           
        'ui.bootstrap',
        'ngStorage',
        'ngMask',
        'toastr',
        'leaflet-directive',
        'summernote',
        'chart.js',
        'ui.select',
        'datePicker',
        'cgBusy',
        'ui.calendar',
        'webcam'
      ]);
})();

'use strict';

angular.module('inspinia')
  .controller('VendaCadastroSelecionarServicoController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_ROOT', '$compile',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_ROOT, $compile)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registrosOriginal = [];
    vm.registros = null;
    vm.filtro = {};

    vm.init = function()
    {
      vm.consultar();
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/servico")
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.pesquisa != null && vm.filtro.pesquisa != '')
            {
              if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
              {
                incluir = false;

                if (vm.registrosOriginal[i].cpf == null || !vm.registrosOriginal[i].cpf.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                {
                  incluir = false;

                  if (vm.registrosOriginal[i].celular == null || !vm.registrosOriginal[i].celular.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                  {
                      incluir = false;
                  }
                  else
                  {
                    incluir = true;
                  }
                }
                else
                {
                  incluir = true;
                }
              }
              else
              {
                incluir = true;
              }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);        
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('VendaCadastroSelecionarProdutoController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_ROOT', '$compile',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_ROOT, $compile)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registrosOriginal = [];
    vm.registros = null;
    vm.filtro = {};

    vm.init = function()
    {
      vm.consultar();
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/produto")
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.pesquisa != null && vm.filtro.pesquisa != '')
            {
              if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
              {
                incluir = false;

                if (vm.registrosOriginal[i].cpf == null || !vm.registrosOriginal[i].cpf.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                {
                  incluir = false;

                  if (vm.registrosOriginal[i].celular == null || !vm.registrosOriginal[i].celular.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                  {
                      incluir = false;
                  }
                  else
                  {
                    incluir = true;
                  }
                }
                else
                {
                  incluir = true;
                }
              }
              else
              {
                incluir = true;
              }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);        
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('VendaPagamentoController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$filter', '$http', 'APP_ROOT', '$compile', 'pagamento',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $filter, $http, APP_ROOT, $compile, pagamento)
  {
    var vm = this;
    vm.registro = pagamento;
    vm.valor = 0;

    vm.init = function()
    {
      //vm.registro.dataVencimento = new Date(vm.registro.dataVencimento);      
      vm.valor = $filter('currency')(vm.registro.valor.toFixed(2), '', 2);      

      if (vm.registro.dataPagamento == null)
      {
        vm.registro.dataPagamento = new Date();
      }
      else
      {
        vm.registro.dataPagamento = new Date(vm.registro.dataPagamento);
      }
      //vm.consultar();
    }

    vm.salvar = function()
    {
      var registro = {
        viewId: vm.registro.viewId,
        valor: parseFloat(vm.valor.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.')),
        dataPagamento: vm.registro.dataPagamento,
        dataVencimento: vm.registro.dataPagamento,
        formaPagamento: vm.registro.formaPagamento,
        situacao: vm.registro.situacao
      };

      vm.salvarPromise = $http.post(APP_ROOT + "/venda/atualizarpagamento", registro).success(function(response){           
        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        $uibModalInstance.close(true);
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/produto")
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close(false);
    }

    vm.init();
}]);
'use strict';

angular.module('inspinia')
  .controller('VendaCadastroSelecionarClienteController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_ROOT', '$compile',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_ROOT, $compile)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registrosOriginal = [];
    vm.registros = null;
    vm.filtro = {};

    vm.init = function()
    {
      vm.consultar();
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/cliente")
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.pesquisa != null && vm.filtro.pesquisa != '')
            {
              if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
              {
                incluir = false;

                if (vm.registrosOriginal[i].cpf == null || !vm.registrosOriginal[i].cpf.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                {
                  incluir = false;

                  if (vm.registrosOriginal[i].celular == null || !vm.registrosOriginal[i].celular.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                  {
                      incluir = false;
                  }
                  else
                  {
                    incluir = true;
                  }
                }
                else
                {
                  incluir = true;
                }
              }
              else
              {
                incluir = true;
              }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);        
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('VendaAddPagamentoController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$filter', '$http', 'APP_ROOT', '$compile', 'venda',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $filter, $http, APP_ROOT, $compile, venda)
  {
    var vm = this;
    vm.registroVenda = venda;
    vm.valor = 0;
    vm.registro = {
      viewId: '00000000-0000-0000-0000-000000000000',
      tipoPagamento: 1,
      formaPagamento: 1,
      dataPagamento: new Date(),
      dataVencimento: new Date(),
      situacao: 2,
      quantidade: 1
    };

    vm.init = function()
    {
      //vm.registro.dataVencimento = new Date(vm.registro.dataVencimento); 
      /*     
      vm.valor = $filter('currency')(vm.registro.valor.toFixed(2), '', 2);      

      if (vm.registro.dataPagamento == null)
      {
        vm.registro.dataPagamento = new Date();
      }
      else
      {
        vm.registro.dataPagamento = new Date(vm.registro.dataPagamento);
      }
      */
      //vm.consultar();
    }

    vm.salvar = function()
    {      
      //vm.registro.tipoPagamento = vm.registro.tipoPagamento;
      vm.registro.valor = parseFloat(vm.valor.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
      vm.registro.vendaViewId = venda.viewId;
      vm.registro.dataPagamento = vm.registro.dataPagamento;
      vm.registro.dataVencimento = vm.registro.dataPagamento;
      //vm.registro.formaPagamento = vm.registro.formaPagamento;
      //vm.registro.situacao = vm.registro.situacao;

      if (vm.registro.valor <= 0)
      {
        toastr.error('Valor é inválido.', 'Alerta');
        return;
      }

      // A vista
      if (vm.registro.tipoPagamento == 1)
      {
        vm.registro.numeroParcela = 0;
        vm.registro.totalParcelas = 0;

        var urlApi = "/venda/gerarpagamento";

        if (venda.tipo == 'agenda')
        {
          urlApi = "/agenda/gerarpagamento";
          vm.registro.agendaViewId = venda.viewId;
        }

        vm.salvarPromise = $http.post(APP_ROOT + urlApi, vm.registro).success(function(response){           
          toastr.info('Requisição enviada com sucesso.', 'Alerta');
          $uibModalInstance.close(true);
          return response;
        }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
        });
      }
      // Parcelado
      else if (vm.registro.tipoPagamento == 2)
      {
        if (vm.registro.quantidade == 0)
        {
          toastr.error('Informe o número de parcelas.', 'Alerta');
          return;
        }

        if (vm.registro.quantidade > 36)
        {
          toastr.error('Quantidade máxima de parcelas é de 36x.', 'Alerta');
          return;
        }

        vm.registro.numeroParcela = 0;
        vm.registro.totalParcelas = vm.registro.quantidade;

        var urlApi = "/venda/gerarpagamento";

        if (venda.tipo == 'agenda')
        {
          urlApi = "/agenda/gerarpagamento";
          vm.registro.agendaViewId = venda.viewId;
        }

        vm.salvarPromise = $http.post(APP_ROOT + urlApi, vm.registro).success(function(response){           
          toastr.info('Requisição enviada com sucesso.', 'Alerta');
          $uibModalInstance.close(true);
          return response;
        }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
        });
      }

      /*
      vm.salvarPromise = $http.post(APP_ROOT + "/venda/gerarpagamento", registro).success(function(response){           
        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        $uibModalInstance.close(true);
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
      */
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/produto")
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close(false);
    }

    vm.init();
}]);
'use strict';
angular.module('inspinia')
  .controller('ReciboDocumentoController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', '$sce', '$filter', '$uibModalInstance', 'viewId',
      function($scope, $state, toastr, $http, APP_ROOT, $sce, $filter, $uibModalInstance, viewId)
{
    var vm = this;
    
    vm.init = function()
    {
      vm.arquivo =  $sce.trustAsResourceUrl(APP_ROOT + "/venda/GetRecibo/" + viewId);
    }

    vm.init();

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }
}]);

'use strict';

angular.module('inspinia')
  .controller('TarefaModalCadastrarController', ['$scope', '$state', 'toastr','$uibModalInstance', '$http', 'APP_ROOT', '$compile', 'projeto',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_ROOT, $compile, projeto)
  {
    var vm = this;
    vm.registro = {
      projeto: projeto
    }

    vm.init = function()
    {
      vm.listarUsuarios();
    }

    vm.salvar = function()
    {
      vm.salvarPromise = $http.post(APP_ROOT + "/tarefa", vm.registro).success(function(response){   
        toastr.info('Tarefa cadastrado com sucesso.', 'Alerta');
        vm.fechar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }

    vm.listarUsuarios = function()
    {
      vm.usuariosPromise =  $http.get(APP_ROOT + "/usuario");

      vm.usuariosPromise.then(function(result) {  
        vm.usuarios = result.data; 
        vm.registro.usuarioResponsavel = vm.usuarios[0];
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('ProjetoModalReplicarController', ['$scope', '$state', 'toastr','$uibModalInstance', '$http', 'APP_ROOT', '$compile', 'projeto',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_ROOT, $compile, projeto)
  {
    var vm = this;
    vm.projeto = projeto;

    vm.init = function()
    {
      vm.listarProjetos();
    }

    vm.replicarTarefas = function()
    {
      if (vm.projetoModelo.tarefas.length == 0)
      {
        toastr.error('Projeto selecionado não possui tarefas.', 'Alerta');
        return;
      }

      vm.salvarPromise = $http.put(APP_ROOT + "/projeto/replicartarefas/" + vm.projeto.viewId, vm.projetoModelo).success(function(response){   
        toastr.info('Tarefas replicadas com sucesso.', 'Alerta');
        vm.fechar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }

    vm.listarProjetos = function()
    {
      vm.projetosPromise =  $http.get(APP_ROOT + "/projeto");

      vm.projetosPromise.then(function(result) {  
        vm.projetos = result.data; 
        vm.projetoModelo = vm.projetos[0];
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('ProjetoModalCadastrarController', ['$scope', '$state', 'toastr','$uibModalInstance', '$http', 'APP_ROOT', '$compile', 'objetivo',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_ROOT, $compile, objetivo)
  {
    var vm = this;
    vm.registro = {
      objetivo: objetivo
    }

    vm.init = function()
    {
      vm.listarUsuarios();
    }

    vm.salvar = function()
    {
      vm.salvarPromise = $http.post(APP_ROOT + "/projeto", vm.registro).success(function(response){   
        toastr.info('Projeto cadastrado com sucesso.', 'Alerta');
        vm.fechar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }

    vm.listarUsuarios = function()
    {
      vm.usuariosPromise =  $http.get(APP_ROOT + "/usuario");

      vm.usuariosPromise.then(function(result) {  
        vm.usuarios = result.data; 
        vm.registro.usuarioResponsavel = vm.usuarios[0];
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('ProdutoEstoqueHistoricoController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$filter', '$http', 'APP_ROOT', '$compile', 'produto',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $filter, $http, APP_ROOT, $compile, produto)
  {
    var vm = this;
    vm.produto = produto;

    vm.init = function()
    {
      vm.consultar();
    }

    vm.salvar = function()
    {
      var registro = {
        viewId: vm.registro.viewId,
        valor: parseFloat(vm.valor.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.')),
        dataPagamento: vm.registro.dataPagamento,
        dataVencimento: vm.registro.dataPagamento,
        formaPagamento: vm.registro.formaPagamento,
        situacao: vm.registro.situacao
      };

      vm.salvarPromise = $http.post(APP_ROOT + "/venda/atualizarpagamento", registro).success(function(response){           
        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        $uibModalInstance.close(true);
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/produto/estoque/" + vm.produto.viewId)
      .then(function(response)
      {        
        vm.items = response.data;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close(false);
    }

    vm.init();
}]);
'use strict';

angular.module('inspinia')
  .controller('ProdutoEstoqueReporController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$filter', '$http', 'APP_ROOT', '$compile', 'produto',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $filter, $http, APP_ROOT, $compile, produto)
  {
    var vm = this;
    vm.produto = produto;
    vm.estoqueAtual = 0;
    vm.quantidade = 0;
    vm.estoqueAtualizado = 0;

    vm.init = function()
    {
      vm.estoqueAtual = vm.produto.estoqueAtual;
      vm.estoqueAtualizado = vm.quantidade + vm.estoqueAtual;
    }

    vm.calcularTotal = function()
    {
      vm.estoqueAtualizado = vm.quantidade + vm.estoqueAtual;
    }

    vm.salvar = function()
    {
      var registro = {
        produtoViewId: vm.produto.viewId,
        quantidade: vm.quantidade,
      };

      vm.salvarPromise = $http.put(APP_ROOT + "/produto/reporestoque", registro).success(function(response){           
        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        $uibModalInstance.close(true);
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/produto")
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close(false);
    }

    vm.init();
}]);
'use strict';

angular.module('inspinia')
  .controller('ProdutoEstoqueCorrigirController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$filter', '$http', 'APP_ROOT', '$compile', 'produto',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $filter, $http, APP_ROOT, $compile, produto)
  {
    var vm = this;
    vm.produto = produto;
    vm.quantidade = 0;

    vm.init = function()
    {
      vm.quantidade = vm.produto.estoqueAtual;
    }

    vm.salvar = function()
    {
      var registro = {
        produtoViewId: vm.produto.viewId,
        quantidade: vm.quantidade,
      };

      vm.salvarPromise = $http.put(APP_ROOT + "/produto/corrigirestoque", registro).success(function(response){           
        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        $uibModalInstance.close(true);
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/produto")
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close(false);
    }

    vm.init();
}]);
'use strict';

angular.module('inspinia')
  .controller('ProdutoCategoriaCadastrarController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$filter', '$http', 'APP_ROOT', '$compile', 'categoria',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $filter, $http, APP_ROOT, $compile, categoria)
  {
    var vm = this;
    vm.registro = {};
    vm.isUpdate = false;

    vm.init = function()
    {
      if (categoria != null)
      {
        vm.isUpdate = true;

        vm.consultar();
      }
      else
      {
        vm.isUpdate = false;
      }
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/produtoCategoria/" + categoria.viewId)
      .then(function(response)
      {           
        vm.registro = response.data;
      });
    }

    vm.salvar = function()
    {
      if (vm.registro.nome == null || vm.registro.nome == '')
      {
        toastr.error('Nome é obrigatório.', 'Alerta');
        return;
      }

      if (!vm.isUpdate)
      {
        vm.salvarPromise = $http.post(APP_ROOT + "/produtoCategoria", vm.registro).success(function(response){           
          toastr.info('Categoria cadastrada com sucesso.', 'Alerta');
          $uibModalInstance.close();
          return response;
        }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
        });
      }    
      else
      {
        vm.salvarPromise = $http.put(APP_ROOT + "/produtoCategoria/" + vm.registro.viewId, vm.registro).success(function(response){        
          toastr.info('Categoria atualizada com sucesso.', 'Alerta');        
          $uibModalInstance.close();
          return response;
        }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
        });
      }
    }

    vm.selecionar = function(registro)
    {
      //$uibModalInstance.close(registro);
    }

    vm.fechar = function()
    {
      $uibModalInstance.close(false);
    }

    vm.init();
}]);
'use strict';

angular.module('inspinia')
  .controller('AgendaCalendarioConsultarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', '$uibModal', '$uibModalInstance', '$filter', 'viewId',
      function($scope, $state, toastr, $http, APP_ROOT, $uibModal, $uibModalInstance, $filter, viewId)
{
    var vm = this;
    vm.viewId = viewId;
    vm.isUpdate = false;
    //vm.registroViewId = $state.params.viewId;      

    vm.init = function()
    { 
        vm.listarClientes();
        vm.listarUsuarios();

        if (vm.viewId != null)
        {
            vm.isUpdate = true;
            vm.consultar();
        }
        else
        {
            vm.isUpdate = false;
            vm.registro = {};
            vm.registro.status = 0;
            vm.registro.duracao = 30;

            vm.registro.dataAgenda = new Date();
            var pad = "00";
            var hora = vm.registro.dataAgenda.getHours().toString();
            var minuto = vm.registro.dataAgenda.getMinutes().toString();
            vm.registro.horaAgenda = (pad.substring(0, pad.length - hora.length) + hora) + ":" + (pad.substring(0, pad.length - minuto.length) + minuto);
        }
    }

    vm.listarClientes = function()
    {
        vm.consultarClientePromise = $http.get(APP_ROOT + "/cliente")
        .then(function(response)
        {           
            vm.clientes = response.data;

            if (vm.registro.cliente == null)
            {
                vm.registro.cliente = vm.clientes[0];
            }
            /*
            if (!vm.isUpdate && vm.clientes.length > 0)
            {
                vm.registro.cliente = {
                    viewId : vm.clientes[0].viewId
                };
            }
            */
        });
    }

    vm.listarUsuarios = function()
    {
        vm.consultarUsuariosPromise = $http.get(APP_ROOT + "/usuario/usuarios")
        .then(function(response)
        {           
            vm.usuarios = response.data;

            if (vm.registro.responsavel == null)
            {
                vm.registro.responsavel = vm.usuarios[0];
            }
        });
    }
    
    vm.consultar = function()
    {
        vm.registrosPromise = $http.get(APP_ROOT + "/agenda/" + vm.viewId)
        .then(function(response)
        { 
            vm.registro = response.data;
            vm.registro.dataAgenda = new Date(vm.registro.dataAgenda);
            var pad = "00";
            var hora = vm.registro.dataAgenda.getHours().toString();
            var minuto = vm.registro.dataAgenda.getMinutes().toString();
            vm.registro.horaAgenda = (pad.substring(0, pad.length - hora.length) + hora) + ":" + (pad.substring(0, pad.length - minuto.length) + minuto);

            vm.registro.valorAdicional = $filter('currency')(vm.registro.valorAdicional.toFixed(2), '', 2);
            vm.registro.valorDesconto = $filter('currency')(vm.registro.valorDesconto.toFixed(2), '', 2);

            vm.listarPagamentos();
        });
    }

    vm.listarPagamentos = function()
    {
        vm.consultarPagamentosPromise = $http.get(APP_ROOT + "/agenda/pagamento/" + vm.viewId)
        .then(function(response)
        {           
        vm.pagamentos = response.data;
        });
    }

    vm.salvar = function()
    {
        if (vm.isUpdate)
        {
            vm.registro.valorAdicional = parseFloat(vm.registro.valorAdicional.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
            vm.registro.valorDesconto = parseFloat(vm.registro.valorDesconto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
        }

        vm.registro.dataAgenda = new Date(new Date(vm.registro.dataAgenda).setHours(-3));

        if (!vm.isUpdate)
        {
            vm.salvarPromise = $http.post(APP_ROOT + "/agenda/", vm.registro).success(function(response){        
                toastr.info('Registro enviado com sucesso.', 'Alerta');
                $uibModalInstance.close();
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
        else
        {
            vm.salvarPromise = $http.put(APP_ROOT + "/agenda/" + vm.registro.viewId, vm.registro).success(function(response){        
                toastr.info('Registro atualizado com sucesso.', 'Alerta');
                $uibModalInstance.close();
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };








    
    vm.quantidadeServico = 1;
    vm.valorServico = 0;

    vm.selecionarServicoModal = function()
    {
        var modalInstance = $uibModal.open({
        templateUrl: 'app/venda/cadastrar/modal/servico/index.html',
        controller: 'VendaCadastroSelecionarServicoController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
        vm.servico = null;
        if (data != null)
        {
            vm.servico = data;
            vm.valorServico = vm.servico.valorUnitarioTexto;
        }      
        });
    }
    vm.adicionarPagamento = function()
    {
        vm.registro.tipo = 'agenda';

        var modalInstance = $uibModal.open({
        templateUrl: 'app/venda/cadastrar/modal/addpagamento/index.html',
        controller: 'VendaAddPagamentoController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        //backdrop: false,
        size: 'lg',
        resolve: {
            venda: function () {
                return vm.registro;
            },
        }
        }).result.then(function(data){
        if (data)
        {
            //vm.consultar();
            vm.listarPagamentos();
        }
        });
    }
    vm.editarPagamento = function(p)
    {
        var modalInstance = $uibModal.open({
        templateUrl: 'app/venda/cadastrar/modal/pagamento/index.html',
        controller: 'VendaPagamentoController',
        controllerAs: 'controller',
        windowClass: 'inmodal',      
        //backdrop: false,
        size: 'lg',
        resolve: {
            pagamento: function () {
                return p;
            },
        }
        }).result.then(function(data){
        if (data)
        {
            vm.consultar();
        }
        });
    }
    vm.removerPagamento = function(p)
    {
        if (confirm('Deseja realmente excluir o pagamento?'))
        {
        vm.salvarPromise = $http.delete(APP_ROOT + "/venda/excluirpagamento/" + p.viewId).success(function(response){           
            toastr.info('Registro excluído com sucesso.', 'Alerta');
            vm.consultar();
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
        }
    }
    vm.visualizarRecibo = function()
    {
        var modalInstance = $uibModal.open({
        templateUrl: 'app/venda/cadastrar/recibo/index.html',
        controller: 'ReciboDocumentoController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        //backdrop: false,
        size: 'lg',
        resolve: {
            viewId: function () {
                return vm.registroViewId;
            },
        }
        }).result.then(function(data){
        });
    }
    vm.selecionarServico = function()
    {
        if (vm.servico != null)
        {         
        vm.valorServico = vm.servico.valorUnitarioTexto;
        }
    }
    vm.listarServicos = function()
    {
        vm.consultarServicoPromise = $http.get(APP_ROOT + "/servico")
        .then(function(response)
        {           
        vm.servicos = response.data;
        });
    }

    vm.adicionarServico = function()
    {
        if (vm.servico == null)
        {
        toastr.error('Selecione um serviço.', 'Alerta');
        return;
        }

        if (vm.quantidadeServico <= 0)
        {
        toastr.error('Informe a quantidade do serviço.', 'Alerta');
        return;
        }

        var valorServico = parseFloat(vm.valorServico.toString().replaceAll('R$','').replaceAll('.','').replaceAll(',','.'));

        if (vm.servico != null && vm.servico.viewId != null)
        {
        for(var indice in vm.registro.servicos){
            if(vm.registro.servicos[indice].viewId == vm.servico.viewId)
            {
            toastr.error('Serviço já adicionado.', 'Alerta');
            return;
            }
        }

        var novoServico = 
        {
            viewId : vm.servico.viewId,
            nome : vm.servico.nome,
            valorUnitario : valorServico,
            quantidade : vm.quantidadeServico
        }

        vm.registro.servicos.push(novoServico);

        //vm.valorServico = 'R$0,00';
        vm.quantidadeServico = 1;
        }
        else
        {
        toastr.error('Selecione um serviço', 'Alerta');
        }

        vm.calcular();
    }

    vm.removerServico = function(registro)
    {
        for(var indice in vm.registro.servicos){
        if(vm.registro.servicos[indice].viewId == registro.viewId)
        {
            vm.registro.servicos.splice(indice, 1);
        }
        }
        vm.calcular();
    }

    vm.calcular = function()
    {
        // Calcular servicos
        var totalServicos = 0;
        for(var indice in vm.registro.servicos){
        totalServicos = totalServicos + (vm.registro.servicos[indice].valorUnitario * vm.registro.servicos[indice].quantidade);
        }

        vm.registro.valorTotal =  (parseFloat(vm.registro.valorAdicional.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.')) + totalServicos) - parseFloat(vm.registro.valorDesconto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('VendaImprimirController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'UsuarioService', '$uibModal', '$sce',
      function($scope, $state, toastr, $http, APP_ROOT, UsuarioService, $uibModal, $sce)
{
  var vm = this;
  vm.registroViewId = $state.params.viewId;    
  vm.isUpdate = false;

  vm.init = function()
  {    
    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;
      vm.arquivo =  $sce.trustAsResourceUrl(APP_ROOT + "/Venda/GetDocumento/" + vm.registroViewId);
      //vm.consultar();
    }
    else
    {
      vm.isUpdate = false;
    }

    //vm.listarUsuarios();
  }


  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/Venda/GetDocumento/" + vm.registroViewId)
    .then(function(response)
    {           
      vm.registro = response.data;
      var blob = new Blob([ response.data ], { type : 'application/pdf' });
      vm.arquivo = $sce.trustAsResourceUrl(URL.createObjectURL(blob));
    });
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('VendaPesquisarController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;
    vm.tipo = $state.params.tipo;
    vm.titulo = '';

    vm.pesquisar = function()
    {        
        if (vm.tipo != null)
        {
            if (vm.tipo == 0)
            {
                vm.titulo = 'Venda';
            }
            else if (vm.tipo == 1)
            {
                vm.titulo = 'Pedido';
            }
            else if (vm.tipo == 2)
            {
                vm.titulo = 'Orçamento';
            }
        }

        vm.registros = null;
        vm.registrosOriginal = null;
        
        vm.registrosPromise = $http.get(APP_ROOT + "/venda/pesquisartipo/" + vm.tipo + "/0")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.pager.totalPages = 1;
            vm.setPage(1);
        });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.numero != null && vm.filtro.numero != '')
            {
                if (!vm.registrosOriginal[i].numero.toUpperCase().includes(vm.filtro.numero.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cliente != null && vm.filtro.cliente != '')
            {
                if (!vm.registrosOriginal[i].cliente.nome.toUpperCase().includes(vm.filtro.cliente.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.usuario != null && vm.filtro.usuario != '')
            {
                if (!vm.registrosOriginal[i].usuarioCadastro.nome.toUpperCase().includes(vm.filtro.usuario.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.incluir = function()
    {
      $state.go('index.venda_cadastrar');
    }

    vm.visualizar = function(p)
    {      
      if (p.registroAntigo == 2)
      {
        $state.go('index.orcamento_imprimir', {viewId: p.viewId});
      }
      else if (p.registroAntigo == 1)
      {
        $state.go('index.pedido_imprimir', {viewId: p.viewId});
      }
      else
      {
        $state.go('index.venda_imprimir', {viewId: p.viewId});
      }
    }

    vm.alterar = function(p)
    {      
      if (p.registroAntigo == 2)
      {
        $state.go('index.orcamento_cadastrar', {viewId: p.viewId});
      }
      else if (p.registroAntigo == 1)
      {
        $state.go('index.pedido_cadastrar', {viewId: p.viewId});
      }
      else
      {
        $state.go('index.venda_cadastrar', {viewId: p.viewId});
      }
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('VendaCadastrarOldController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'UsuarioService', '$uibModal',
      function($scope, $state, toastr, $http, APP_ROOT, UsuarioService, $uibModal)
{
  var vm = this;

  vm.registro = {    
    produtos : [],
    servicos : []
  };
  vm.quantidadeProduto = 1;
  vm.quantidadeServico = 1;
  vm.valorProduto = 0;
  vm.valorServico = 0;
  vm.registroViewId = $state.params.viewId;    
  vm.tipo = $state.params.tipo;    
  vm.isUpdate = false;
  vm.titulo = '';  

  vm.init = function()
  {    
    if (vm.tipo != null)
    {
      if (vm.tipo == 0)
      {
        vm.titulo = 'Venda';
        vm.registro.tipoVenda = 0;
      }
      else if (vm.tipo == 1)
      {
        vm.titulo = 'Pedido';
        vm.registro.tipoVenda = 1;
      }
      else if (vm.tipo == 2)
      {
        vm.titulo = 'Orçamento';
        vm.registro.tipoVenda = 2;
      }
    }
    else
    {
      vm.registro.tipoVenda = 0;
    }

    vm.listarClientes();
    vm.listarProdutos();
    vm.listarServicos();

    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;

      vm.consultar();
    }
    else
    {
      vm.isUpdate = false;
      vm.registro.situacaoPagamento = 1;
      vm.registro.formaPagamento = 1;

      vm.registro.dataVenda = new Date();
    }
  }

  vm.salvar = function()
  {
    var registro = vm.registro;    

    vm.registro.valorAdicional = parseFloat(vm.registro.valorAdicional.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
    vm.registro.valorDesconto = parseFloat(vm.registro.valorDesconto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
    //vm.registro.valorTotal = parseFloat(vm.registro.valorTotal.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));

    if (!vm.isUpdate)
    {
      registro.tipoVenda = vm.tipo;
      
      vm.salvarPromise = $http.post(APP_ROOT + "/venda/registrar", registro).success(function(response){   
        
        vm.registroViewId = response.viewId;
        vm.isUpdate = true;

        toastr.info(vm.titulo + ' registrada com sucesso.', 'Alerta');

        $state.go('index.venda_pesquisar', {tipo: vm.tipo});
        //$state.go('index.venda_cadastrar', {viewId: vm.registroViewId});

        //vm.consultar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }    
    else
    {

      vm.salvarPromise = $http.put(APP_ROOT + "/venda", registro).success(function(response){        
        toastr.info(vm.titulo + ' atualizada com sucesso.', 'Alerta');
        //vm.consultar();
        //$state.go('index.venda_pesquisar');
        $state.go('index.venda_pesquisar', {tipo: vm.tipo});
        //$state.go('index.pesquisaratendimento');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/venda/" + vm.registroViewId)
    .then(function(response)
    {           
      vm.registro = response.data;
      vm.registro.valorAdicional = vm.registro.valorAdicional.toFixed(2);
      vm.registro.valorDesconto = vm.registro.valorDesconto.toFixed(2);
      
      vm.tipo = vm.registro.tipoVenda;

      if (vm.registro.dataVenda != null)
      {
        vm.registro.dataVenda = new Date(vm.registro.dataVenda);

        vm.calcular();
      }
    });
  }

  vm.listarClientes = function()
  {
    vm.consultarClientePromise = $http.get(APP_ROOT + "/cliente")
    .then(function(response)
    {            
      vm.clientes = response.data;

      if (!vm.isUpdate && vm.clientes.length > 0)
      {
        vm.registro.cliente = {
          viewId : vm.clientes[0].viewId
        };
      }
    });
  }

  vm.selecionarProduto = function()
  {
    if (vm.produto != null)
    {         
      vm.valorProduto = vm.produto.valorUnitarioTexto;
    }
  }

  vm.selecionarServico = function()
  {
    if (vm.servico != null)
    {         
      vm.valorServico = vm.servico.valorUnitarioTexto;
    }
  }

  vm.listarProdutos = function()
  {
    vm.consultarProdutoPromise = $http.get(APP_ROOT + "/produto")
    .then(function(response)
    {           
      vm.produtos = response.data;

      /*
      if (vm.produtos.length > 0)
      {
        vm.produto = vm.produtos[0];
      }
      */
    });
  }

  vm.listarServicos = function()
  {
    vm.consultarServicoPromise = $http.get(APP_ROOT + "/servico")
    .then(function(response)
    {           
      vm.servicos = response.data;
      /*
      if (vm.servicos.length > 0)
      {
        vm.servico = vm.servicos[0];
      }
      */
    });
  }

  vm.adicionarProduto = function()
  {
    if (vm.produto == null)
    {
      toastr.error('Selecione um produto.', 'Alerta');
      return;
    }

    if (vm.quantidadeProduto <= 0)
    {
      toastr.error('Informe a quantidade do produto.', 'Alerta');
      return;
    }

    var valorProduto = parseFloat(vm.valorProduto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));

    if (vm.produto != null && vm.produto.viewId != null)
    {
      for(var indice in vm.registro.produtos){
        if(vm.registro.produtos[indice].viewId == vm.produto.viewId)
        {
          toastr.error('Produto já adicionado.', 'Alerta');
          return;
        }
      }

      var novoProduto = 
      {
        viewId : vm.produto.viewId,
        nome : vm.produto.nome,
        valorUnitario : valorProduto,
        quantidade : vm.quantidadeProduto
      }

      vm.registro.produtos.push(novoProduto);
      
      //vm.valorProduto = 'R$0,00';
      vm.quantidadeProduto = 1;
    }
    else
    {
      toastr.error('Selecione um produto', 'Alerta');
    }

    vm.calcular();
  }

  vm.adicionarServico = function()
  {
    if (vm.servico == null)
    {
      toastr.error('Selecione um serviço.', 'Alerta');
      return;
    }

    if (vm.quantidadeServico <= 0)
    {
      toastr.error('Informe a quantidade do serviço.', 'Alerta');
      return;
    }

    var valorServico = parseFloat(vm.valorServico.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));

    if (vm.servico != null && vm.servico.viewId != null)
    {
      for(var indice in vm.registro.servicos){
        if(vm.registro.servicos[indice].viewId == vm.servico.viewId)
        {
          toastr.error('Serviço já adicionado.', 'Alerta');
          return;
        }
      }

      var novoServico = 
      {
        viewId : vm.servico.viewId,
        nome : vm.servico.nome,
        valorUnitario : valorServico,
        quantidade : vm.quantidadeServico
      }

      vm.registro.servicos.push(novoServico);

      //vm.valorServico = 'R$0,00';
      vm.quantidadeServico = 1;
    }
    else
    {
      toastr.error('Selecione um serviço', 'Alerta');
    }

    vm.calcular();
  }

  vm.removerProduto = function(registro)
  {
    for(var indice in vm.registro.produtos){
      if(vm.registro.produtos[indice].viewId == registro.viewId)
      {
        vm.registro.produtos.splice(indice, 1);
      }
    }
    vm.calcular();
  }

  vm.removerServico = function(registro)
  {
    for(var indice in vm.registro.servicos){
      if(vm.registro.servicos[indice].viewId == registro.viewId)
      {
        vm.registro.servicos.splice(indice, 1);
      }
    }
    vm.calcular();
  }

  vm.excluir = function()
  {
    if (confirm('Deseja realmente excluir este registro?'))
    {
      vm.excluirPromise = $http.delete(APP_ROOT + "/venda/" + vm.registro.viewId).success(function(response){        
        toastr.info('Solicitação excluída com sucesso.', 'Alerta');      
        $state.go('index.venda_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.calcular = function()
  {
    // Calcular produtos
    var totalProdutos = 0;
    for(var indice in vm.registro.produtos){
      totalProdutos = totalProdutos + (vm.registro.produtos[indice].valorUnitario * vm.registro.produtos[indice].quantidade);
    }

    // Calcular servicos
    var totalServicos = 0;
    for(var indice in vm.registro.servicos){
      totalServicos = totalServicos + (vm.registro.servicos[indice].valorUnitario * vm.registro.servicos[indice].quantidade);
    }

    vm.registro.valorTotal =  (parseFloat(vm.registro.valorAdicional.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.')) + totalProdutos + totalServicos) - parseFloat(vm.registro.valorDesconto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';
angular.module('inspinia')
  .controller('VendaCadastrarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'UsuarioService', '$uibModal', '$filter',
      function($scope, $state, toastr, $http, APP_ROOT, UsuarioService, $uibModal, $filter)
{
  var vm = this;

  vm.registro = {    
    produtos : [],
    servicos : []
  };
  vm.quantidadeProduto = 1;
  vm.quantidadeServico = 1;
  vm.valorProduto = 0;
  vm.valorServico = 0;
  vm.registroViewId = $state.params.viewId;    
  vm.tipo = $state.params.tipo;    
  vm.isUpdate = false;
  vm.titulo = '';  
  vm.restricaoSituacaoVenda = true;

  vm.init = function()
  {    
    vm.restricaoSituacaoVendaPromise = $http.get(APP_ROOT + "/checkmodule/restricaosituacaovenda")
    .then(function(response)
    { 
      vm.restricaoSituacaoVenda = response.data;
    });

    if (vm.tipo != null)
    {
      if (vm.tipo == 0)
      {
        vm.titulo = 'Venda';
        vm.registro.tipoVenda = 0;
      }
      else if (vm.tipo == 1)
      {
        vm.titulo = 'Pedido';
        vm.registro.tipoVenda = 1;
      }
      else if (vm.tipo == 2)
      {
        vm.titulo = 'Orçamento';
        vm.registro.tipoVenda = 2;
      }
    }
    else
    {
      vm.registro.tipoVenda = 0;
    }

    vm.listarClientes();
    vm.listarProdutos();
    vm.listarServicos();

    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;

      vm.consultar();
    }
    else
    {
      vm.isUpdate = false;
      vm.registro.situacaoPagamento = 1;
      vm.registro.formaPagamento = 0;

      vm.registro.dataVenda = new Date();
    }
  }

  vm.selecionarCliente = function()
  {
    if (!vm.isUpdate)
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/venda/cadastrar/modal/cliente/index.html',
        controller: 'VendaCadastroSelecionarClienteController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
      }).result.then(function(data){
        vm.registro.cliente = data;
      });
    }
  }

  vm.selecionarProdutoModal = function()
  {    
    var modalInstance = $uibModal.open({
      templateUrl: 'app/venda/cadastrar/modal/produto/index.html',
      controller: 'VendaCadastroSelecionarProdutoController',
      controllerAs: 'controller',
      windowClass: 'inmodal',
      size: 'lg',
    }).result.then(function(data){
      vm.produto = null;
      if (data != null)
      {
        vm.produto = data;
        vm.valorProduto = vm.produto.valorUnitarioTexto;
      }      
    });
  }

  vm.selecionarServicoModal = function()
  {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/venda/cadastrar/modal/servico/index.html',
      controller: 'VendaCadastroSelecionarServicoController',
      controllerAs: 'controller',
      windowClass: 'inmodal',
      size: 'lg',
    }).result.then(function(data){
      vm.servico = null;
      if (data != null)
      {
        vm.servico = data;
        vm.valorServico = vm.servico.valorUnitarioTexto;
      }      
    });
  }

  vm.adicionarPagamento = function()
  {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/venda/cadastrar/modal/addpagamento/index.html',
      controller: 'VendaAddPagamentoController',
      controllerAs: 'controller',
      windowClass: 'inmodal',
      //backdrop: false,
      size: 'lg',
      resolve: {
        venda: function () {
            return vm.registro;
        },
      }
    }).result.then(function(data){
      if (data)
      {
        vm.consultar();
      }
    });
  }

  vm.editarPagamento = function(p)
  {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/venda/cadastrar/modal/pagamento/index.html',
      controller: 'VendaPagamentoController',
      controllerAs: 'controller',
      windowClass: 'inmodal',      
      //backdrop: false,
      size: 'lg',
      resolve: {
        pagamento: function () {
            return p;
        },
      }
    }).result.then(function(data){
      if (data)
      {
        vm.consultar();
      }
    });
  }

  vm.removerPagamento = function(p)
  {
    if (confirm('Deseja realmente excluir o pagamento?'))
    {
      vm.salvarPromise = $http.delete(APP_ROOT + "/venda/excluirpagamento/" + p.viewId).success(function(response){           
        toastr.info('Registro excluído com sucesso.', 'Alerta');
        vm.consultar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.visualizarRecibo = function()
  {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/venda/cadastrar/recibo/index.html',
      controller: 'ReciboDocumentoController',
      controllerAs: 'controller',
      windowClass: 'inmodal',
      //backdrop: false,
      size: 'lg',
      resolve: {
        viewId: function () {
            return vm.registroViewId;
        },
      }
    }).result.then(function(data){
    });
  }

  vm.salvar = function()
  {
    var registro = vm.registro;    

    if (registro.cliente == null || registro.cliente.nome == null)
    {
      toastr.error('Favor selecionar um cliente.', 'Alerta');
      return;
    }

    if (vm.registro.produtos.length <= 0 && vm.registro.servicos.length <= 0)
    {
      toastr.error('Não foram adicionados produtos ou serviços.', 'Alerta');
      return;
    }

    vm.registro.valorAdicional = parseFloat(vm.registro.valorAdicional.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
    vm.registro.valorDesconto = parseFloat(vm.registro.valorDesconto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
    //vm.registro.valorTotal = parseFloat(vm.registro.valorTotal.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));

    if (!vm.isUpdate)
    {
      registro.tipoVenda = vm.tipo;
      
      vm.salvarPromise = $http.post(APP_ROOT + "/venda/registrar", registro).success(function(response){   
        
        vm.registroViewId = response.viewId;
        vm.isUpdate = true;

        toastr.info(vm.titulo + ' registrada com sucesso.', 'Alerta');
        $state.go('index.venda_pesquisar', {tipo: vm.tipo});

        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }    
    else
    {

      vm.salvarPromise = $http.put(APP_ROOT + "/venda", registro).success(function(response){        
        toastr.info(vm.titulo + ' atualizada com sucesso.', 'Alerta');        
        $state.go('index.venda_pesquisar', {tipo: vm.tipo});
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/venda/" + vm.registroViewId)
    .then(function(response)
    {           
      vm.registro = response.data;
      //vm.registro.valorAdicional = vm.registro.valorAdicional.toFixed(2);
      //vm.registro.valorDesconto = vm.registro.valorDesconto.toFixed(2);

      vm.registro.valorAdicional = $filter('currency')(vm.registro.valorAdicional.toFixed(2), '', 2);
      vm.registro.valorDesconto = $filter('currency')(vm.registro.valorDesconto.toFixed(2), '', 2);
      
      vm.tipo = vm.registro.tipoVenda;

      if (vm.registro.dataVenda != null)
      {
        vm.registro.dataVenda = new Date(vm.registro.dataVenda);

        vm.calcular();
      }

      vm.listarPagamentos();
    });
  }

  vm.listarClientes = function()
  {
    vm.consultarClientePromise = $http.get(APP_ROOT + "/cliente")
    .then(function(response)
    {            
      vm.clientes = response.data;

      /*
      if (!vm.isUpdate && vm.clientes.length > 0)
      {
        vm.registro.cliente = {
          viewId : vm.clientes[0].viewId
        };
      }
      */
    });
  }

  vm.selecionarProduto = function()
  {
    if (vm.produto != null)
    {         
      vm.valorProduto = vm.produto.valorUnitarioTexto;
    }
  }

  vm.selecionarServico = function()
  {
    if (vm.servico != null)
    {         
      vm.valorServico = vm.servico.valorUnitarioTexto;
    }
  }

  vm.listarProdutos = function()
  {
    vm.consultarProdutoPromise = $http.get(APP_ROOT + "/produto")
    .then(function(response)
    {           
      vm.produtos = response.data;
    });
  }

  vm.listarServicos = function()
  {
    vm.consultarServicoPromise = $http.get(APP_ROOT + "/servico")
    .then(function(response)
    {           
      vm.servicos = response.data;
    });
  }

  vm.listarPagamentos = function()
  {
    vm.consultarPagamentosPromise = $http.get(APP_ROOT + "/venda/pagamento/" + vm.registroViewId)
    .then(function(response)
    {           
      vm.pagamentos = response.data;
    });
  }

  vm.adicionarProduto = function()
  {
    if (vm.produto == null)
    {
      toastr.error('Selecione um produto.', 'Alerta');
      return;
    }

    if (vm.quantidadeProduto <= 0)
    {
      toastr.error('Informe a quantidade do produto.', 'Alerta');
      return;
    }

    var valorProduto = parseFloat(vm.valorProduto.toString().replaceAll('R$','').replaceAll('.','').replaceAll(',','.'));

    if (vm.produto != null && vm.produto.viewId != null)
    {
      for(var indice in vm.registro.produtos){
        if(vm.registro.produtos[indice].viewId == vm.produto.viewId)
        {
          toastr.error('Produto já adicionado.', 'Alerta');
          return;
        }
      }

      var novoProduto = 
      {
        viewId : vm.produto.viewId,
        nome : vm.produto.nome,
        valorUnitario : valorProduto,
        quantidade : vm.quantidadeProduto
      }

      vm.registro.produtos.push(novoProduto);
      
      //vm.valorProduto = 'R$0,00';
      vm.quantidadeProduto = 1;
    }
    else
    {
      toastr.error('Selecione um produto', 'Alerta');
    }

    vm.calcular();
  }

  vm.adicionarServico = function()
  {
    if (vm.servico == null)
    {
      toastr.error('Selecione um serviço.', 'Alerta');
      return;
    }

    if (vm.quantidadeServico <= 0)
    {
      toastr.error('Informe a quantidade do serviço.', 'Alerta');
      return;
    }

    var valorServico = parseFloat(vm.valorServico.toString().replaceAll('R$','').replaceAll('.','').replaceAll(',','.'));

    if (vm.servico != null && vm.servico.viewId != null)
    {
      for(var indice in vm.registro.servicos){
        if(vm.registro.servicos[indice].viewId == vm.servico.viewId)
        {
          toastr.error('Serviço já adicionado.', 'Alerta');
          return;
        }
      }

      var novoServico = 
      {
        viewId : vm.servico.viewId,
        nome : vm.servico.nome,
        valorUnitario : valorServico,
        quantidade : vm.quantidadeServico
      }

      vm.registro.servicos.push(novoServico);

      //vm.valorServico = 'R$0,00';
      vm.quantidadeServico = 1;
    }
    else
    {
      toastr.error('Selecione um serviço', 'Alerta');
    }

    vm.calcular();
  }

  vm.removerProduto = function(registro)
  {
    for(var indice in vm.registro.produtos){
      if(vm.registro.produtos[indice].viewId == registro.viewId)
      {
        vm.registro.produtos.splice(indice, 1);
      }
    }
    vm.calcular();
  }

  vm.removerServico = function(registro)
  {
    for(var indice in vm.registro.servicos){
      if(vm.registro.servicos[indice].viewId == registro.viewId)
      {
        vm.registro.servicos.splice(indice, 1);
      }
    }
    vm.calcular();
  }

  vm.excluir = function()
  {
    if (confirm('Deseja realmente excluir este registro?'))
    {
      vm.excluirPromise = $http.delete(APP_ROOT + "/venda/" + vm.registro.viewId).success(function(response){        
        toastr.info('Solicitação excluída com sucesso.', 'Alerta');      
        $state.go('index.venda_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.calcular = function()
  {
    // Calcular produtos
    var totalProdutos = 0;
    for(var indice in vm.registro.produtos){
      totalProdutos = totalProdutos + (vm.registro.produtos[indice].valorUnitario * vm.registro.produtos[indice].quantidade);
    }

    // Calcular servicos
    var totalServicos = 0;
    for(var indice in vm.registro.servicos){
      totalServicos = totalServicos + (vm.registro.servicos[indice].valorUnitario * vm.registro.servicos[indice].quantidade);
    }

    vm.registro.valorTotal =  (parseFloat(vm.registro.valorAdicional.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.')) + totalProdutos + totalServicos) - parseFloat(vm.registro.valorDesconto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('EsqueciSenhaController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_ROOT', '$compile',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_ROOT, $compile)
  {
    var vm = this;
    vm.registro = {};

    vm.init = function()
    {
    }

    vm.enviar = function()
    {
      if (vm.registro.login == null || vm.registro.login == '')
      {
        alert('Informe o seu e-mail de cadastro.');
        return;
      }

      vm.enviarPromise = $http.post(APP_ROOT + "/esquecisenha/reset", vm.registro).success(function(response){        
        toastr.info('Registro enviado com sucesso.', 'Alerta');
        $uibModalInstance.close();
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('TarefaPesquisarController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;
    vm.filtro = {
      objetivo : null
    };

    vm.init = function()
    {
      vm.listarObjetivos();
    }

    vm.pesquisar = function()
    {
      vm.registros = null;
        
      vm.registrosPromise = $http.get(APP_ROOT + "/tarefa/projeto/" + vm.filtro.projeto.viewId)
      .then(function(response)
      { 
          //vm.registrosOriginal = response.data;
          vm.registros = response.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
      });
    }

    vm.listarObjetivos = function()
    {
      vm.objetivosPromise =  $http.get(APP_ROOT + "/objetivo");

      vm.objetivosPromise.then(function(result) {  
        vm.objetivos = result.data; 
        vm.filtro.objetivo = vm.objetivos[0];

        vm.listarProjetos();
      });
    }

    vm.listarProjetos = function()
    {
      vm.projetosPromise =  $http.get(APP_ROOT + "/projeto/objetivo/" + vm.filtro.objetivo.viewId);

      vm.projetosPromise.then(function(result) {  
        vm.projetos = result.data; 
        vm.filtro.projeto = vm.projetos[0];

        vm.pesquisar();
      });
    }

    vm.incluir = function()
    {
      $state.go('index.tarefa_cadastrar');
    }

    vm.visualizar = function(p)
    {      
      $state.go('index.tarefa_cadastrar', {viewId: p.viewId});
    }

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('TarefaCadastrarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'UsuarioService',
      function($scope, $state, toastr, $http, APP_ROOT, UsuarioService)
{
  var vm = this;

  vm.registro = {
    arquivos: []
  };
  vm.registroViewId = $state.params.viewId;  
  vm.filesBinary = [];
  vm.isUpdate = false;

  vm.init = function()
  {    
    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;

      vm.consultar();
    }
    else
    {
      vm.isUpdate = false;

      vm.registro.dataInicio = new Date();
    }

    vm.listarUsuarios();
    vm.listarProjetos();
  }

  vm.salvar = function()
  {
    if (!vm.isUpdate)
    {
      vm.salvarPromise = $http.post(APP_ROOT + "/tarefa", vm.registro).success(function(response){   
        
        vm.registroViewId = response.viewId;
        vm.isUpdate = true;

        toastr.info('Tarefa cadastrado com sucesso.', 'Alerta');
        vm.consultar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }    
    else
    {
      vm.salvarPromise = $http.put(APP_ROOT + "/tarefa", vm.registro).success(function(response){        
        toastr.info('Tarefa atualizado com sucesso.', 'Alerta');
        vm.consultar();
        //$state.go('index.pesquisaratendimento');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.finalizarTarefa = function()
  {
    if (confirm('Deseja realmente finalizar a tarefa?'))
    {
      vm.salvarPromise = $http.put(APP_ROOT + "/tarefa/finalizartarefa", vm.registro).success(function(response){        
        toastr.info('Tarefa finalizada com sucesso.', 'Alerta');
        vm.consultar();
        //$state.go('index.pesquisaratendimento');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/tarefa/" + vm.registroViewId)
    .then(function(response)
    {           
      if (response.data == null || response.data == '')
      {
        $state.go('index.tarefa_pesquisar');
      }
      else
      {
        vm.registro = response.data;

        vm.listarTarefas();
      }
    });
  }

  vm.listarUsuarios = function()
  {
    vm.usuariosPromise = UsuarioService.getAll()

    vm.usuariosPromise.then(function(result) {  
      vm.usuarios = result; 
      vm.registro.usuarioResponsavel = vm.usuarios[0];
    });
  }

  vm.listarTarefas = function()
  {
    if (vm.registro.projeto != null)
    {
      vm.tarefasPromise =  $http.get(APP_ROOT + "/tarefa/projeto/" + vm.registro.projeto.viewId);

      vm.tarefasPromise.then(function(result) {  

        vm.tarefas = result.data.filter(function( obj ) {
          return obj.id !== vm.registro.id;
        });

      });
    }
  }

  vm.selecionarProjeto = function()
  {
    vm.registro.predecessora = null;

    vm.listarTarefas();
  }

  vm.listarProjetos = function()
  {
    vm.projetosPromise =  $http.get(APP_ROOT + "/projeto");

    vm.projetosPromise.then(function(result) {  
      vm.projetos = result.data; 

      if (vm.registro.projeto != null)
      {
        vm.registro.projeto = vm.registro.projeto;
      }
      else
      {
        vm.registro.projeto = vm.projetos[0];
      }      

      vm.listarTarefas();
    });
  }

  vm.excluir = function()
  {
    if (confirm('Deseja realmente excluir a tarefa?'))
    {
      vm.salvarPromise = $http.delete(APP_ROOT + "/tarefa/" + vm.registro.viewId).success(function(response){        
        toastr.info('Tarefa excluída com sucesso.', 'Alerta');
        //vm.consultar();
        $state.go('index.tarefa_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.downloadFile = function(p)
  {
    vm.arquivoPromise = $http.get(APP_ROOT + "/arquivo/" + p.viewId)
    .then(function(response)
    {
      vm.download(response.data.base64, response.data.tipo, response.data.nome);
    });
  }

  vm.download = function(dados, tipo, nome)
  {
    var file = vm.b64toBlob(dados, tipo);

    var fileURL = URL.createObjectURL(file);
    var a = document.createElement('a');
    a.href = fileURL;
    a.target = '_blank';
    a.download = nome;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a); 
  }

  vm.b64toBlob = function (b64Data, contentType) {
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    var sliceSize = 512
    
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
    
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
        }
    
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }
  
  function getBase64(file, onLoadCallback) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
  }

  $scope.uploadFile = function(files) {
        
    if (files.length > 0)
    {
      vm.uploadPromise = getBase64(files[0]);

      vm.filesBinary.push(files[0]);

      vm.uploadPromise.then(function(result) {

        var arquivo = vm.filesBinary[vm.filesBinary.length-1];

        vm.registro.arquivos.push(
          { 
            nome: arquivo.name,
            base64: result, 
            typeFile: arquivo.type,
            lengthFile: arquivo.size,
            tipo: arquivo.type.indexOf('image') >= 0 ? 'img' : 'doc' 
          }
        );
      });

      toastr.success("Arquivo enviado com sucesso.", 'Upload');
    }
  };

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('ServicoCadastrarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT','$uibModal', '$filter',
      function($scope, $state, toastr, $http, APP_ROOT, $uibModal, $filter)
{
  var vm = this;

  vm.registro = {};
  vm.registroViewId = $state.params.viewId;    
  vm.isUpdate = false;

  vm.init = function()
  {    
    vm.check();
    
    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;

      vm.consultar();
    }
    else
    {
      vm.isUpdate = false;
    }
  }

  vm.check = function()
    {      
      vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/restricaoprodutoservico")
      .then(function(response)
      { 
        if (response.data)
        {
          toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
          $state.go('index.main');
        }
      });
    }

  vm.salvar = function()
  {
    if (vm.registro.nome == null || vm.registro.nome == '')
    {
      toastr.error('Nome é obrigatório.', 'Alerta');
      return;
    }

    vm.registro.valorUnitario = parseFloat(vm.registro.valorUnitario.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));

    if (!vm.isUpdate)
    {
      vm.salvarPromise = $http.post(APP_ROOT + "/servico", vm.registro).success(function(response){   
        
        vm.registroViewId = response.viewId;
        vm.isUpdate = true;

        toastr.info('Serviço cadastrado com sucesso.', 'Alerta');
        $state.go('index.servico_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }    
    else
    {
      vm.salvarPromise = $http.put(APP_ROOT + "/servico/" + vm.registroViewId, vm.registro).success(function(response){        
        toastr.info('Serviço atualizado com sucesso.', 'Alerta');        
        $state.go('index.servico_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/servico/" + vm.registroViewId)
    .then(function(response)
    {           
      vm.registro = response.data;
      //vm.registro.valorUnitario = vm.registro.valorUnitario.toFixed(2);

      vm.registro.valorUnitario = $filter('currency')(vm.registro.valorUnitario.toFixed(2), '', 2);
    });
  }

  vm.excluir = function()
  {
    if (confirm('Deseja realmente excluir este registro?'))
    {
      vm.excluirPromise = $http.delete(APP_ROOT + "/servico/" + vm.registro.viewId).success(function(response){        
        toastr.info('Serviço excluído com sucesso.', 'Alerta');      
        $state.go('index.servico_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('ServicoPesquisarController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
      vm.check();
      
      vm.registros = null;
      vm.registrosOriginal = null;
        
      vm.registrosPromise = $http.get(APP_ROOT + "/servico")
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
      });
    }

    vm.check = function()
    {      
      vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/restricaoprodutoservico")
      .then(function(response)
      { 
        if (response.data)
        {
          toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
          $state.go('index.main');
        }
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.incluir = function()
    {
      $state.go('index.servico_cadastrar');
    }

    vm.visualizar = function(p)
    {      
      $state.go('index.servico_cadastrar', {viewId: p.viewId});
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('RelatorioVendasController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService', 'Excel', '$timeout',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService, Excel, $timeout)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;
    vm.tipo = $state.params.tipo;
    vm.titulo = '';
    vm.filtro = {tipo: '0'};
    vm.anoFiltro = '2022';
    vm.mesFiltro = (new Date().getMonth() + 1).toString();

    vm.init = function()
    {
      vm.pesquisar();
    }

    vm.pesquisar = function()
    {
      vm.check();

      vm.registros = null;
      vm.registrosOriginal = null;              

      vm.consultaPromise = $http.get(APP_ROOT + "/venda/relatorio/vendas/" + vm.anoFiltro + '/' + vm.mesFiltro)
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;

          vm.filtrarPesquisa();
          /*
          vm.pager.totalPages = 1;
          vm.setPage(1);
          */
      });
    }

    vm.check = function()
    {      
      vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/admin")
      .then(function(response)
      { 
        if (!response.data)
        {
          toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
          $state.go('index.main');
        }
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.numero != null && vm.filtro.numero != '')
            {
                if (!vm.registrosOriginal[i].numero.toUpperCase().includes(vm.filtro.numero.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cliente != null && vm.filtro.cliente != '')
            {
                if (!vm.registrosOriginal[i].cliente.nome.toUpperCase().includes(vm.filtro.cliente.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.usuario != null && vm.filtro.usuario != '')
            {
                if (!vm.registrosOriginal[i].usuarioCadastro.nome.toUpperCase().includes(vm.filtro.usuario.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.tipo != null && vm.filtro.tipo != '-1')
            {
                if (!vm.registrosOriginal[i].tipoVenda.toString().includes(vm.filtro.tipo))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        //vm.pager.totalPages = 1;
        //vm.setPage(1);
    }

    $scope.exportToExcel=function(tableId){
      var exportHref=Excel.tableToExcel(tableId,'WireWorkbenchDataExport');
      $timeout(function(){location.href=exportHref;},100); // trigger download
    }


    vm.incluir = function()
    {
      $state.go('index.venda_cadastrar');
    }

    vm.visualizar = function(p)
    {      
      if (p.registroAntigo == 2)
      {
        $state.go('index.orcamento_imprimir', {viewId: p.viewId});
      }
      else if (p.registroAntigo == 1)
      {
        $state.go('index.pedido_imprimir', {viewId: p.viewId});
      }
      else
      {
        $state.go('index.venda_imprimir', {viewId: p.viewId});
      }
    }

    vm.alterar = function(p)
    {      
      if (p.registroAntigo == 2)
      {
        $state.go('index.orcamento_cadastrar', {viewId: p.viewId});
      }
      else if (p.registroAntigo == 1)
      {
        $state.go('index.pedido_cadastrar', {viewId: p.viewId});
      }
      else
      {
        $state.go('index.venda_cadastrar', {viewId: p.viewId});
      }
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('RelatorioVendasLucroController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService', 'Excel', '$timeout',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService, Excel, $timeout)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;
    vm.tipo = $state.params.tipo;
    vm.titulo = '';
    vm.filtro = {tipo: '0'};
    vm.anoFiltro = '2022';
    vm.mesFiltro = (new Date().getMonth() + 1).toString();

    vm.init = function()
    {
      vm.pesquisar();
    }

    vm.pesquisar = function()
    {
      vm.check();

      vm.registros = null;
      vm.registrosOriginal = null;              

      vm.consultaPromise = $http.get(APP_ROOT + "/venda/relatorio/vendasLucro/" + vm.anoFiltro + '/' + vm.mesFiltro)
      //vm.consultaPromise = $http.get(APP_ROOT + "/venda/relatorio/vendasLucro/" + vm.anoFiltro + '/' + vm.mesFiltro)
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;

          vm.filtrarPesquisa();
          /*
          vm.pager.totalPages = 1;
          vm.setPage(1);
          */
      });
    }

    vm.check = function()
    {      
      vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/admin")
      .then(function(response)
      { 
        if (!response.data)
        {
          toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
          $state.go('index.main');
        }
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.numero != null && vm.filtro.numero != '')
            {
                if (!vm.registrosOriginal[i].numero.toUpperCase().includes(vm.filtro.numero.toUpperCase()))
                {
                    incluir = false;
                }
            }

            /*
            if (vm.filtro.cliente != null && vm.filtro.cliente != '')
            {
                if (!vm.registrosOriginal[i].cliente.nome.toUpperCase().includes(vm.filtro.cliente.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.usuario != null && vm.filtro.usuario != '')
            {
                if (!vm.registrosOriginal[i].usuarioCadastro.nome.toUpperCase().includes(vm.filtro.usuario.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.tipo != null && vm.filtro.tipo != '-1')
            {
                if (!vm.registrosOriginal[i].tipoVenda.toString().includes(vm.filtro.tipo))
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        //vm.pager.totalPages = 1;
        //vm.setPage(1);
    }

    $scope.exportToExcel=function(tableId){
      var exportHref=Excel.tableToExcel(tableId,'WireWorkbenchDataExport');
      $timeout(function(){location.href=exportHref;},100); // trigger download
    }


    vm.incluir = function()
    {
      $state.go('index.venda_cadastrar');
    }

    vm.visualizar = function(p)
    {      
      if (p.registroAntigo == 2)
      {
        $state.go('index.orcamento_imprimir', {viewId: p.viewId});
      }
      else if (p.registroAntigo == 1)
      {
        $state.go('index.pedido_imprimir', {viewId: p.viewId});
      }
      else
      {
        $state.go('index.venda_imprimir', {viewId: p.viewId});
      }
    }

    vm.alterar = function(p)
    {      
      if (p.registroAntigo == 2)
      {
        $state.go('index.orcamento_cadastrar', {viewId: p.viewId});
      }
      else if (p.registroAntigo == 1)
      {
        $state.go('index.pedido_cadastrar', {viewId: p.viewId});
      }
      else
      {
        $state.go('index.venda_cadastrar', {viewId: p.viewId});
      }
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('RelatorioServicoVendasController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService', 'Excel', '$timeout',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService, Excel, $timeout)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;
    vm.tipo = $state.params.tipo;
    vm.titulo = '';
    vm.filtro = {tipo: '0'};
    vm.anoFiltro = '2022';
    vm.mesFiltro = (new Date().getMonth() + 1).toString();

    vm.init = function()
    {
      vm.pesquisar();
    }

    vm.pesquisar = function()
    {
      vm.check();

      vm.registros = null;
      vm.registrosOriginal = null;              

      vm.consultaPromise = $http.get(APP_ROOT + "/venda/relatorio/servicosVendas/" + vm.anoFiltro + '/' + vm.mesFiltro)
      
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;

          vm.filtrarPesquisa();
          /*
          vm.pager.totalPages = 1;
          vm.setPage(1);
          */
      });
    }

    vm.check = function()
    {      
      vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/admin")
      .then(function(response)
      { 
        if (!response.data)
        {
          toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
          $state.go('index.main');
        }
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.numero != null && vm.filtro.numero != '')
            {
                if (!vm.registrosOriginal[i].numero.toUpperCase().includes(vm.filtro.numero.toUpperCase()))
                {
                    incluir = false;
                }
            }

            /*
            if (vm.filtro.cliente != null && vm.filtro.cliente != '')
            {
                if (!vm.registrosOriginal[i].cliente.nome.toUpperCase().includes(vm.filtro.cliente.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.usuario != null && vm.filtro.usuario != '')
            {
                if (!vm.registrosOriginal[i].usuarioCadastro.nome.toUpperCase().includes(vm.filtro.usuario.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.tipo != null && vm.filtro.tipo != '-1')
            {
                if (!vm.registrosOriginal[i].tipoVenda.toString().includes(vm.filtro.tipo))
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        //vm.pager.totalPages = 1;
        //vm.setPage(1);
    }

    $scope.exportToExcel=function(tableId){
      var exportHref=Excel.tableToExcel(tableId,'WireWorkbenchDataExport');
      $timeout(function(){location.href=exportHref;},100); // trigger download
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('RelatorioProdutoVendasController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService', 'Excel', '$timeout',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService, Excel, $timeout)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;
    vm.tipo = $state.params.tipo;
    vm.titulo = '';
    vm.filtro = {tipo: '0'};
    vm.anoFiltro = '2022';
    vm.mesFiltro = (new Date().getMonth() + 1).toString();

    vm.init = function()
    {
      vm.pesquisar();
    }

    vm.pesquisar = function()
    {
      vm.check();

      vm.registros = null;
      vm.registrosOriginal = null;              

      vm.consultaPromise = $http.get(APP_ROOT + "/venda/relatorio/produtosVendas/" + vm.anoFiltro + '/' + vm.mesFiltro)
      
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;

          vm.filtrarPesquisa();
          /*
          vm.pager.totalPages = 1;
          vm.setPage(1);
          */
      });
    }

    vm.check = function()
    {      
      vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/admin")
      .then(function(response)
      { 
        if (!response.data)
        {
          toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
          $state.go('index.main');
        }
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.numero != null && vm.filtro.numero != '')
            {
                if (!vm.registrosOriginal[i].numero.toUpperCase().includes(vm.filtro.numero.toUpperCase()))
                {
                    incluir = false;
                }
            }

            /*
            if (vm.filtro.cliente != null && vm.filtro.cliente != '')
            {
                if (!vm.registrosOriginal[i].cliente.nome.toUpperCase().includes(vm.filtro.cliente.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.usuario != null && vm.filtro.usuario != '')
            {
                if (!vm.registrosOriginal[i].usuarioCadastro.nome.toUpperCase().includes(vm.filtro.usuario.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.tipo != null && vm.filtro.tipo != '-1')
            {
                if (!vm.registrosOriginal[i].tipoVenda.toString().includes(vm.filtro.tipo))
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        //vm.pager.totalPages = 1;
        //vm.setPage(1);
    }

    $scope.exportToExcel=function(tableId){
      var exportHref=Excel.tableToExcel(tableId,'WireWorkbenchDataExport');
      $timeout(function(){location.href=exportHref;},100); // trigger download
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('ProjetoPesquisarController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
      vm.registros = null;
        
      vm.registrosPromise = $http.get(APP_ROOT + "/projeto")
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.solicitacao != null && vm.filtro.solicitacao != '')
            {
                if (!vm.registrosOriginal[i].objetivo.nome.toUpperCase().includes(vm.filtro.solicitacao.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.responsavel != null && vm.filtro.responsavel != '')
            {
                if (!vm.registrosOriginal[i].usuarioResponsavel.nome.toUpperCase().includes(vm.filtro.responsavel.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.incluir = function()
    {
      $state.go('index.projeto_cadastrar');
    }

    vm.visualizar = function(p)
    {      
      $state.go('index.projeto_cadastrar', {viewId: p.viewId});
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('ProjetoCadastrarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'UsuarioService', '$uibModal',
      function($scope, $state, toastr, $http, APP_ROOT, UsuarioService, $uibModal)
{
  var vm = this;

  vm.registro = {
    arquivos: []
  };
  vm.registroViewId = $state.params.viewId;  
  vm.filesBinary = [];
  vm.isUpdate = false;

  vm.init = function()
  {    
    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;

      vm.consultar();
    }
    else
    {
      vm.isUpdate = false;

      vm.registro.dataInicio = new Date();      
    }

    vm.listarUsuarios();
    vm.listarObjetivos();
  }

  vm.salvar = function()
  {
    if (!vm.isUpdate)
    {
      vm.salvarPromise = $http.post(APP_ROOT + "/projeto", vm.registro).success(function(response){   
        
        vm.registroViewId = response.viewId;
        vm.isUpdate = true;

        toastr.info('Projeto cadastrado com sucesso.', 'Alerta');
        vm.consultar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }    
    else
    {
      vm.salvarPromise = $http.put(APP_ROOT + "/projeto", vm.registro).success(function(response){        
        toastr.info('Projeto atualizado com sucesso.', 'Alerta');
        vm.consultar();
        //$state.go('index.pesquisaratendimento');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.replicarProjeto = function()
  {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/projeto/modal/replicar/index.html',
      controller: 'ProjetoModalReplicarController',
      controllerAs: 'controller',
      windowClass: 'inmodal',
      size: 'lg',
      resolve: {
        projeto: function () {
            return vm.registro;
        },
    }
    }).result.then(function(data){
      vm.init();
    });
  }

  vm.adicionarTarefa = function()
  {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/tarefa/modal/cadastrar/index.html',
      controller: 'TarefaModalCadastrarController',
      controllerAs: 'controller',
      windowClass: 'inmodal',
      size: 'lg',
      resolve: {
        projeto: function () {
            return vm.registro;
        },
    }
    }).result.then(function(data){
      vm.init();
    });
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/projeto/" + vm.registroViewId)
    .then(function(response)
    {           
      if (response.data == null || response.data == '')
      {
        $state.go('index.projeto_pesquisar');
      }
      else
      {
        vm.registro = response.data;
      }
    });
  }

  vm.listarUsuarios = function()
  {
    vm.usuariosPromise = UsuarioService.getAll()

    vm.usuariosPromise.then(function(result) {  
      vm.usuarios = result; 
      vm.registro.usuarioResponsavel = vm.usuarios[0];
    });
  }

  vm.listarObjetivos = function()
  {
    vm.objetivosPromise =  $http.get(APP_ROOT + "/objetivo");

    vm.objetivosPromise.then(function(result) {  
      vm.objetivos = result.data; 
      vm.registro.objetivo = vm.objetivos[0];
    });
  }

  vm.excluir = function()
  {
    if (confirm('Deseja realmente excluir este registro?'))
    {
      vm.excluirPromise = $http.delete(APP_ROOT + "/projeto/" + vm.registro.viewId).success(function(response){        
        toastr.info('Projeto excluído com sucesso.', 'Alerta');      
        $state.go('index.projeto_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.downloadFile = function(p)
  {
    vm.arquivoPromise = $http.get(APP_ROOT + "/arquivo/" + p.viewId)
    .then(function(response)
    {
      vm.download(response.data.base64, response.data.tipo, response.data.nome);
    });
  }

  vm.download = function(dados, tipo, nome)
  {
    var file = vm.b64toBlob(dados, tipo);

    var fileURL = URL.createObjectURL(file);
    var a = document.createElement('a');
    a.href = fileURL;
    a.target = '_blank';
    a.download = nome;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a); 
  }

  vm.b64toBlob = function (b64Data, contentType) {
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    var sliceSize = 512
    
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
    
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
        }
    
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }
  
  function getBase64(file, onLoadCallback) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
  }

  $scope.uploadFile = function(files) {
        
    if (files.length > 0)
    {
      vm.uploadPromise = getBase64(files[0]);

      vm.filesBinary.push(files[0]);

      vm.uploadPromise.then(function(result) {

        var arquivo = vm.filesBinary[vm.filesBinary.length-1];

        vm.registro.arquivos.push(
          { 
            nome: arquivo.name,
            base64: result, 
            typeFile: arquivo.type,
            lengthFile: arquivo.size,
            tipo: arquivo.type.indexOf('image') >= 0 ? 'img' : 'doc' 
          }
        );
      });

      toastr.success("Arquivo enviado com sucesso.", 'Upload');
    }
  };

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('ProdutoPesquisarController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
      vm.check();

      vm.registros = null;
      vm.registrosOriginal = null;
        
      vm.registrosPromise = $http.get(APP_ROOT + "/produto")
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
      });
    }

    vm.check = function()
    {      
      vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/restricaoprodutoservico")
      .then(function(response)
      { 
        if (response.data)
        {
          toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
          $state.go('index.main');
        }
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.categoria != null && vm.filtro.categoria != '')
            {
                if (vm.registrosOriginal[i].categoria == null)
                {
                  incluir = false
                }
                else if (vm.registrosOriginal[i].categoria != null && !vm.registrosOriginal[i].categoria.nome.toUpperCase().includes(vm.filtro.categoria.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.incluir = function()
    {
      $state.go('index.produto_cadastrar');
    }

    vm.visualizar = function(p)
    {      
      $state.go('index.produto_cadastrar', {viewId: p.viewId});
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('ProdutoCategoriaPesquisarController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService', '$uibModal',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService, $uibModal)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
      vm.check();

      vm.registros = null;
      vm.registrosOriginal = null;
        
      vm.registrosPromise = $http.get(APP_ROOT + "/produtoCategoria")
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
      });
    }

    vm.check = function()
    {      
      vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/restricaoprodutoservico")
      .then(function(response)
      { 
        if (response.data)
        {
          toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
          $state.go('index.main');
        }
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.categoria != null && vm.filtro.categoria != '')
            {
                if (vm.registrosOriginal[i].categoria == null)
                {
                  incluir = false
                }
                else if (vm.registrosOriginal[i].categoria != null && !vm.registrosOriginal[i].categoria.nome.toUpperCase().includes(vm.filtro.categoria.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.incluir = function()
    {
      $state.go('index.produto_cadastrar');
    }

    vm.visualizar = function(p)
    {      
      var modalInstance = $uibModal.open({
        templateUrl: 'app/produto/categoria/cadastro/index.html',
        controller: 'ProdutoCategoriaCadastrarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        //backdrop: false,
        size: 'md',
        resolve: {
          categoria: function () {
              return p;
          },
        }
      }).result.then(function(data){
        vm.pesquisar();
      });
    }

    vm.excluir = function(p)
    { 
      if (confirm('Deseja excluir a categoria ' + p.nome + '?'))
      {
        vm.excluirPromise = $http.delete(APP_ROOT + "/produtoCategoria/" + p.viewId).success(function(response){        
          toastr.info('Categoria excluída com sucesso.', 'Alerta');      
          vm.pesquisar();
          return response;
        }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
        });
      }
    }

    vm.cadastrar = function()
    {      
      var modalInstance = $uibModal.open({
        templateUrl: 'app/produto/categoria/cadastro/index.html',
        controller: 'ProdutoCategoriaCadastrarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        //backdrop: false,
        size: 'md',
        resolve: {
          categoria: function () {
              return null;
          },
        }
      }).result.then(function(data){
        vm.pesquisar();
      });
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('PedidoPesquisarController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
      vm.registros = null;
      vm.registrosOriginal = null;
        
      vm.registrosPromise = $http.get(APP_ROOT + "/pedido/pesquisar/0")
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            
            if (vm.filtro.numero != null && vm.filtro.numero != '')
            {
                if (!vm.registrosOriginal[i].numero.toUpperCase().includes(vm.filtro.numero.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cliente != null && vm.filtro.cliente != '')
            {
                if (!vm.registrosOriginal[i].cliente.nome.toUpperCase().includes(vm.filtro.cliente.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.incluir = function()
    {
      $state.go('index.pedido_cadastrar');
    }

    vm.visualizar = function(p)
    {      
      $state.go('index.pedido_imprimir', {viewId: p.viewId});
    }

    vm.alterar = function(p)
    {      
      $state.go('index.pedido_cadastrar', {viewId: p.viewId});
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('ProdutoCadastrarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT','$uibModal', '$filter',
      function($scope, $state, toastr, $http, APP_ROOT, $uibModal, $filter)
{
  var vm = this;

  vm.registro = {};
  vm.registroViewId = $state.params.viewId;    
  vm.isUpdate = false;
  vm.foto = null;
  vm.filesBinary = [];
  vm.categoria = {};

  vm.init = function()
  {    
    vm.check();
    vm.listarCategorias();
    
    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;

      vm.consultar();
    }
    else
    {
      vm.isUpdate = false;
    }
  }

  vm.listarCategorias = function()
  {
    vm.consultarCategoriasPromise = $http.get(APP_ROOT + "/produtocategoria")
    .then(function(response)
    {           
      vm.categorias = response.data;
      /*
      if (vm.categorias.length > 0)
      {
        vm.categoria = vm.categorias[0];
      }
      */
    });
  }

  vm.check = function()
    {      
      vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/restricaoprodutoservico")
      .then(function(response)
      { 
        if (response.data)
        {
          toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
          $state.go('index.main');
        }
      });
    }

  vm.salvar = function()
  {
    if (vm.registro.nome == null || vm.registro.nome == '')
    {
      toastr.error('Nome é obrigatório.', 'Alerta');
      return;
    }

    if (vm.categoria.viewId == null)
    {
      vm.registro.categoria = null;
    }
    else
    {
      vm.categoria.nome = '.';
      vm.registro.categoria = vm.categoria;
    }    

    vm.registro.valorUnitario = parseFloat(vm.registro.valorUnitario.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
    vm.registro.valorCompra = parseFloat(vm.registro.valorCompra.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));

    if (!vm.isUpdate)
    {
      vm.salvarPromise = $http.post(APP_ROOT + "/produto", vm.registro).success(function(response){   
        
        vm.registroViewId = response.viewId;
        vm.isUpdate = true;

        toastr.info('Produto cadastrado com sucesso.', 'Alerta');
        $state.go('index.produto_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }    
    else
    {
      vm.salvarPromise = $http.put(APP_ROOT + "/produto/" + vm.registroViewId, vm.registro).success(function(response){        
        toastr.info('Produto atualizado com sucesso.', 'Alerta');        
        $state.go('index.produto_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/produto/" + vm.registroViewId)
    .then(function(response)
    {           
      vm.registro = response.data;
      //vm.registro.valorUnitario = vm.registro.valorUnitario.toFixed(2);
      vm.registro.valorUnitario = $filter('currency')(vm.registro.valorUnitario.toFixed(2), '', 2);

      //vm.registro.valorCompra = vm.registro.valorCompra.toFixed(2);
      vm.registro.valorCompra = $filter('currency')(vm.registro.valorCompra.toFixed(2), '', 2);

      if (vm.registro.categoria != null)
      {
        vm.categoria = vm.registro.categoria;
      }

      vm.foto = (APP_ROOT + "/catalogoweb/ConsultarProdutoFoto/" + vm.registro.viewId);
    });
  }

  vm.excluir = function()
  {
    if (confirm('Deseja realmente excluir este registro?'))
    {
      vm.excluirPromise = $http.delete(APP_ROOT + "/produto/" + vm.registro.viewId).success(function(response){        
        toastr.info('Produto excluído com sucesso.', 'Alerta');      
        $state.go('index.produto_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.estoqueCorrigir = function()
  {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/produto/estoque/corrigir/index.html',
      controller: 'ProdutoEstoqueCorrigirController',
      controllerAs: 'controller',
      windowClass: 'inmodal',
      //backdrop: false,
      size: 'md',
      resolve: {
        produto: function () {
            return vm.registro;
        },
      }
    }).result.then(function(data){
      if (data)
      {
        vm.consultar();
      }
    });
  }

  vm.estoqueRepor = function()
  {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/produto/estoque/repor/index.html',
      controller: 'ProdutoEstoqueReporController',
      controllerAs: 'controller',
      windowClass: 'inmodal',
      //backdrop: false,
      size: 'md',
      resolve: {
        produto: function () {
            return vm.registro;
        },
      }
    }).result.then(function(data){
      if (data)
      {
        vm.consultar();
      }
    });
  }

  vm.estoqueHistorico = function()
  {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/produto/estoque/historico/index.html',
      controller: 'ProdutoEstoqueHistoricoController',
      controllerAs: 'controller',
      windowClass: 'inmodal',
      //backdrop: false,
      size: 'md',
      resolve: {
        produto: function () {
            return vm.registro;
        },
      }
    }).result.then(function(data){
      if (data)
      {
        vm.consultar();
      }
    });
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

  $scope.uploadFile = function(files) {
        
    if (files.length > 0)
    {
      vm.uploadPromise = getBase64(files[0]);

      vm.filesBinary.push(files[0]);

      vm.uploadPromise.then(function(result) {

        var arquivo = vm.filesBinary[vm.filesBinary.length-1];

        //var logo = new ProdutoFoto();
        var logo = {
          base64 : result.split(',')[1],
          produtoViewId : vm.registro.viewId
        }

        vm.salvarFotoPromise = $http.put(APP_ROOT + "/produto/foto", logo).success(function(response){        
          toastr.info('Foto atualizada com sucesso.', 'Alerta');                  
          vm.foto = (APP_ROOT + "/catalogoweb/ConsultarProdutoFoto/" + vm.registro.viewId + "?id=" + + Math.random());
          return response;
        }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
        });

        /*
        vm.contato.foto =
        { 
          nome: arquivo.name,
          base64: result, 
          typeFile: arquivo.type,
          lengthFile: arquivo.size,
          tipo: arquivo.type.indexOf('image') >= 0 ? 'img' : 'doc' 
        }
        */
      });
    }
  };

  function getBase64(file, onLoadCallback) {
    return new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onload = function() { resolve(reader.result); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

}]);

'use strict';

angular.module('inspinia')
  .controller('PedidoImprimirController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'UsuarioService', '$uibModal', '$sce',
      function($scope, $state, toastr, $http, APP_ROOT, UsuarioService, $uibModal, $sce)
{
  var vm = this;
  vm.registroViewId = $state.params.viewId;    
  vm.isUpdate = false;

  vm.init = function()
  {    
    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;
      vm.arquivo =  $sce.trustAsResourceUrl(APP_ROOT + "/Pedido/GetDocumento/" + vm.registroViewId);
      //vm.consultar();
    }
    else
    {
      vm.isUpdate = false;
    }

    //vm.listarUsuarios();
  }


  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/Pedido/GetDocumento/" + vm.registroViewId)
    .then(function(response)
    {           
      vm.registro = response.data;
      var blob = new Blob([ response.data ], { type : 'application/pdf' });
      vm.arquivo = $sce.trustAsResourceUrl(URL.createObjectURL(blob));
    });
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('PedidoCadastrarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'UsuarioService', '$uibModal',
      function($scope, $state, toastr, $http, APP_ROOT, UsuarioService, $uibModal)
{
  var vm = this;

  vm.registro = {    
    produtos : [],
    servicos : []
  };
  vm.quantidadeProduto = 1;
  vm.quantidadeServico = 1;
  vm.registroViewId = $state.params.viewId;    
  vm.isUpdate = false;

  vm.init = function()
  {    
    vm.listarClientes();
    vm.listarProdutos();
    vm.listarServicos();

    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;

      vm.consultar();
    }
    else
    {
      vm.isUpdate = false;
      /*
      vm.registro.situacaoPagamento = 1;
      vm.registro.formaPagamento = 1;
      */

      vm.registro.dataPedido = new Date();
    }
  }

  vm.salvar = function()
  {
    var registro = vm.registro;

    vm.registro.valorAdicional = parseFloat(vm.registro.valorAdicional.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
    vm.registro.valorDesconto = parseFloat(vm.registro.valorDesconto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));    

    if (!vm.isUpdate)
    {
      vm.registro.pedidoTipo = 1;

      vm.salvarPromise = $http.post(APP_ROOT + "/pedido", registro).success(function(response){   
        
        vm.registroViewId = response.viewId;
        vm.isUpdate = true;
        toastr.info('Pedido registrado com sucesso.', 'Alerta');
        //$state.go('index.pedido_pesquisar');
        $state.go('index.venda_pesquisar', {tipo: 1});
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }    
    else
    {
      vm.salvarPromise = $http.put(APP_ROOT + "/pedido", registro).success(function(response){        
        toastr.info('Pedido atualizado com sucesso.', 'Alerta');        
        //$state.go('index.pedido_pesquisar');
        $state.go('index.venda_pesquisar', {tipo: 1});
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/pedido/" + vm.registroViewId)
    .then(function(response)
    {           
      vm.registro = response.data;
      //vm.registro.valorAdicional = vm.registro.valorAdicional.toFixed(2);
      //vm.registro.valorDesconto = vm.registro.valorDesconto.toFixed(2);

      vm.registro.valorAdicional = $filter('currency')(vm.registro.valorAdicional.toFixed(2), '', 2);
      vm.registro.valorDesconto = $filter('currency')(vm.registro.valorDesconto.toFixed(2), '', 2);

      if (vm.registro.dataPedido != null)
      {
        vm.registro.dataPedido = new Date(vm.registro.dataPedido);

        vm.calcular();
      }
    });
  }

  vm.listarClientes = function()
  {
    vm.consultarClientePromise = $http.get(APP_ROOT + "/cliente")
    .then(function(response)
    {            
      vm.clientes = response.data;

      if (!vm.isUpdate && vm.clientes.length > 0)
      {
        vm.registro.cliente = {
          viewId : vm.clientes[0].viewId
        };
      }
    });
  }

  vm.listarProdutos = function()
  {
    vm.consultarProdutoPromise = $http.get(APP_ROOT + "/produto")
    .then(function(response)
    {           
      vm.produtos = response.data;

      if (vm.produtos.length > 0)
      {
        vm.produto = vm.produtos[0];
      }
    });
  }

  vm.listarServicos = function()
  {
    vm.consultarServicoPromise = $http.get(APP_ROOT + "/servico")
    .then(function(response)
    {           
      vm.servicos = response.data;

      if (vm.servicos.length > 0)
      {
        vm.servico = vm.servicos[0];
      }
    });
  }

  vm.adicionarProduto = function()
  {
    if (vm.quantidadeProduto <= 0)
    {
      toastr.error('Informe a quantidade do produto.', 'Alerta');
      return;
    }

    if (vm.produto != null && vm.produto.viewId != null)
    {
      for(var indice in vm.registro.produtos){
        if(vm.registro.produtos[indice].viewId == vm.produto.viewId)
        {
          toastr.error('Produto já adicionado.', 'Alerta');
          return;
        }
      }

      var novoProduto = 
      {
        viewId : vm.produto.viewId,
        nome : vm.produto.nome,
        valorUnitario : vm.produto.valorUnitario,
        quantidade : vm.quantidadeProduto
      }

      vm.registro.produtos.push(novoProduto);
    }
    else
    {
      toastr.error('Selecione um produto', 'Alerta');
    }

    vm.calcular();
  }

  vm.adicionarServico = function()
  {
    if (vm.quantidadeServico <= 0)
    {
      toastr.error('Informe a quantidade do serviço.', 'Alerta');
      return;
    }

    if (vm.servico != null && vm.servico.viewId != null)
    {
      for(var indice in vm.registro.servicos){
        if(vm.registro.servicos[indice].viewId == vm.servico.viewId)
        {
          toastr.error('Serviço já adicionado.', 'Alerta');
          return;
        }
      }

      var novoServico = 
      {
        viewId : vm.servico.viewId,
        nome : vm.servico.nome,
        valorUnitario : vm.servico.valorUnitario,
        quantidade : vm.quantidadeServico
      }

      vm.registro.servicos.push(novoServico);
    }
    else
    {
      toastr.error('Selecione um serviço', 'Alerta');
    }

    vm.calcular();
  }

  vm.removerProduto = function(registro)
  {
    for(var indice in vm.registro.produtos){
      if(vm.registro.produtos[indice].viewId == registro.viewId)
      {
        vm.registro.produtos.splice(indice, 1);
      }
    }
    vm.calcular();
  }

  vm.removerServico = function(registro)
  {
    for(var indice in vm.registro.servicos){
      if(vm.registro.servicos[indice].viewId == registro.viewId)
      {
        vm.registro.servicos.splice(indice, 1);
      }
    }
    vm.calcular();
  }

  vm.excluir = function()
  {
    if (confirm('Deseja realmente excluir este registro?'))
    {
      vm.excluirPromise = $http.delete(APP_ROOT + "/pedido/" + vm.registro.viewId).success(function(response){        
        toastr.info('Solicitação excluída com sucesso.', 'Alerta');      
        $state.go('index.pedido_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.calcular = function()
  {
    // Calcular produtos
    var totalProdutos = 0;
    for(var indice in vm.registro.produtos){
      totalProdutos = totalProdutos + (vm.registro.produtos[indice].valorUnitario * vm.registro.produtos[indice].quantidade);
    }

    // Calcular servicos
    var totalServicos = 0;
    for(var indice in vm.registro.servicos){
      totalServicos = totalServicos + (vm.registro.servicos[indice].valorUnitario * vm.registro.servicos[indice].quantidade);
    }

    vm.registro.valorTotal =  (parseFloat(vm.registro.valorAdicional.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.')) + totalProdutos + totalServicos) - parseFloat(vm.registro.valorDesconto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('OrcamentoPesquisarController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
      vm.registros = null;
      vm.registrosOriginal = null;
        
      vm.registrosPromise = $http.get(APP_ROOT + "/Orcamento/pesquisar")
      //vm.registrosPromise = $http.get(APP_ROOT + "/venda/pesquisartipo/2/0")
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            
            if (vm.filtro.numero != null && vm.filtro.numero != '')
            {
                if (!vm.registrosOriginal[i].numero.toUpperCase().includes(vm.filtro.numero.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cliente != null && vm.filtro.cliente != '')
            {
                if (!vm.registrosOriginal[i].cliente.nome.toUpperCase().includes(vm.filtro.cliente.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.incluir = function()
    {
      $state.go('index.orcamento_cadastrar');
    }

    vm.visualizar = function(p)
    {      
      $state.go('index.orcamento_imprimir', {viewId: p.viewId});
    }

    vm.alterar = function(p)
    {      
      $state.go('index.orcamento_cadastrar', {viewId: p.viewId});
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('OrcamentoImprimirController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'UsuarioService', '$uibModal', '$sce',
      function($scope, $state, toastr, $http, APP_ROOT, UsuarioService, $uibModal, $sce)
{
  var vm = this;
  vm.registroViewId = $state.params.viewId;    
  vm.isUpdate = false;

  vm.init = function()
  {    
    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;
      vm.arquivo =  $sce.trustAsResourceUrl(APP_ROOT + "/Orcamento/GetDocumento/" + vm.registroViewId);
      //vm.consultar();
    }
    else
    {
      vm.isUpdate = false;
    }

    //vm.listarUsuarios();
  }


  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/Pedido/GetDocumento/" + vm.registroViewId)
    .then(function(response)
    {           
      vm.registro = response.data;
      var blob = new Blob([ response.data ], { type : 'application/pdf' });
      vm.arquivo = $sce.trustAsResourceUrl(URL.createObjectURL(blob));
    });
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('ObjetivoPesquisarController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
      vm.registros = null;
      vm.registrosOriginal = null;
        
      vm.registrosPromise = $http.get(APP_ROOT + "/objetivo")
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            /*
            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.incluir = function()
    {
      $state.go('index.objetivo_cadastrar');
    }

    vm.visualizar = function(p)
    {      
      $state.go('index.objetivo_cadastrar', {viewId: p.viewId});
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('OrcamentoCadastrarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'UsuarioService', '$uibModal',
      function($scope, $state, toastr, $http, APP_ROOT, UsuarioService, $uibModal)
{
  var vm = this;

  vm.registro = {    
    produtos : [],
    servicos : []
  };
  vm.quantidadeProduto = 1;
  vm.quantidadeServico = 1;
  vm.registroViewId = $state.params.viewId;    
  vm.isUpdate = false;

  vm.init = function()
  {    
    vm.listarClientes();
    vm.listarProdutos();
    vm.listarServicos();

    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;

      vm.consultar();
    }
    else
    {
      vm.isUpdate = false;
      /*
      vm.registro.situacaoPagamento = 1;
      vm.registro.formaPagamento = 1;
      */

      vm.registro.dataPedido = new Date();
    }
  }

  vm.salvar = function()
  {
    var registro = vm.registro;

    vm.registro.valorAdicional = parseFloat(vm.registro.valorAdicional.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
    vm.registro.valorDesconto = parseFloat(vm.registro.valorDesconto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));    

    if (!vm.isUpdate)
    {
      vm.registro.pedidoTipo = 2;

      vm.salvarPromise = $http.post(APP_ROOT + "/pedido", registro).success(function(response){   
        
        vm.registroViewId = response.viewId;
        vm.isUpdate = true;
        toastr.info('Orçamento registrado com sucesso.', 'Alerta');
        //$state.go('index.orcamento_pesquisar');
        $state.go('index.venda_pesquisar', {tipo: 2});
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }    
    else
    {
      vm.salvarPromise = $http.put(APP_ROOT + "/pedido", registro).success(function(response){        
        toastr.info('Orçamento atualizado com sucesso.', 'Alerta');        
        //$state.go('index.orcamento_pesquisar');
        $state.go('index.venda_pesquisar', {tipo: 2});
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/pedido/" + vm.registroViewId)
    .then(function(response)
    {           
      vm.registro = response.data;
      vm.registro.valorAdicional = vm.registro.valorAdicional.toFixed(2);
      vm.registro.valorDesconto = vm.registro.valorDesconto.toFixed(2);

      if (vm.registro.dataPedido != null)
      {
        vm.registro.dataPedido = new Date(vm.registro.dataPedido);

        vm.calcular();
      }
    });
  }

  vm.listarClientes = function()
  {
    vm.consultarClientePromise = $http.get(APP_ROOT + "/cliente")
    .then(function(response)
    {            
      vm.clientes = response.data;

      if (!vm.isUpdate && vm.clientes.length > 0)
      {
        vm.registro.cliente = {
          viewId : vm.clientes[0].viewId
        };
      }
    });
  }

  vm.listarProdutos = function()
  {
    vm.consultarProdutoPromise = $http.get(APP_ROOT + "/produto")
    .then(function(response)
    {           
      vm.produtos = response.data;

      if (vm.produtos.length > 0)
      {
        vm.produto = vm.produtos[0];
      }
    });
  }

  vm.listarServicos = function()
  {
    vm.consultarServicoPromise = $http.get(APP_ROOT + "/servico")
    .then(function(response)
    {           
      vm.servicos = response.data;

      if (vm.servicos.length > 0)
      {
        vm.servico = vm.servicos[0];
      }
    });
  }

  vm.adicionarProduto = function()
  {
    if (vm.quantidadeProduto <= 0)
    {
      toastr.error('Informe a quantidade do produto.', 'Alerta');
      return;
    }

    if (vm.produto != null && vm.produto.viewId != null)
    {
      for(var indice in vm.registro.produtos){
        if(vm.registro.produtos[indice].viewId == vm.produto.viewId)
        {
          toastr.error('Produto já adicionado.', 'Alerta');
          return;
        }
      }

      var novoProduto = 
      {
        viewId : vm.produto.viewId,
        nome : vm.produto.nome,
        valorUnitario : vm.produto.valorUnitario,
        quantidade : vm.quantidadeProduto
      }

      vm.registro.produtos.push(novoProduto);
    }
    else
    {
      toastr.error('Selecione um produto', 'Alerta');
    }

    vm.calcular();
  }

  vm.adicionarServico = function()
  {
    if (vm.quantidadeServico <= 0)
    {
      toastr.error('Informe a quantidade do serviço.', 'Alerta');
      return;
    }

    if (vm.servico != null && vm.servico.viewId != null)
    {
      for(var indice in vm.registro.servicos){
        if(vm.registro.servicos[indice].viewId == vm.servico.viewId)
        {
          toastr.error('Serviço já adicionado.', 'Alerta');
          return;
        }
      }

      var novoServico = 
      {
        viewId : vm.servico.viewId,
        nome : vm.servico.nome,
        valorUnitario : vm.servico.valorUnitario,
        quantidade : vm.quantidadeServico
      }

      vm.registro.servicos.push(novoServico);
    }
    else
    {
      toastr.error('Selecione um serviço', 'Alerta');
    }

    vm.calcular();
  }

  vm.removerProduto = function(registro)
  {
    for(var indice in vm.registro.produtos){
      if(vm.registro.produtos[indice].viewId == registro.viewId)
      {
        vm.registro.produtos.splice(indice, 1);
      }
    }
    vm.calcular();
  }

  vm.removerServico = function(registro)
  {
    for(var indice in vm.registro.servicos){
      if(vm.registro.servicos[indice].viewId == registro.viewId)
      {
        vm.registro.servicos.splice(indice, 1);
      }
    }
    vm.calcular();
  }

  vm.excluir = function()
  {
    if (confirm('Deseja realmente excluir este registro?'))
    {
      vm.excluirPromise = $http.delete(APP_ROOT + "/pedido/" + vm.registro.viewId).success(function(response){        
        toastr.info('Solicitação excluída com sucesso.', 'Alerta');      
        $state.go('index.pedido_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.calcular = function()
  {
    // Calcular produtos
    var totalProdutos = 0;
    for(var indice in vm.registro.produtos){
      totalProdutos = totalProdutos + (vm.registro.produtos[indice].valorUnitario * vm.registro.produtos[indice].quantidade);
    }

    // Calcular servicos
    var totalServicos = 0;
    for(var indice in vm.registro.servicos){
      totalServicos = totalServicos + (vm.registro.servicos[indice].valorUnitario * vm.registro.servicos[indice].quantidade);
    }

    vm.registro.valorTotal =  (parseFloat(vm.registro.valorAdicional.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.')) + totalProdutos + totalServicos) - parseFloat(vm.registro.valorDesconto.toString().replaceAll('R$','0').replaceAll('.','').replaceAll(',','.'));
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('ObjetivoCadastrarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'UsuarioService', '$uibModal',
      function($scope, $state, toastr, $http, APP_ROOT, UsuarioService, $uibModal)
{
  var vm = this;

  vm.registro = {
    tipo: 1,
    classificacao: 1,
    arquivos: []
  };
  vm.registroViewId = $state.params.viewId;  
  vm.filesBinary = [];
  vm.isUpdate = false;

  vm.init = function()
  {    
    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;

      vm.consultar();
    }
    else
    {
      vm.isUpdate = false;
    }

    //vm.listarUsuarios();
  }

  vm.salvar = function()
  {
    if (!vm.isUpdate)
    {
      vm.salvarPromise = $http.post(APP_ROOT + "/objetivo", vm.registro).success(function(response){   
        
        vm.registroViewId = response.viewId;
        vm.isUpdate = true;

        toastr.info('Solicitação cadastrada com sucesso.', 'Alerta');

        $state.go('index.objetivo_cadastrar', {viewId: vm.registroViewId});

        //vm.consultar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }    
    else
    {
      vm.salvarPromise = $http.put(APP_ROOT + "/objetivo", vm.registro).success(function(response){        
        toastr.info('Solicitação atualizada com sucesso.', 'Alerta');
        vm.consultar();
        //$state.go('index.pesquisaratendimento');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.adicionarProjeto = function()
  {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/projeto/modal/cadastrar/index.html',
      controller: 'ProjetoModalCadastrarController',
      controllerAs: 'controller',
      windowClass: 'inmodal',
      size: 'lg',
      resolve: {
        objetivo: function () {
            return vm.registro;
        },
    }
    }).result.then(function(data){
      vm.init();
    });
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/objetivo/" + vm.registroViewId)
    .then(function(response)
    {           
      if (response.data == null || response.data == '')
      {
        $state.go('index.objetivo_pesquisar');
      }
      else
      {
        vm.registro = response.data;
      }
    });
  }

  vm.arquivar = function()
  {
    if (confirm('Deseja realmente arquivar este registro?'))
    {
      vm.excluirPromise = $http.post(APP_ROOT + "/objetivo/arquivar/" + vm.registro.viewId).success(function(response){        
        toastr.info('Solicitação arquivada com sucesso.', 'Alerta');      
        $state.go('index.objetivo_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.excluir = function()
  {
    if (confirm('Deseja realmente excluir este registro?'))
    {
      vm.excluirPromise = $http.delete(APP_ROOT + "/objetivo/" + vm.registro.viewId).success(function(response){        
        toastr.info('Solicitação excluída com sucesso.', 'Alerta');      
        $state.go('index.objetivo_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.downloadFile = function(p)
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/arquivo/" + p.viewId)
    .then(function(response)
    {
      vm.download(response.data.base64, response.data.tipo, response.data.nome);
    });
  }

  vm.download = function(dados, tipo, nome)
  {
    var file = vm.b64toBlob(dados, tipo);

    var fileURL = URL.createObjectURL(file);
    var a = document.createElement('a');
    a.href = fileURL;
    a.target = '_blank';
    a.download = nome;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a); 
  }

  vm.b64toBlob = function (b64Data, contentType) {
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    var sliceSize = 512
    
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
    
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
        }
    
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }
  
  function getBase64(file, onLoadCallback) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
  }

  $scope.uploadFile = function(files) {
        
    if (files.length > 0)
    {
      vm.uploadPromise = getBase64(files[0]);

      vm.filesBinary.push(files[0]);

      vm.uploadPromise.then(function(result) {

        var arquivo = vm.filesBinary[vm.filesBinary.length-1];

        vm.registro.arquivos.push(
          { 
            nome: arquivo.name,
            base64: result, 
            typeFile: arquivo.type,
            lengthFile: arquivo.size,
            tipo: arquivo.type.indexOf('image') >= 0 ? 'img' : 'doc' 
          }
        );
      });

      toastr.success("Arquivo enviado com sucesso.", 'Upload');
    }
  };

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('MapaContatosController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'leafletData',
      function($scope, $state, $http, APP_ROOT, toastr, leafletData)
  {
    var vm = this;

    vm.init = function()
    {
      vm.initialMap();
    }

    vm.initialMap = function(ip) {
      $scope.mapProjects = {
        lat: global_latitude,
        lng: global_longitude,
        zoom: global_zoom_map
      };

      
      $scope.layers = {
        baselayers: {
            osm: {
              name: 'OpenStreetMap',
              type: 'xyz',
              url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
            }
        },
        overlays: {
          contatos: {
            name: "Contatos",
            type: "markercluster",
            visible: true
          },
        }
      }
        
      vm.contatosMapPromise = $http.get(APP_ROOT + "/contato/mapa")
      .then(function(response)
      {
          $scope.markers = [];

          angular.forEach(response.data, function(value, key){
            if (value.enderecoLatitude != null)
            {
              var m1 = {
                  layer: "contatos",
                  lat: parseFloat(value.enderecoLatitude),
                  lng: parseFloat(value.enderecoLongitude),
                  focus: false,
                  message: (
                    '<b>Nome:</b> ' + value.nome + '<br>' + 
                    '<b>Sexo:</b> ' + value.sexoDesc + '<br>' + 
                    '<b>Idade:</b> ' + value.idade + '<br>'
                  ),
                  draggable: false
              };
              $scope.markers.push(m1);
            }                                
          });
      });
    };

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('ContatoPesquisaController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    vm.filtro = {};
    vm.pager = {};
    vm.setPage = setPage;    

    vm.pesquisar = function()
    {
      vm.registros = null;
      vm.registrosOriginal = null;
        
      vm.listarPromise = $http.get(APP_ROOT + "/contato")
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;
          //vm.pager.totalPages = 1;
          //vm.setPage(1);
          vm.filtrarPesquisa();
      });
    }

    vm.incluir = function()
    {
      $state.go('index.cadastrarcontato');
    }

    vm.incluirAtendimento = function(contato)
    {
      $state.go('index.cadastraratendimento', {contato: contato});
    }

    vm.visualizar = function(contato)
    {
      $state.go('index.contato_cadastrar', {viewId: contato.viewId});
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
              if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
              {
                  incluir = false;
              }
            }

            if (vm.filtro.cpf != null && vm.filtro.cpf != '')
            {
              if (vm.registrosOriginal[i].cpf == null || !vm.registrosOriginal[i].cpf.includes(vm.filtro.cpf))
              {
                  incluir = false;
              }
            }

            if (vm.filtro.email != null && vm.filtro.email != '')
            {
              if (vm.registrosOriginal[i].email == null || !vm.registrosOriginal[i].email.toUpperCase().includes(vm.filtro.email.toUpperCase()))
              {
                  incluir = false;
              }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
        
        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('ContatoCadastroController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'CepService', 'GeocodeGoogleService',
      function($scope, $state, toastr, $http, APP_ROOT, CepService, GeocodeGoogleService)
{
    var vm = this;

    vm.contato = {};
    vm.contato.Sexo = "0";
    vm.filesBinary = [];
    vm.isUpdate = false;
    vm.contatoViewId = $state.params.viewId;

    $scope.myChannel = {
      // the fields below are all optional
      videoHeight: 180,
      videoWidth: 280,
      video: null // Will reference the video element on success
    };

    vm.init = function()
    {
      if (vm.contatoViewId == null)
      {
        vm.isUpdate = false;
      }
      else
      {
        vm.isUpdate = true;
        vm.consultar();
      }
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/contato/" + vm.contatoViewId)
      .then(function(response)
      { 
        vm.contato = response.data;

        vm.contato.dataNascimento = new Date(vm.contato.dataNascimento);
        vm.contato.sexo = vm.contato.sexo.toString();

        if (vm.contato.enderecoLatitude != null)
        {
          $scope.markers = [];
          var m1 = {
              lat: parseFloat(vm.contato.enderecoLatitude),
              lng: parseFloat(vm.contato.enderecoLongitude),
              focus: true,
              message: vm.contato.enderecoLogradouro + ", " + vm.contato.enderecoCidade + ", " + vm.contato.enderecoCidade,
              draggable: false
          };
          $scope.markers.push(m1);
        }
      });
    }

    vm.incluir = function()
    {
      if (vm.contato.enderecoLatitude != null)
      {
        vm.contato.enderecoLatitude = vm.contato.enderecoLatitude.toString();
        vm.contato.enderecoLongitude = vm.contato.enderecoLongitude.toString();
      }

      if (!vm.isUpdate)
      {
        if (vm.contato.foto != null)
        {
          vm.contato.foto.viewId = "00000000-0000-0000-0000-000000000000";
        }

        vm.salvarPromise = $http.post(APP_ROOT + "/contato", vm.contato).success(function(response){        
          toastr.info('Contato cadastrado com sucesso.', 'Alerta');
          $state.go('index.contato_pesquisar');
          return response;
        }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
        });
      }
      else
      {
        // TODO verificar se a foto foi alterada
        if (vm.contato.foto != null && vm.contato.foto.viewId == null)
        {
          vm.contato.foto.viewId = "00000000-0000-0000-0000-000000000000";
        }

        vm.salvarPromise = $http.put(APP_ROOT + "/contato", vm.contato).success(function(response){        
          toastr.info('Contato atualizado com sucesso.', 'Alerta');
          $state.go('index.contato_pesquisar');
          return response;
        }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
        });
      }
    }

    vm.consultarCep = function()
    {
      vm.contato.enderecoLogradouro = '';
      vm.contato.enderecoBairro = '';
      vm.contato.enderecoCidade = '';
      vm.contato.enderecoEstado = '';

      vm.cepPromise = CepService.get(vm.contato.enderecoCep);

      vm.cepPromise.then(function(result) {  
        if (result != null)
        {
          if (result.localidade == null)
          {
            toastr.error("CEP não encontrado.", 'Cep');
          }
          else
          {
            vm.contato.enderecoLogradouro = result.logradouro;
            vm.contato.enderecoBairro = result.bairro;
            vm.contato.enderecoCidade = result.localidade;
            vm.contato.enderecoEstado = result.uf;

            vm.GeocodePromise = GeocodeGoogleService.get(vm.contato.enderecoCep)

            vm.GeocodePromise.then(function(result2) {  
              if (result2 != null)
              {
                if (result2.results.length > 0)
                {
                  vm.contato.enderecoLatitude = result2.results[0].geometry.location.lat; 
                  vm.contato.enderecoLongitude = result2.results[0].geometry.location.lng;   
                  
                  $scope.markers = [];

                  var m1 = {
                      lat: parseFloat(result2.results[0].geometry.location.lat),
                      lng: parseFloat(result2.results[0].geometry.location.lng),
                      focus: true,
                      message: vm.contato.enderecoLogradouro + ", " + vm.contato.enderecoCidade + ", " + vm.contato.enderecoCidade,
                      draggable: false
                  };
                  $scope.markers.push(m1);
                }
              }
              else
              {
                toastr.error("Erro na consulta da latitude/longitude", 'Maps');
              }
            });
          }
        }
        else
        {
          toastr.error("Erro na consulta de CEP", 'Cep');
        }
      });
    }

    vm.initialMap = function() {
      $scope.mapProjects = {
          lat: global_latitude,
          lng: global_longitude,
          zoom: global_zoom_map
      };
    }; 

    vm.initialMap();

    $scope.uploadFile = function(files) {
        
      if (files.length > 0)
      {
        vm.uploadPromise = getBase64(files[0]);
  
        vm.filesBinary.push(files[0]);
  
        vm.uploadPromise.then(function(result) {
  
          var arquivo = vm.filesBinary[vm.filesBinary.length-1];
  
          vm.contato.foto =
          { 
            nome: arquivo.name,
            base64: result, 
            typeFile: arquivo.type,
            lengthFile: arquivo.size,
            tipo: arquivo.type.indexOf('image') >= 0 ? 'img' : 'doc' 
          }
        });
  
        toastr.success("Arquivo enviado com sucesso.", 'Upload');
      }
    };

    vm.init();

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

    function getBase64(file, onLoadCallback) {
      return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }



    var _video = null,
        patData = null;
    $scope.channel = {};
    $scope.webcamError = false;
    $scope.onError = function (err) {
        $scope.$apply(
            function() {
                $scope.webcamError = err;
            }
        );
    };
    $scope.showDemos = false;
    $scope.edgeDetection = false;
    $scope.mono = false;
    $scope.invert = false;
    $scope.patOpts = {x: 0, y: 0, w: 25, h: 25};

    $scope.onSuccess = function () {
      // The video element contains the captured camera data
      _video = $scope.channel.video;
      $scope.$apply(function() {
          $scope.patOpts.w = _video.width;
          $scope.patOpts.h = _video.height;
          $scope.showDemos = true;
      });
    };
    $scope.onStream = function (stream) {
      // You could do something manually with the stream.
    };

    $scope.makeSnapshot = function makeSnapshot() {
      if (_video) {
          var patCanvas = document.querySelector('#snapshot');
          if (!patCanvas) return;

          patCanvas.width = _video.width;
          patCanvas.height = _video.height;
          var ctxPat = patCanvas.getContext('2d');

          var idata = getVideoData(0, 0, 320, 240);
          ctxPat.putImageData(idata, 0, 0);

          sendSnapshotToServer(patCanvas.toDataURL());

          patData = idata;
      }
  };
  $scope.downloadSnapshot = function downloadSnapshot(dataURL) {
    window.location.href = dataURL;
  };

  var getVideoData = function getVideoData(x, y, w, h) {
      var hiddenCanvas = document.createElement('canvas');
      hiddenCanvas.width = _video.width;
      hiddenCanvas.height = _video.height;
      var ctx = hiddenCanvas.getContext('2d');
      ctx.drawImage(_video, 0, 0, _video.width, _video.height);
      return ctx.getImageData(x, y, w, h);
  };

  var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
    $scope.snapshotData = imgBase64;
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioPesquisarController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
      vm.registros = null;
      vm.registrosOriginal = null;
        
      vm.registrosPromise = $http.get(APP_ROOT + "/usuario/usuarios")
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }
            /*
            if (vm.filtro.celular != null && vm.filtro.celular != '')
            {
                if (!vm.registrosOriginal[i].celular.toUpperCase().includes(vm.filtro.celular.toUpperCase()))
                {
                    incluir = false;
                }
            }
            if (vm.filtro.email != null && vm.filtro.email != '')
            {
                if (!vm.registrosOriginal[i].email.toUpperCase().includes(vm.filtro.email.toUpperCase()))
                {
                    incluir = false;
                }
            }
            */
            if (vm.filtro.cpf != null && vm.filtro.cpf != '')
            {
                if (vm.registrosOriginal[i].cpf == null || !vm.registrosOriginal[i].cpf.toUpperCase().includes(vm.filtro.cpf.toUpperCase()))
                {
                    incluir = false;
                }
            }
            /*
            /*
            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.incluir = function()
    {
      $state.go('index.cliente_cadastrar');
    }

    vm.editar = function(p)
    {      
        alert('Edição de usuário é permitida apenas no aplicativo móvel do administrador.');
        //$state.go('index.cliente_cadastrar', {viewId: p.viewId});
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('LogoAtualizarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT','$uibModal', '$filter',
      function($scope, $state, toastr, $http, APP_ROOT, $uibModal, $filter)
{
  var vm = this;

  vm.registro = {};
  vm.filesBinary = [];

  vm.init = function()
  {    
    vm.check();
    vm.consultar();
  }

  vm.check = function()
  {      
    vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/admin")
      .then(function(response)
      { 
        if (!response.data)
        {
          toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
          $state.go('index.main');
        }
    });
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/empresa/logo")
    .then(function(response)
    {           
      vm.logo = response.data;
    });
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

  $scope.uploadFile = function(files) {
        
    if (files.length > 0)
    {
      vm.uploadPromise = getBase64(files[0]);

      vm.filesBinary.push(files[0]);

      vm.uploadPromise.then(function(result) {

        var arquivo = vm.filesBinary[vm.filesBinary.length-1];

        //var logo = new ProdutoFoto();
        var logo = {
          base64 : result.split(',')[1]
        }

        vm.salvarFotoPromise = $http.put(APP_ROOT + "/empresa/logo", logo).success(function(response){        
          toastr.info('Logo atualizado com sucesso.', 'Alerta');                  
          vm.consultar();
          return response;
        }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
        });

      });
    }
  };

  function getBase64(file, onLoadCallback) {
    return new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onload = function() { resolve(reader.result); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

}]);

'use strict';

angular.module('inspinia')
  .controller('EmpresaAtualizarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT','$uibModal', '$filter', 'CepService',
      function($scope, $state, toastr, $http, APP_ROOT, $uibModal, $filter, CepService)
{
  var vm = this;

  vm.registro = {};

  vm.init = function()
  {    
    vm.check();
    vm.consultar();
  }

  vm.check = function()
    {      
      vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/admin")
      .then(function(response)
      { 
        if (!response.data)
        {
          toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
          $state.go('index.main');
        }
      });
    }

  vm.salvar = function()
  {
    if (vm.registro.nome == null || vm.registro.nome == '')
    {
      toastr.error('Nome é obrigatório.', 'Alerta');
      return;
    }

    vm.salvarPromise = $http.put(APP_ROOT + "/empresa", vm.registro).success(function(response){        
        toastr.info('Registro atualizado com sucesso.', 'Alerta');                
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
  }

  vm.consultarCep = function()
  {
    vm.registro.enderecoLogradouro = '';
    vm.registro.enderecoBairro = '';
    vm.registro.enderecoCidade = '';
    vm.registro.enderecoEstado = '';

    vm.cepPromise = CepService.get(vm.registro.enderecoCep);

    vm.cepPromise.then(function(result) {  
      if (result != null)
      {
        if (result.localidade == null)
        {
          toastr.error("CEP não encontrado.", 'Cep');
        }
        else
        {
          vm.registro.enderecoLogradouro = result.logradouro;
          vm.registro.enderecoBairro = result.bairro;
          vm.registro.enderecoCidade = result.localidade;
          vm.registro.enderecoEstado = result.uf;
        }
      }
      else
      {
        toastr.error("Erro na consulta de CEP", 'Cep');
      }
    });
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/empresa")
    .then(function(response)
    {           
      vm.registro = response.data;
    });
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('ConfigDocumentoController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT','$uibModal', '$filter',
      function($scope, $state, toastr, $http, APP_ROOT, $uibModal, $filter)
{
  var vm = this;

  vm.registro = {};
  vm.identificador = '';
  vm.templateUrl = 'assets/images/template/template_basic0.png';

  vm.init = function()
  {    
    vm.check();
    vm.consultar();
  }

  vm.check = function()
  {
    vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/admin")
    .then(function(response)
    { 
      if (!response.data)
      {
        toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
        $state.go('index.main');
      }
    });
  }

  vm.salvar = function()
  {
    if (vm.registro.nome == null || vm.registro.nome == '')
    {
      toastr.error('Nome é obrigatório.', 'Alerta');
      return;
    }

    vm.salvarPromise = $http.put(APP_ROOT + "/empresa/template", vm.registro).success(function(response){ 
        if(response)       
        {
          toastr.info('Dados atualizados com sucesso.', 'Alerta');
        }
        else
        {
          alert('Alerta');
        }
        vm.consultar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/empresa/template")
    .then(function(response)
    {           
      vm.registro = response.data;
      vm.registro.templateId = parseInt(vm.registro.templateId);
      vm.changeTemplate();
    });
  }

  vm.changeTemplate = function()
  {
    switch (vm.registro.templateId.toString())
    {
      case "7":
        vm.templateUrl = 'assets/images/template/template_basic0.png';
      break;
      case "4":
        vm.templateUrl = 'assets/images/template/template_basic1.png';
      break;
      case "11":
        vm.templateUrl = 'assets/images/template/template_basic2.png';
      break;
      case "6":
        vm.templateUrl = 'assets/images/template/template_basic1purple.png';
      break;
      case "8":
        vm.templateUrl = 'assets/images/template/template_basic1blue2.png';
      break;
      case "9":
        vm.templateUrl = 'assets/images/template/template_basic1green.png';
      break;
      case "5":
        vm.templateUrl = 'assets/images/template/template_basic1blue.png';
      break;
      default:
        vm.templateUrl = 'assets/images/template/template_basic0.png';
    }
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('CobrancaVencidosController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService', '$uibModal',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService, $uibModal)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
        vm.registros = null;
        vm.registrosOriginal = null;
        
        vm.registrosPromise = $http.get(APP_ROOT + "/cobranca/vencidos")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.pager.totalPages = 1;
            vm.setPage(1);
        });
    }

    vm.consultarVenda = function(p)
    {
        if (p.agenda != null)
        {
            vm.consultarAgenda(p.agenda.viewId);
            //alert('Edição do agendamento será disponibilizado em breve.');
        }
        else
        {
            $state.go('index.venda_cadastrar', {viewId: p.venda.viewId});
        }        
    }

    vm.consultarAgenda = function(viewId)
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/agenda/calendario/consultar/index.html',
        controller: 'AgendaCalendarioConsultarController',
        controllerAs: 'controller',
        backdrop: 'static',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {          
          viewId: function () {
              return viewId;
          },
        }
      }).result.then(function(data){
        vm.pesquisar();
        //vm.ticket.assunto = data;
      });
    }

    vm.removerPagamento = function(p)
    {
        if (confirm('Deseja realmente excluir este registro?'))
        {
        vm.salvarPromise = $http.delete(APP_ROOT + "/venda/excluirpagamento/" + p.viewId).success(function(response){           
            toastr.info('Registro excluído com sucesso.', 'Alerta');
            vm.pesquisar();
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
        }
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.cliente != null && vm.filtro.cliente != '')
            {
                if (!vm.registrosOriginal[i].venda.cliente.nome.toUpperCase().includes(vm.filtro.cliente.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('CobrancaRecebidosController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService', '$uibModal',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService, $uibModal)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;
    vm.filtro = {
        cliente: ''
    };
    vm.anoFiltro = '2021';
    vm.mesFiltro = (new Date().getMonth() + 1).toString();

    vm.pesquisar = function()
    {
        vm.filtro.cliente = '';
        vm.registros = null;
        vm.registrosOriginal = null;
        
        vm.registrosPromise = $http.get(APP_ROOT + "/cobranca/recebidosweb/" + vm.anoFiltro + '/' + vm.mesFiltro)
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.pager.totalPages = 1;
            vm.setPage(1);
        });
    }

    vm.consultarVenda = function(p)
    {
        if (p.agenda != null)
        {
            vm.consultarAgenda(p.agenda.viewId);
            //alert('Edição do agendamento será disponibilizado em breve.');
        }
        else
        {
            $state.go('index.venda_cadastrar', {viewId: p.venda.viewId});
        }        
    }

    vm.consultarAgenda = function(viewId)
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/agenda/calendario/consultar/index.html',
        controller: 'AgendaCalendarioConsultarController',
        controllerAs: 'controller',
        backdrop: 'static',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {          
          viewId: function () {
              return viewId;
          },
        }
      }).result.then(function(data){
        vm.pesquisar();
        //vm.ticket.assunto = data;
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.cliente != null && vm.filtro.cliente != '')
            {
                if (!vm.registrosOriginal[i].venda.cliente.nome.toUpperCase().includes(vm.filtro.cliente.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.removerPagamento = function(p)
    {
        if (confirm('Deseja realmente excluir este registro?'))
        {
        vm.salvarPromise = $http.delete(APP_ROOT + "/venda/excluirpagamento/" + p.viewId).success(function(response){           
            toastr.info('Registro excluído com sucesso.', 'Alerta');
            vm.pesquisar();
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
        }
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('CobrancaPendentesController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService', '$uibModal',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService, $uibModal)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
        vm.registros = null;
        vm.registrosOriginal = null;
        
        vm.registrosPromise = $http.get(APP_ROOT + "/cobranca/pendentes")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.pager.totalPages = 1;
            vm.setPage(1);
        });
    }

    vm.consultarVenda = function(p)
    {
        if (p.agenda != null)
        {
            vm.consultarAgenda(p.agenda.viewId);
            //alert('Edição do agendamento será disponibilizado em breve.');
        }
        else
        {
            $state.go('index.venda_cadastrar', {viewId: p.venda.viewId});
        }        
    }

    vm.consultarAgenda = function(viewId)
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/agenda/calendario/consultar/index.html',
        controller: 'AgendaCalendarioConsultarController',
        controllerAs: 'controller',
        backdrop: 'static',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {          
          viewId: function () {
              return viewId;
          },
        }
      }).result.then(function(data){
        vm.pesquisar();
        //vm.ticket.assunto = data;
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.cliente != null && vm.filtro.cliente != '')
            {
                if (!vm.registrosOriginal[i].venda.cliente.nome.toUpperCase().includes(vm.filtro.cliente.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.removerPagamento = function(p)
    {
        if (confirm('Deseja realmente excluir este registro?'))
        {
        vm.salvarPromise = $http.delete(APP_ROOT + "/venda/excluirpagamento/" + p.viewId).success(function(response){           
            toastr.info('Registro excluído com sucesso.', 'Alerta');
            vm.pesquisar();
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
        }
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('CobrancaAreceberController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
        vm.registros = null;
        vm.registrosOriginal = null;
        
        vm.registrosPromise = $http.get(APP_ROOT + "/venda/pesquisartipo/" + vm.tipo + "/0")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.pager.totalPages = 1;
            vm.setPage(1);
        });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.numero != null && vm.filtro.numero != '')
            {
                if (!vm.registrosOriginal[i].numero.toUpperCase().includes(vm.filtro.numero.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cliente != null && vm.filtro.cliente != '')
            {
                if (!vm.registrosOriginal[i].cliente.nome.toUpperCase().includes(vm.filtro.cliente.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.usuario != null && vm.filtro.usuario != '')
            {
                if (!vm.registrosOriginal[i].usuarioCadastro.nome.toUpperCase().includes(vm.filtro.usuario.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.visualizar = function(p)
    {

    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('ClientePesquisarController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
      vm.registros = null;
      vm.registrosOriginal = null;
        
      vm.registrosPromise = $http.get(APP_ROOT + "/cliente")
      .then(function(response)
      { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }
            /*
            if (vm.filtro.celular != null && vm.filtro.celular != '')
            {
                if (!vm.registrosOriginal[i].celular.toUpperCase().includes(vm.filtro.celular.toUpperCase()))
                {
                    incluir = false;
                }
            }
            if (vm.filtro.email != null && vm.filtro.email != '')
            {
                if (!vm.registrosOriginal[i].email.toUpperCase().includes(vm.filtro.email.toUpperCase()))
                {
                    incluir = false;
                }
            }
            */
            if (vm.filtro.cpf != null && vm.filtro.cpf != '')
            {
                if (vm.registrosOriginal[i].cpf == null || !vm.registrosOriginal[i].cpf.toUpperCase().includes(vm.filtro.cpf.toUpperCase()))
                {
                    incluir = false;
                }
            }
            /*
            /*
            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.incluir = function()
    {
      $state.go('index.cliente_cadastrar');
    }

    vm.visualizar = function(p)
    {      
      $state.go('index.cliente_cadastrar', {viewId: p.viewId});
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('ClienteImportarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'UsuarioService', '$uibModal', 'CepService',
      function($scope, $state, toastr, $http, APP_ROOT, UsuarioService, $uibModal, CepService)
{
    var vm = this;

    vm.selectedTempFile = [];
    vm.registros = [];

    vm.init = function()
    {
        
    }

    vm.adicionarItem = function()
    {
        var nfe = {};
        nfe.Id = vm.fileId++;
        nfe.Nome = vm.selectedTempFile[0].name;
        
        var reader = new FileReader();
        reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
        reader.onload = function (evt) {

            vm.validarPromise = $http.post(APP_ROOT + "/cliente/importarcsv", { file : evt.target.result }).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })

                //= NfeService.validar(evt.target.result);
            vm.validarPromise.then(function(result) {  
                vm.registros = result.data;
            });
        };

        vm.selectedTempFile = [];
        angular.element("input[type='file']").val(null);
    }

    vm.importar = function()
    {
        if (vm.registros.length == 0)
        {
            toastr.error('Não existem clientes para importação.', 'Alerta');
        }

        if (vm.registros.length > 150)
        {
            toastr.error('Lista de cliente ultrapassa o limite de 150 registros.', 'Alerta');
        }

        var item = {
            registros: vm.registros
        }

        vm.validarPromise = $http.post(APP_ROOT + "/cliente/salvarimportarcsv", item).success(function(response){
            return response;
        }).error(function(error){
            return error;
        })
        vm.validarPromise.then(function(result) {  
            vm.selectedTempFile = [];
            vm.registros = [];
            toastr.info('Clientes importados com sucesso.', 'Alerta');
        });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);

'use strict';

angular.module('inspinia')
  .controller('ClienteCadastrarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', 'UsuarioService', '$uibModal', 'CepService',
      function($scope, $state, toastr, $http, APP_ROOT, UsuarioService, $uibModal, CepService)
{
  var vm = this;

  vm.registro = {
    sexo : 1
  };
  vm.registroViewId = $state.params.viewId;    
  vm.isUpdate = false;
  vm.foto = null;
  vm.filesBinary = [];

  vm.init = function()
  {    
    if (vm.registroViewId != null)
    {
      vm.isUpdate = true;

      vm.consultar();
    }
    else
    {
      vm.isUpdate = false;
    }

    //vm.listarUsuarios();
  }

  vm.salvar = function()
  {
    vm.registro.sexo = parseInt(vm.registro.sexo);
    if (!vm.isUpdate)
    {
      vm.salvarPromise = $http.post(APP_ROOT + "/cliente", vm.registro).success(function(response){   
        
        vm.registroViewId = response.viewId;
        vm.isUpdate = true;

        toastr.info('Cliente cadastrado com sucesso.', 'Alerta');

        $state.go('index.cliente_cadastrar', {viewId: vm.registroViewId});

        //vm.consultar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }    
    else
    {
      vm.salvarPromise = $http.put(APP_ROOT + "/cliente/" + vm.registroViewId, vm.registro).success(function(response){        
        toastr.info('Cliente atualizado com sucesso.', 'Alerta');
        vm.consultar();
        //$state.go('index.pesquisaratendimento');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/cliente/" + vm.registroViewId)
    .then(function(response)
    {           
      vm.registro = response.data;
      if (vm.registro.sexo != null)
      {
        if (vm.registro.sexo == 0)
        {
          vm.registro.sexo = 1;
        }
      }
      if (vm.registro.dataNascimento != null)
      {
        vm.registro.dataNascimento = new Date(vm.registro.dataNascimento);
      }

      vm.foto = (APP_ROOT + "/clienteFoto/consultar/" + vm.registroViewId);
      
    });
  }

  vm.excluir = function()
  {
    if (confirm('Deseja realmente excluir este registro?'))
    {
      vm.excluirPromise = $http.delete(APP_ROOT + "/cliente/" + vm.registro.viewId).success(function(response){        
        toastr.info('Solicitação excluída com sucesso.', 'Alerta');      
        $state.go('index.cliente_pesquisar');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.consultarCep = function()
  {
    vm.registro.enderecoLogradouro = '';
    vm.registro.enderecoBairro = '';
    vm.registro.enderecoCidade = '';
    vm.registro.enderecoEstado = '';

    vm.cepPromise = CepService.get(vm.registro.enderecoCep);

    vm.cepPromise.then(function(result) {  
      if (result != null)
      {
        if (result.localidade == null)
        {
          toastr.error("CEP não encontrado.", 'Cep');
        }
        else
        {
          vm.registro.enderecoLogradouro = result.logradouro;
          vm.registro.enderecoBairro = result.bairro;
          vm.registro.enderecoCidade = result.localidade;
          vm.registro.enderecoEstado = result.uf;
        }
      }
      else
      {
        toastr.error("Erro na consulta de CEP", 'Cep');
      }
    });
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

  $scope.uploadFile = function(files) {
        
    if (files.length > 0)
    {
      vm.uploadPromise = getBase64(files[0]);

      vm.filesBinary.push(files[0]);

      vm.uploadPromise.then(function(result) {

        var arquivo = vm.filesBinary[vm.filesBinary.length-1];

        //var logo = new ProdutoFoto();
        var logo = {
          base64 : result.split(',')[1],
          clienteViewId : vm.registroViewId
        }

        vm.salvarFotoPromise = $http.put(APP_ROOT + "/clientefoto", logo).success(function(response){        
          toastr.info('Foto atualizada com sucesso.', 'Alerta');                  
          vm.foto = (APP_ROOT + "/clienteFoto/consultar/" + vm.registroViewId + "?id=" + + Math.random());
          return response;
        }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
        });

      });
    }
  };

  function getBase64(file, onLoadCallback) {
    return new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onload = function() { resolve(reader.result); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

}]);

'use strict';

angular.module('inspinia')
  .controller('AtendimentoPesquisaController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    vm.pesquisar = function()
    {
      vm.registros = null;
        
      vm.atendimentosPromise = $http.get(APP_ROOT + "/atendimento")
      .then(function(response)
      { 
          //vm.registrosOriginal = response.data;
          vm.registros = response.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
      });
    }

    vm.incluir = function()
    {
      $state.go('index.cadastraratendimento');
    }

    vm.visualizar = function(atendimento)
    {
      //$state.go('index.consultaratendimento', {obj: atendimento});
      $state.go('index.cadastraratendimento', {atendimento: atendimento});
    }

    vm.alterar = function(atendimento)
    {
      //$state.go('index.alteraratendimento', {obj: atendimento});
    }    

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('AtendimentoCadastroController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT','AtendimentoService', 'OrigemAtendimentoService',
  'SituacaoAtendimentoService', 'GeocodeGoogleService', 'UsuarioService',
      function($scope, $state, toastr, $http, APP_ROOT, AtendimentoService, OrigemAtendimentoService, SituacaoAtendimentoService, 
        GeocodeGoogleService, UsuarioService)
{
  var vm = this;

  vm.atendimento = {};
  vm.atendimento.arquivos = [];
  vm.contato = {};
  vm.contatoParam = $state.params.contato;
  vm.atendimentoParam = $state.params.atendimento;
  vm.filesBinary = [];
  vm.isUpdate = false;

  vm.init = function()
  {
    if (vm.contatoParam == null && vm.atendimentoParam == null)
    {
      $state.go('index.pesquisaratendimento');
    }
    
    if (vm.atendimentoParam != null)
    {
      vm.isUpdate = true;

      vm.consultarAtendimento(vm.atendimentoParam.viewId);
    }
    else
    {
      vm.isUpdate = false;

      vm.contato.Nome = vm.contatoParam.nome;
      vm.contato.CPF = vm.contatoParam.cpf;
      vm.atendimento.contato = {};
      vm.atendimento.contato.viewId = vm.contatoParam.viewId;
      vm.atendimento.dataAtendimento = new Date();
      /*
      var today = new Date();    
      var hh = today.getHours();
      var minuto = today.getMinutes();
      if(hh<10){
        hh='0'+hh;
      } 
      if(minuto<10){
        minuto='0'+minuto;
      }     
      vm.atendimento.Data = new Date();
      vm.atendimento.Hora = hh+':'+minuto;
      */
    }

    vm.listarOrigemAtendimento();
    vm.listarSituacaoAtendimento();
    vm.listarUsuarios();
    vm.initialMap();
  }

  vm.incluir = function()
  {
    //vm.atendimento.DataAtendimento = vm.atendimento.Data + ' ' + vm.atendimento.Hora;
    //vm.atendimento.DataAtendimento = vm.atendimento.Data;

    if (vm.atendimento.latitude != null)
    {
      vm.atendimento.latitude = vm.atendimento.latitude.toString();
    }
    
    if (vm.atendimento.longitude != null)
    {
      vm.atendimento.longitude = vm.atendimento.longitude.toString();
    }
    
    if (!vm.isUpdate)
    {
      vm.salvarPromise = $http.post(APP_ROOT + "/atendimento", vm.atendimento).success(function(response){        
        toastr.info('Atendimento cadastrado com sucesso.', 'Alerta');
        $state.go('index.pesquisaratendimento');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }    
    else
    {
      vm.salvarPromise = $http.put(APP_ROOT + "/atendimento", vm.atendimento).success(function(response){        
        toastr.info('Atendimento atualizado com sucesso.', 'Alerta');
        $state.go('index.pesquisaratendimento');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }
  }

  vm.consultarAtendimento = function(viewId)
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/atendimento/" + viewId)
    .then(function(response)
    {           
      if (response.data == null || response.data == '')
      {
        $state.go('index.pesquisaratendimento');
      }
      else
      {
        vm.atendimento = response.data;

        vm.contato.Nome = vm.atendimento.contato.nome;
        vm.contato.CPF = vm.atendimento.contato.cpf;       
        
        vm.atendimento.dataAtendimento = new Date(vm.atendimento.dataAtendimento);
        
        if (vm.atendimento.latitude != null)
        {
          vm.atendimento.latitude = parseFloat(vm.atendimento.latitude);
          vm.atendimento.longitude = parseFloat(vm.atendimento.longitude);          

          $scope.markers = [];

          var m1 = {
              lat: parseFloat(vm.atendimento.latitude),
              lng: parseFloat(vm.atendimento.longitude),
              focus: true,
              message: "<b>Referência:</b> " + vm.atendimento.enderecoReferencia,
              draggable: false
          };
          $scope.markers.push(m1);
        }
      }
    });
  }

  vm.listarOrigemAtendimento = function()
  {
    vm.origensAtendimentoPromise = $http.get(APP_ROOT + "/atendimento/origem")
    .then(function(response)
    {           
        vm.origensAtendimento = response.data;
        if (!vm.isUpdate)
        {
          vm.atendimento.origem = vm.origensAtendimento[0].id;
        }        
    });
  }

  vm.listarSituacaoAtendimento = function()
  {
    vm.situacoesAtendimentoPromise = $http.get(APP_ROOT + "/atendimento/situacao")
    .then(function(response)
    {           
        vm.situacoesAtendimento = response.data;

        if (!vm.isUpdate)
        {
          vm.atendimento.situacao = vm.situacoesAtendimento[0].id;
        }        
    });
  }

  vm.consultarLocal = function()
  {
    vm.GeocodePromise = GeocodeGoogleService.get(vm.atendimento.enderecoReferencia)

    vm.GeocodePromise.then(function(result) {  
      if (result != null)
      {
        if (result.results.length > 0)
        {
          var lat = result.results[0].geometry.location.lat;
          var lng = result.results[0].geometry.location.lng;
          var logradouro = result.results[0].address_components[0].long_name;
          
          vm.atendimento.latitude = lat; 
          vm.atendimento.longitude = lng;    
          
          $scope.markers = [];

          var m1 = {
              lat: parseFloat(lat),
              lng: parseFloat(lng),
              focus: true,
              message: "<b>Referência:</b> " + vm.atendimento.enderecoReferencia,
              draggable: false
          };
          $scope.markers.push(m1);
        }
      }
      else
      {
          toastr.error("Erro na consulta da latitude/longitude", 'Maps');
      }
    });
  }

  vm.listarUsuarios = function()
  {
    vm.usuariosPromise = UsuarioService.getAll()

    vm.usuariosPromise.then(function(result) {  
      vm.usuarios = result; 
      vm.atendimento.responsavel = vm.usuarios[0];
    });
  }

  vm.initialMap = function(ip) {
    $scope.mapProjects = {
        lat: global_latitude,
        lng: global_longitude,
        zoom: global_zoom_map
    };
  }; 

  function getBase64(file, onLoadCallback) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
  }

  $scope.uploadFile = function(files) {
        
    if (files.length > 0)
    {
      vm.uploadPromise = getBase64(files[0]);

      vm.filesBinary.push(files[0]);

      vm.uploadPromise.then(function(result) {

        var arquivo = vm.filesBinary[vm.filesBinary.length-1];

        vm.atendimento.arquivos.push(
          { 
            nome: arquivo.name,
            base64: result, 
            typeFile: arquivo.type,
            lengthFile: arquivo.size,
            tipo: arquivo.type.indexOf('image') >= 0 ? 'img' : 'doc' 
          }
        );
      });

      toastr.success("Arquivo enviado com sucesso.", 'Upload');
    }
  };

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

'use strict';

angular.module('inspinia')
  .controller('AgendaCalendarioController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT', '$uibModal',
      function($scope, $state, toastr, $http, APP_ROOT, $uibModal)
{
    var vm = this;
    $scope.eventSources = [];
    //vm.registroViewId = $state.params.viewId;      

    vm.init = function()
    {    
        vm.pesquisar();        

        $scope.uiConfig = {
            calendar:{
                height: 750,
                editable: true,
                header:{
                left: 'month basicWeek basicDay',
                center: 'title',
                right: 'today prev,next'
                },
                //eventClick: $scope.alertEventOnClick,
                eventDrop: $scope.alertOnDrop,
                eventResize: $scope.alertOnResize,
                eventClick: function(event){
                    //window.open('#/index/cliente_cadastrar/' + event.id,'_blank');
                    vm.consultar(event.id);
                }
            }
        };
    }

    vm.novo = function()
    {  
        var modalInstance = $uibModal.open({
            templateUrl: 'app/agenda/calendario/consultar/index.html',
            controller: 'AgendaCalendarioConsultarController',
            controllerAs: 'controller',
            backdrop: 'static',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {          
              viewId: function () {
                  return null;
              },
            }
          }).result.then(function(data){
            vm.pesquisar();
            //vm.ticket.assunto = data;
          });
    }

    vm.consultar = function(viewId)
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/agenda/calendario/consultar/index.html',
        controller: 'AgendaCalendarioConsultarController',
        controllerAs: 'controller',
        backdrop: 'static',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {          
          viewId: function () {
              return viewId;
          },
        }
      }).result.then(function(data){
        vm.pesquisar();
        //vm.ticket.assunto = data;
      });
    }

    vm.pesquisar = function()
    {                        
        $scope.eventSources = [];

        vm.registrosPromise = $http.get(APP_ROOT + "/agenda/calendarioweb")
        .then(function(response)
        { 
            var registros = response.data;
            
            $scope.events = [];
            for(var i=0; i<registros.length; i++) {
                $scope.events.push(
                    { 
                        title: registros[i].title, 
                        start: new Date(registros[i].start), 
                        end: new Date(registros[i].end),
                        id: registros[i].viewId,
                        color: (registros[i].status == 2 ? 'red' : (registros[i].status == 3 ? 'grey' : (registros[i].status == 1 ? '' : '#1c84c6')))
                    }
                )
            }
            
            $scope.eventSources = [$scope.events];
        });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);

angular
.module('inspinia').factory("UsuarioService", ['$http', 'APP_ROOT', 'AuthService', 
    function ($http, APP_ROOT, AuthService) {
    return {
        login: function(login, pwd){
            var data = {
                login: login,
                senha: pwd,
                origem: 'web'
            }
            return $http.post(APP_ROOT + "/token/user", data).then(
                function(response){
                    AuthService.setToken(response.data.accessToken);
                    AuthService.setUser(response.data.userName);
                    AuthService.setEmpresa(response.data.empresaName);
                    AuthService.setRole(response.data.role);
                    return response;
                },
                function (error) {
                    return error;
                }
            )
        },
        insert: function(usuario){
            return $http.post(APP_ROOT + "/usuario", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        update: function(viewId, usuario){
            usuario.ViewId = viewId;
            return $http.post(APP_ROOT + "/usuario/update", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        updatePassword: function(oldPassword, newPassword){
            usuario = {};
            usuario.oldPassword = oldPassword;
            usuario.newPassword = newPassword;
            return $http.post(APP_ROOT + "/usuario/updatePassword", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        delete: function(usuario){
            return $http.post(APP_ROOT + "/usuario/remove", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },       
        get: function (viewId) {
            return $http.get(APP_ROOT + "/usuario/" + viewId)
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAll: function () {
            return $http.get(APP_ROOT + "/usuario")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getMenu: function (viewId) {
            return $http.get(APP_ROOT + "/auth/menu")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
'use strict';

angular.module('inspinia')
  .controller('UsuarioPesquisaController', ['$scope', '$state', 'UsuarioService', 'toastr', 'PagerService',
      function($scope, $state, UsuarioService, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.usuarios.length, page);
      vm.items = vm.usuarios.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.pesquisar = function()
    {
      var usuariosPromise = UsuarioService.getAll();

      usuariosPromise.then(function(result) {  
        if (result.status)
        {
          vm.usuarios = result.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
        }
      });
    }

    vm.incluir = function()
    {
      $state.go('index.cadastrarusuario');
    }

    vm.visualizar = function(usuario)
    {
      $state.go('index.consultarusuario', {obj: usuario});
    }

    vm.alterar = function(usuario)
    {
      $state.go('index.alterarusuario', {obj: usuario});
    }    

    vm.pesquisar();

  }]);
'use strict';

angular.module('inspinia')
  .controller('UsuarioLoginController', ['$scope', '$state', 'UsuarioService', 'toastr', 'AuthService', '$uibModal',
      function($scope, $state, UsuarioService, toastr, AuthService, $uibModal)
  {
    var vm = this;

    vm.esqueciMinhaSenha = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/usuario/esqueci_senha/index.html',
        controller: 'EsqueciSenhaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'xs',
        resolve: {
          /*
          antecipacao: function () {
              return antecipacao;
          },
          */
        }
      }).result.then(function(data){
        vm.ticket.assunto = data;        
        vm.gerarCampos();
        //vm.listar();
      });
    }

  }]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioCadastroController', ['$scope', '$state', 'UsuarioService', 
      'toastr',
      function($scope, $state, UsuarioService, toastr)
{
    var vm = this;

    vm.usuario = {};

    vm.incluir = function()
    {
      var usuarioPromise = UsuarioService.insert(vm.usuario);

      usuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário cadastrado com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioAlteracaoSenhaController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT',
      function($scope, $state, toastr, $http, APP_ROOT)
  {
    var vm = this;

    vm.atualizar = function()
    {
      var request = {
        senhaAnterior: vm.oldPassword,
        novaSenha: vm.newPassword
      };

      vm.aprovarAberturaPromise = $http.post(APP_ROOT + "/usuario/alterarsenha", request).success(function(response){
        toastr.info('Senha atualizada com sucesso.', 'Alerta');   
        $state.go('index.main');          
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioAlteracaoController', ['$scope', '$state', 'UsuarioService', 
      'toastr',
      function($scope, $state, UsuarioService, toastr)
  {
    var vm = this;

    vm.usuario = {};
    vm.usuarioParam = $state.params.obj;

    vm.consultar = function()
    {
      var usuarioConsultaPromise = UsuarioService.get(vm.usuarioParam.ViewId);

      usuarioConsultaPromise.then(function(result) {  
        vm.usuario = result;
      });
    }

    vm.alterar = function()
    {
      var usuarioPromise = UsuarioService.update(vm.usuarioParam.ViewId, vm.usuario);

      usuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário alterado com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

    vm.excluir = function()
    {
      var deleteUsuarioPromise = UsuarioService.delete(vm.usuarioParam);

      deleteUsuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário excluído com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

    vm.init = function()
    {
      if (vm.usuarioParam == null)
      {
        $state.go('index.pesquisarusuario');
      }
      else
      {
        vm.consultar();
      }
    }

    vm.init();

}]);

angular.module('inspinia')
    .factory('AuthService', AuthService);

function AuthService ($localStorage, $q) {
    return {
    getToken : function () {
        return $localStorage.tokenCli;
    },
    setToken: function (token) {
        $localStorage.tokenCli = token;
    },
    getUser : function () {
        return $localStorage.userCli;
    },
    setUser: function (user) {
        $localStorage.userCli = user;
    },
    getRole : function () {
        return $localStorage.roleCli;
    },
    setRole: function (role) {
        $localStorage.roleCli = role;
    },
    getMenu : function () {
        return $localStorage.menuCli;
    },
    setMenu: function (menu) {
        $localStorage.menuCli = menu;
    },
    getEmpresa : function () {
        return $localStorage.empresaCli;
    },
    setEmpresa: function (empresa) {
        $localStorage.empresaCli = empresa;
    },
    logout : function (data) {
        delete $localStorage.tokenCli;
        delete $localStorage.userCli;
        delete $localStorage.roleCli;
        delete $localStorage.empresaCli;
        $q.when();
    }
    };
}
angular.module('inspinia')
    .factory('AuthInterceptor', AuthInterceptor)
    .config(function($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');
});

function AuthInterceptor ($location, AuthService, $q) {
    return {
    request: function(config) {
        config.headers = config.headers || {};

        if (!config.skipInterceptor && AuthService.getToken()) {
            config.headers['Authorization'] = 'Bearer ' + AuthService.getToken();
        }
        
        return config;
    },

    responseError: function(response) {
        if (response.status === 401 || response.status === 403) {
        $location.path('/login');
        }

        return $q.reject(response);
    }
    }
}
'use strict';

angular.module('inspinia')
  .controller('ExternoAlterarSenhaController', ['$scope', '$state', 'toastr', 'API_INTRANET', '$http',
      function($scope, $state, toastr, API_INTRANET, $http)
  {
    var vm = this;
    vm.registro = {};

    vm.init = function()
    {
      
    }

    vm.enviar = function()
    {
      if (vm.registro.email == null || vm.registro.email == '')
      {
        toastr.error('E-mail é obrigatório.', 'ALERTA');
        return;
      }
      
      vm.enviarPromise = $http.post(API_INTRANET + "/reset/solicitar", vm.registro).success(function(response){        
        toastr.info('Procedimento enviado com sucesso.', 'Alerta');
        $state.go('login.autenticar');
        return response;
      }).error(function(error){
        toastr.error(error, 'ALERTA');
        return error;
      });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('MockController', ['$scope', '$state', '$http', 'APP_ROOT', 'toastr', 'PagerService',
      function($scope, $state, $http, APP_ROOT, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;    

    vm.pesquisar = function()
    {
      vm.registros = [];
      vm.items = [];
    }

    vm.pesquisar();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);
angular
.module('inspinia').factory("MapaService", ['$http', 'APP_ROOT', 
    function ($http, APP_ROOT) {
    return {
        getContatos: function () {
            return $http.get(APP_ROOT + "/mapa/GetContatosMapa/")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
'use strict';

angular.module('inspinia')
  .controller('MainController', ['$state', 'AuthService', 'UsuarioService', 'toastr', '$cookieStore', 'APP_ROOT', '$http',
  function ($state, AuthService, UsuarioService, toastr, $cookieStore, APP_ROOT, $http) {

    var vm = this;
    vm.userName = AuthService.getUser();
    vm.empresaName = AuthService.getEmpresa();
    vm.menus = AuthService.getMenu();
    vm.role = AuthService.getRole();
    vm.usuario = {};     
    vm.default = '';
    vm.isAdmin = false;
    
    vm.restricaoSituacaoVenda = true;
    vm.restricaoCadastroProduto = true;

    vm.usuario = {};
    //vm.usuario.Login = 'contato@plandesk.com.br';
    //vm.usuario.Password = 'teste123';
    vm.usuario.Login = '';
    vm.usuario.Password = '';

    vm.init = function()
    {
      if ($cookieStore.get('lastLogin') != null)
      {
        vm.usuario.Login = $cookieStore.get('lastLogin');
      }
      vm.role = AuthService.getRole();
    }

    vm.login = function()
    {
      $cookieStore.put('lastLogin', vm.usuario.Login);
      
      vm.loginPromise = UsuarioService.login(vm.usuario.Login, vm.usuario.Password);

      vm.loginPromise.then(function(result) {  
        if(result.data.authenticated)
        {
            vm.default = result.data.default;

            vm.userName = AuthService.getUser();
            vm.empresaName = AuthService.getEmpresa();
            vm.role = AuthService.getRole();
            
            /*
            vm.menusPromise = UsuarioService.getMenu();

            vm.menusPromise.then(function(result2) {  
              vm.menus = result2;
              AuthService.setMenu(vm.menus);
              $state.go(vm.default);
            });
            */

            vm.restricaoProdutosPromise = $http.get(APP_ROOT + "/checkmodule/restricaoprodutoservico")
            .then(function(response)
            { 
              //alert('produtos: ' + response.data)
              vm.restricaoCadastroProduto = response.data;
            });

            vm.restricaoSituacaoVendaPromise = $http.get(APP_ROOT + "/checkmodule/restricaosituacaovenda")
            .then(function(response)
            { 
              vm.restricaoSituacaoVenda = response.data;
              //alert('situacao: ' + response.data)
            });

            vm.restricaoSituacaoVendaPromise = $http.get(APP_ROOT + "/checkmodule/admin")
            .then(function(response)
            { 
              vm.isAdmin = response.data;
              AuthService.setRole(vm.isAdmin ? '1' : '0');
              vm.role = AuthService.getRole();
              //alert('situacao: ' + response.data)
            });

            $state.go("index.main");
        }
        else
        {
            toastr.error(result.data.message, 'Login');
        }
      });
    }

    vm.init();

  }]);

'use strict';

angular.module('inspinia')
  .controller('HomeController', ['$state', '$scope', 'toastr', '$http', 'APP_ROOT', 'HomeService',
  function ($state, $scope, toastr, $http, APP_ROOT, HomeService) {

    var vm = this;
    vm.isAssinante = true;

    vm.init = function()
    {
      vm.getIndicadores();
      vm.loadVendas();
      vm.loadClientes();
      //vm.getMinhasTarefas();
      //vm.listarObjetivosAtivos();
      //vm.listarProjetosAtivos();

      vm.assinantePromise = $http.get(APP_ROOT + "/checkmodule/assinante")
      .then(function(response)
      { 
        vm.isAssinante = response.data;
      });
    }

    vm.getIndicadores = function()
    {
      vm.indicadoresPromise = $http.get(APP_ROOT + "/home")
      .then(function(response)
      {           
          vm.indicadores = response.data;
      });
    }

    vm.getMinhasTarefas = function()
    {
      vm.minhastarefasPromise = $http.get(APP_ROOT + "/home/minhastarefas")
      .then(function(response)
      {           
          vm.minhastarefas = response.data;
      });
    }

    vm.listarObjetivosAtivos = function()
    {
      vm.objetivosAtivosPromise = $http.get(APP_ROOT + "/objetivo")
      .then(function(response)
      { 
          vm.objetivosAtivos = response.data;
      });
    }

    vm.listarProjetosAtivos = function()
    {
      vm.projetosAtivosPromise = $http.get(APP_ROOT + "/projeto")
      .then(function(response)
      { 
          vm.projetosAtivos = response.data;
      });
    }

    vm.visualizarTarefa = function(p)
    {      
      $state.go('index.tarefa_cadastrar', {viewId: p.viewId});
    }

    vm.chartOptions = {
      legend: {
          display: false
      },                                                                                             
      scales: {
          //yAxes: [{ticks: {min: 0, max:100}}]
      }
    };
    vm.chartReaisOptions = {
      legend: {
          display: false
      },
      tooltips: {
        enabled: true,
        mode: 'single',
        callbacks: {
          label: function(tooltipItem, data) {
            var label = data.labels[tooltipItem.index];
            var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return 'R$ ' + addCommas(datasetLabel.toString());
          }
        }
      },
    };

    vm.graficoCliente = {
      labels: [],
      series: [],
      colors: [],
      data: []
    };
    vm.graficoVenda = {
      labels: [],
      series: [],
      colors: [],
      data: []
    };

    vm.loadClientes = function()
    {
      vm.clientesPromise = $http.get(APP_ROOT + "/home/clientes")
      .then(function(response)
      { 
          var clientes = response.data;
          
          vm.graficoCliente.labels = clientes.meses;
          vm.graficoCliente.series = ['Clientes'];
          vm.graficoCliente.colors = ['#1ab394'];
          vm.graficoCliente.data = [
            clientes.valores
          ];
      });
    }

    vm.loadVendas = function()
    {
      vm.vendasPromise = $http.get(APP_ROOT + "/home/vendas")
      .then(function(response)
      { 
          var vendas = response.data;
          
          vm.graficoVenda.labels = vendas.meses;
          vm.graficoVenda.series = ['Vendas'];
          vm.graficoVenda.colors = ['#f8ac59'];
          vm.graficoVenda.data = [
            vendas.valores
          ];
      });
    }

    vm.init();

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

    function addCommas(nStr)
    {
      nStr += '';
      var x = nStr.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? ',' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + '.' + '$2');
      }
      return x1 + x2;
    }

  }]);

angular
.module('inspinia').factory("GeocodeGoogleService", ['$http', 'APP_ROOT', 
    function ($http) {
    return { 
        get: function (cep) {
            return $http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + cep + "&key=AIzaSyC-94Oko-7asyv3tuILSqsWPg9Yw2abM_I", {
                skipInterceptor: true
            })
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
angular
.module('inspinia').factory("HomeService", ['$http', 'APP_ROOT', 'AuthService', 
    function ($http, APP_ROOT, AuthService) {
    return {
        getQuantidade: function () {
            return $http.get(APP_ROOT + "/home/GetQuantidade")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAtendimentosMapa: function () {
            return $http.get(APP_ROOT + "/home/GetAtendimentosMapa")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getContatosMaps: function () {
            return $http.get(APP_ROOT + "/home/GetContatosMapa")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
'use strict';

angular.module('inspinia')
  .controller('ExportarDadosPageController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT',
      function($scope, $state, toastr, $http, APP_ROOT)
{
    var vm = this;

    vm.init = function()
    {

    }

    vm.getClientes = function(f)
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/exportarweb/clientes")
      .then(function(response)
      {
        vm.download(response.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'clientes.xls');
      });
    }

    vm.getProdutos = function(f)
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/exportarweb/produtos")
      .then(function(response)
      {
        vm.download(response.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'produtos.xls');
      });
    }

    vm.getServicos = function(f)
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/exportarweb/servicos")
      .then(function(response)
      {
        vm.download(response.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'servicos.xls');
      });
    }

    vm.init();

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

}]);

angular
.module('inspinia').factory("ContatoService", ['$http', 'APP_ROOT', 'AuthService', 
    function ($http, APP_ROOT, AuthService) {
    return {
        update: function(viewId, contato){
            contato.ViewId = viewId;
            return $http.post(APP_ROOT + "/contato/update", contato).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        delete: function(contato){
            return $http.post(APP_ROOT + "/contato/remove", contato).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },       
        get: function (viewId) {
            return $http.get(APP_ROOT + "/contato/" + viewId)
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAll: function () {
            return $http.get(APP_ROOT + "/contato")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
angular
.module('inspinia').factory("CepService", ['$http', 'APP_ROOT', 
    function ($http, APP_ROOT) {
    return { 
        get: function (cep) {
            return $http.get("https://viacep.com.br/ws/" + cep + "/json/", {
                skipInterceptor: true
            })
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
'use strict';

angular.module('inspinia')
  .controller('CatalogoCadastrarController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT','$uibModal', '$filter',
      function($scope, $state, toastr, $http, APP_ROOT, $uibModal, $filter)
{
  var vm = this;

  vm.registro = {};
  vm.identificador = '';

  vm.init = function()
  {    
    vm.check();
    vm.consultar();
  }

  vm.check = function()
    {      
      vm.registrosPromise = $http.get(APP_ROOT + "/checkmodule/admin")
      .then(function(response)
      { 
        if (!response.data)
        {
          toastr.error('Seu usuário não possui permissão para acessar este módulo.', 'Acesso negado');
          $state.go('index.main');
        }
      });
    }

  vm.salvar = function()
  {
    if (vm.identificador == null || vm.identificador == '')
    {
      toastr.error('Identificador é obrigatório.', 'Alerta');
      return;
    }

    var registro = {
        subdominio: vm.identificador,
        habilitarLojaOnline: true
    };

    vm.salvarPromise = $http.put(APP_ROOT + "/empresa/catalogo", registro).success(function(response){        
        toastr.info('Catálogo atualizado com sucesso.', 'Alerta');                
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
  }

  vm.consultar = function()
  {
    vm.consultarPromise = $http.get(APP_ROOT + "/empresa")
    .then(function(response)
    {           
      vm.identificador = response.data.subdominio;
    });
  }

  vm.init();

  vm.showhide = function (icon, box) {
    var icon = angular.element(document.getElementById(icon));
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    var elm = angular.element(document.getElementById(box));
    elm.slideToggle(200);
  };

}]);

angular
.module('inspinia').factory("AtendimentoService", ['$http', 'APP_ROOT', 'AuthService', 
    function ($http, APP_ROOT, AuthService) {
    return {
        insert: function(atendimento){
            return $http.post(APP_ROOT + "/atendimento", atendimento).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        update: function(viewId, atendimento){
            atendimento.ViewId = viewId;
            return $http.post(APP_ROOT + "/atendimento/update", atendimento).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        delete: function(atendimento){
            return $http.post(APP_ROOT + "/atendimento/remove", atendimento).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },       
        get: function (viewId) {
            return $http.get(APP_ROOT + "/atendimento/get/" + viewId)
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAll: function () {
            return $http.get(APP_ROOT + "/atendimento/getall")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
'use strict';

angular.module('inspinia')
  .controller('AtendimentoConsultaController', ['$scope', '$state', 'AtendimentoService', 'toastr',
      function($scope, $state, AtendimentoService, toastr)
  {
    var vm = this;
    vm.atendimentoParam = $state.params.obj;

    vm.init = function()
    {
        if (vm.atendimentoParam == null)
            $state.go('index.pesquisaratendimento');
      
        vm.viewId = vm.atendimentoParam.viewId;

        vm.consultar();
        vm.initialMap();
    }
    
    vm.consultar = function()
    {
      vm.atendimentoPromise = AtendimentoService.get(vm.viewId);

      vm.atendimentoPromise.then(function(result) {  
        if (result.status)
        {
            vm.atendimento = result.data;

            $scope.markers = [];

            $scope.mapProjects = {
                lat: parseFloat(vm.atendimento.latitude),
                lng: parseFloat(vm.atendimento.longitude),
                zoom: 12
            };

            var m1 = {
                lat: parseFloat(vm.atendimento.latitude),
                lng: parseFloat(vm.atendimento.longitude),
                focus: true,
                message: "<b>Referência:</b> " + vm.atendimento.enderecoReferencia,
                draggable: false
            };
            $scope.markers.push(m1);
        }
        else
        {
            toastr.error('Atendimento não encontrado!', 'Atendimento');
            $state.go('index.pesquisaratendimento');
        }
      });
    }

    vm.initialMap = function(ip) {
        $scope.mapProjects = {
            lat: global_latitude,
            lng: global_longitude,
            zoom: 12
        };
    };

    vm.init();

  }]);
/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeight = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeight){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeight){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider

      .state('login', {
        abstract: true,
        url: "/login",
        controller: 'UsuarioLoginController',
        controllerAs: 'usuarioLogin',
        templateUrl: "app/usuario/autenticar.html"
      })
      .state('index.main', {
        url: "/main",
        templateUrl: "app/main/main.html",
        controller: 'HomeController',
        controllerAs: 'home',
        data: { pageTitle: 'Dashboard de Projetos' }
      })

      // Externo
      .state('externo', {
        abstract: true,
        url: "/externo",
        controller: 'ExternoAlterarSenhaController',
        controllerAs: 'alterarSenhaController',
        templateUrl: "app/reset_senha/index.html"
      })
      // Reset de senha
      .state('externo.alterarsenha', {
        url: "/alterarsenha",
        controller: 'ExternoAlterarSenhaController',
        controllerAs: 'alterarSenhaController',
        templateUrl: "app/reset_senha/index.html",
      })

      // Login
      .state('login.autenticar', {
        url: "/autenticar",
        controller: 'UsuarioLoginController',
        controllerAs: 'usuarioLogin',
        templateUrl: "app/usuario/autenticar.html"
      })

      // Cliente
      .state('index.cliente_pesquisar', {
        url: "/cliente_pesquisar",
        templateUrl: "app/cliente/pesquisar/index.html",
        controller: 'ClientePesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.cliente_cadastrar', {
        url: "/cliente_cadastrar/:viewId",
        templateUrl: "app/cliente/cadastrar/index.html",
        controller: 'ClienteCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })
      .state('index.cliente_importar', {
        url: "/cliente_importar",
        templateUrl: "app/cliente/importar/index.html",
        controller: 'ClienteImportarController',
        controllerAs: 'controller'
      })

      // Produto
      .state('index.produto_pesquisar', {
        url: "/produto_pesquisar",
        templateUrl: "app/produto/pesquisar/index.html",
        controller: 'ProdutoPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.produto_cadastrar', {
        url: "/produto_cadastrar/:viewId",
        templateUrl: "app/produto/cadastrar/index.html",
        controller: 'ProdutoCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })
      .state('index.categorias', {
        url: "/categorias",
        templateUrl: "app/produto/categoria/index.html",
        controller: 'ProdutoCategoriaPesquisarController',
        controllerAs: 'controller',        
      })

      // Servico
      .state('index.servico_pesquisar', {
        url: "/servico_pesquisar",
        templateUrl: "app/servico/pesquisar/index.html",
        controller: 'ServicoPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.servico_cadastrar', {
        url: "/servico_cadastrar/:viewId",
        templateUrl: "app/servico/cadastrar/index.html",
        controller: 'ServicoCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })

      // Agenda - Calendario
      .state('index.agenda_calendario', {
        url: "/agenda_calendario",
        templateUrl: "app/agenda/calendario/index.html",
        controller: 'AgendaCalendarioController',
        controllerAs: 'controller',        
      })

      // Venda
      .state('index.venda_pesquisar', {
        url: "/venda_pesquisar/:tipo",
        templateUrl: "app/venda/pesquisar/index.html",
        controller: 'VendaPesquisarController',
        controllerAs: 'controller', 
        params: {
          tipo: null,
        }
      })
      .state('index.venda_cadastrar', {
        url: "/venda_cadastrar/:viewId/:tipo",
        templateUrl: "app/venda/cadastrar/index.html",
        controller: 'VendaCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
          tipo: null
        }
      })
      .state('index.venda_cadastrar_old', {
        url: "/venda_cadastrar/:viewId/:tipo",
        templateUrl: "app/venda/cadastrar_old/index.html",
        controller: 'VendaCadastrarOldController',
        controllerAs: 'controller',
        params: {
          viewId: null,
          tipo: null
        }
      })
      .state('index.venda_imprimir', {
        url: "/venda_imprimir/:viewId",
        templateUrl: "app/venda/imprimir/index.html",
        controller: 'VendaImprimirController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })

      // Pedido
      .state('index.pedido_pesquisar', {
        url: "/pedido_pesquisar",
        templateUrl: "app/pedido/pesquisar/index.html",
        controller: 'PedidoPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.pedido_cadastrar', {
        url: "/pedido_cadastrar/:viewId",
        templateUrl: "app/pedido/cadastrar/index.html",
        controller: 'PedidoCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })
      .state('index.pedido_imprimir', {
        url: "/pedido_imprimir/:viewId",
        templateUrl: "app/pedido/imprimir/index.html",
        controller: 'PedidoImprimirController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })

      // Orcamento
      .state('index.orcamento_pesquisar', {
        url: "/orcamento_pesquisar",
        templateUrl: "app/orcamento/pesquisar/index.html",
        controller: 'OrcamentoPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.orcamento_cadastrar', {
        url: "/orcamento_cadastrar/:viewId",
        templateUrl: "app/orcamento/cadastrar/index.html",
        controller: 'OrcamentoCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })
      .state('index.orcamento_imprimir', {
        url: "/orcamento_imprimir/:viewId",
        templateUrl: "app/orcamento/imprimir/index.html",
        controller: 'OrcamentoImprimirController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })

      // Cobranca - Pendentes
      .state('index.cobranca_pendentes', {
        url: "/cobranca_pendentes",
        templateUrl: "app/cobranca/pendentes/index.html",
        controller: 'CobrancaPendentesController',
        controllerAs: 'controller',        
      })
      // Cobranca - A Receber
      .state('index.cobranca_areceber', {
        url: "/cobranca_areceber",
        templateUrl: "app/cobranca/areceber/index.html",
        controller: 'CobrancaAreceberController',
        controllerAs: 'controller',        
      })
      // Cobranca - Vencidos
      .state('index.cobranca_vencidos', {
        url: "/cobranca_vencidos",
        templateUrl: "app/cobranca/vencidos/index.html",
        controller: 'CobrancaVencidosController',
        controllerAs: 'controller',        
      })
      // Cobranca - Recebidos
      .state('index.cobranca_recebidos', {
        url: "/cobranca_recebidos",
        templateUrl: "app/cobranca/recebidos/index.html",
        controller: 'CobrancaRecebidosController',
        controllerAs: 'controller',        
      })


      // Relatorio - Vendas
      .state('index.relatorio_vendas', {
        url: "/relatorio_vendas",
        templateUrl: "app/relatorio/vendas/index.html",
        controller: 'RelatorioVendasController',
        controllerAs: 'controller',
      })
      // Relatorio - Vendas Lucro
      .state('index.relatorio_vendas_lucro', {
        url: "/relatorio_vendas_lucro",
        templateUrl: "app/relatorio/venda_lucro/index.html",
        controller: 'RelatorioVendasLucroController',
        controllerAs: 'controller',
      })
      // Relatorio - Produtos Vendas
      .state('index.relatorio_produtos_vendas', {
        url: "/relatorio_produtos_vendas",
        templateUrl: "app/relatorio/produtos_vendas/index.html",
        controller: 'RelatorioProdutoVendasController',
        controllerAs: 'controller',
      })
      // Relatorio - Servico Vendas
      .state('index.relatorio_servicos_vendas', {
        url: "/relatorio_servicos_vendas",
        templateUrl: "app/relatorio/servicos_vendas/index.html",
        controller: 'RelatorioServicoVendasController',
        controllerAs: 'controller',
      })

      // Exportar Dados
      .state('index.exportar_dados', {
        url: "/exportar_dados",
        templateUrl: "app/exportar/index.html",
        controller: 'ExportarDadosPageController',
        controllerAs: 'controller',
      })
      
      // Catalogo 
      .state('index.catalogo_cadastrar', {
        url: "/catalogo_cadastrar",
        templateUrl: "app/catalogo/index.html",
        controller: 'CatalogoCadastrarController',
        controllerAs: 'controller',        
      })
      // Config > Empresa 
      .state('index.empresa_cadastrar', {
        url: "/empresa_cadastrar",
        templateUrl: "app/config/empresa/index.html",
        controller: 'EmpresaAtualizarController',
        controllerAs: 'controller',        
      })
      // Config > Logo 
      .state('index.logo_cadastrar', {
        url: "/logo_cadastrar",
        templateUrl: "app/config/logo/index.html",
        controller: 'LogoAtualizarController',
        controllerAs: 'controller',        
      })
      // Config > Usuarios 
      .state('index.usuarios_pesquisar', {
        url: "/usuarios_pesquisar",
        templateUrl: "app/config/usuario/index.html",
        controller: 'UsuarioPesquisarController',
        controllerAs: 'controller',        
      })
      // Config > Documento 
      .state('index.config_documento', {
        url: "/config_documento",
        templateUrl: "app/config/documento/index.html",
        controller: 'ConfigDocumentoController',
        controllerAs: 'controller',        
      })


      // Objetivo
      .state('index.objetivo_pesquisar', {
        url: "/objetivo_pesquisar",
        templateUrl: "app/objetivo/pesquisar/index.html",
        controller: 'ObjetivoPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.objetivo_cadastrar', {
        url: "/objetivo_cadastrar/:viewId",
        templateUrl: "app/objetivo/cadastrar/index.html",
        controller: 'ObjetivoCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })

      // Projeto
      .state('index.projeto_pesquisar', {
        url: "/projeto_pesquisar",
        templateUrl: "app/projeto/pesquisar/index.html",
        controller: 'ProjetoPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.projeto_cadastrar', {
        url: "/projeto_cadastrar/:viewId",
        templateUrl: "app/projeto/cadastrar/index.html",
        controller: 'ProjetoCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })

      // Tarefa
      .state('index.tarefa_pesquisar', {
        url: "/tarefa_pesquisar",
        templateUrl: "app/tarefa/pesquisar/index.html",
        controller: 'TarefaPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.tarefa_cadastrar', {
        url: "/tarefa_cadastrar/:viewId",
        templateUrl: "app/tarefa/cadastrar/index.html",
        controller: 'TarefaCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })








      // Atendimento
      .state('index.pesquisaratendimento', {
        url: "/pesquisaratendimento",
        templateUrl: "app/atendimento/pesquisar/index.html",
        controller: 'AtendimentoPesquisaController',
        controllerAs: 'controller',
        data: { pageTitle: 'Pesquisar atendimentos' }
      })
      .state('index.cadastraratendimento', {
        url: "/cadastraratendimento",
        params: {
          contato: null,
          atendimento: null
        },
        templateUrl: "app/atendimento/cadastrar/index.html",
        controller: 'AtendimentoCadastroController',
        controllerAs: 'controller',
        data: { pageTitle: 'Cadastrar atendimento' }
      })
      .state('index.consultaratendimento', {
        url: "/consultaratendimento",
        params: {
          obj: null
        },
        templateUrl: "app/atendimento/consultar.html",
        controller: 'AtendimentoConsultaController',
        controllerAs: 'atendimentoController',
        data: { pageTitle: 'Consultar atendimento' }
      })

      // Agenda
      .state('index.agenda_consultar', {
        url: "/agenda_consultar",
        templateUrl: "app/agenda/consultar/index.html",
        controller: 'AgendaConsultarController',
        controllerAs: 'controller'
      })
      .state('index.agenda_cadastrar', {
        url: "/agenda_cadastrar",
        templateUrl: "app/agenda/cadastrar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })

      // Mapas
      .state('index.mapa_contatos_geral', {
        url: "/mapa_contatos_geral",
        templateUrl: "app/mapa/contato/index.html",
        controller: 'MapaContatosController',
        controllerAs: 'mapaController'
      })


      // Lideranca
      .state('index.lideranca_pesquisar', {
        url: "/lideranca_pesquisar",
        templateUrl: "app/lideranca/pesquisar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })
      .state('index.lideranca_cadastrar', {
        url: "/lideranca_cadastrar",
        templateUrl: "app/lideranca/cadastrar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })

      // Emenda
      .state('index.emenda_pesquisar', {
        url: "/emenda_pesquisar",
        templateUrl: "app/emenda/pesquisar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })
      .state('index.emenda_cadastrar', {
        url: "/emenda_cadastrar",
        templateUrl: "app/emenda/cadastrar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })

      // Documentos
      .state('index.documento_pesquisar', {
        url: "/documento_pesquisar",
        templateUrl: "app/documento/pesquisar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })
      .state('index.documento_cadastrar', {
        url: "/documento_cadastrar",
        templateUrl: "app/documento/cadastrar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })

      // Relatorio
      .state('index.relatorio_teste', {
        url: "/relatorio_teste",
        templateUrl: "app/relatorio/teste/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })


      // Usuarios
      .state('index.pesquisarusuario', {
        url: "/pesquisarusuario",
        templateUrl: "app/usuario/pesquisar.html",
        controller: 'UsuarioPesquisaController',
        controllerAs: 'usuarioPesquisa',
        data: { pageTitle: 'Pesquisar usuários' }
      })
      .state('index.cadastrarusuario', {
        url: "/cadastrarusuario",
        templateUrl: "app/usuario/cadastrar.html",
        controller: 'UsuarioCadastroController',
        controllerAs: 'usuarioCadastro',
        data: { pageTitle: 'Cadastrar Usuário' }
      })
      .state('index.alterarusuario', {
        url: "/alterarusuario",
        templateUrl: "app/usuario/alterar.html",
        controller: 'UsuarioAlteracaoController',
        controllerAs: 'usuarioAlteracao',
        params: {
          obj: null
        },
        data: { pageTitle: 'Editar Usuário' }
      })
      .state('index.alterarsenha', {
        url: "/alterarsenha",
        templateUrl: "app/usuario/alterarsenha.html",
        controller: 'UsuarioAlteracaoSenhaController',
        controllerAs: 'controller',
        data: { pageTitle: 'Alterar Senha' }
      })

      // Index
      .state('index', {
        abstract: true,
        url: "/index",
        templateUrl: "app/components/common/content.html"
      })

      // Tests
      .state('index.minor', {
        url: "/minor",
        templateUrl: "app/minor/minor.html",
        data: { pageTitle: 'Example view' }
      });

      $urlRouterProvider.otherwise('/login/autenticar');
  }

})();

var global_latitude = -23.5515;
var global_longitude = -51.4614;
var global_zoom_map = 12;

angular
.module('inspinia')
.factory('PagerService', PagerService)

// Local
//.constant('APP_ROOT', "https://localhost:44376/api");

// Producao
.constant('APP_ROOT', "https://apiclientesapp.azurewebsites.net/api");



// OLD
//.constant('APP_ROOT', "https://localhost:44376/api");
//.constant('APP_ROOT', "https://clientesapp.com/api");
//.constant('APP_ROOT', "https://customer.plandesk.com.br/customers/api");
//.constant('APP_ROOT', "https://clientesapp.com/v6/api");
//.constant('APP_ROOT', "https://api4.clientesapp.com/v7/api");
//.constant('APP_ROOT', "https://api.kyvva.com/api");

// Testes
//.constant('APP_ROOT', "https://clientes.b2desk.com/api");
//.constant('APP_ROOT', "https://customers0001.azurewebsites.net/api");


function PagerService() {
    // service definition
    var service = {};

    service.GetPager = GetPager;

    return service;

    // service implementation
    function GetPager(totalItems, currentPage, pageSize) {
        // default to first page
        currentPage = currentPage || 1;

        // default page size is 5
        pageSize = pageSize || 20;

        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);

        var startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        var pages = _.range(startPage, endPage + 1);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }
};

angular
.module('inspinia')
.factory('Excel',function($window){
    var uri='data:application/vnd.ms-excel;base64,',
        template='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64=function(s){return $window.btoa(unescape(encodeURIComponent(s)));},
        format=function(s,c){return s.replace(/{(\w+)}/g,function(m,p){return c[p];})};
    return {
        tableToExcel:function(tableId,worksheetName){
            var table=$(tableId),
                ctx={worksheet:worksheetName,table:table.html()},
                href=uri+base64(format(template,ctx));
            return href;
        }
    };
});

angular.module('inspinia').value('cgBusyDefaults',{
    message:'Carregando222',
    templateUrl: 'app/components/common/loading.html'
  });

angular.module('inspinia').directive('icheck', icheck);

angular.module('inspinia')
.config( [
    '$compileProvider',
    function( $compileProvider )
    {   
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|data|image):/);
        // Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)
    }
]);

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}

/* angular-datepicker
angular.module('inspinia')
.config(function ($provide)
{
    $provide.decorator('mFormatFilter', function ()
    {
        return function newFilter(m, format, tz)
        {
            if (!(moment.isMoment(m))) {
                return '';
            }
            return tz ? moment.tz(m, tz).format(format) : m.format(format);
        };
    });
});
*/
'use strict';

angular.module('inspinia').filter('cut', function () {
    return function (value, wordwise, max, tail) {
        if (!value) return '';

        max = parseInt(max, 10);
        if (!max) return value;
        if (value.length <= max) return value;

        value = value.substr(0, max);
        if (wordwise) {
            var lastspace = value.lastIndexOf(' ');
            if (lastspace !== -1) {
              //Also remove . and , so its gives a cleaner result.
              if (value.charAt(lastspace-1) === '.' || value.charAt(lastspace-1) === ',') {
                lastspace = lastspace - 1;
              }
              value = value.substr(0, lastspace);
            }
        }

        return value + (tail || ' …');
    };
});

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
.directive('icheck', icheck)
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })

    .directive('moneyMask', ['$timeout', 'moneyMaskService', function($timeout, moneyMaskService) {
        return {
          require: 'ngModel',
          link: function(scope, element, attrs, ctrl) {
              var execute = function () {
                  scope.$apply(function () {
                      ctrl.$setViewValue(moneyMaskService.fromStringToMoney(ctrl.$modelValue));
                      ctrl.$render();
                  });
              };
              element.bind('keyup', function () {
                  execute();
              });
              
              $timeout(function () { 
                  execute();
              }, 500);
           }
        };
     }])
     .factory("moneyMaskService", [ "$filter", function ($filter) {
        var _otherCharacters = /[^0-9]/g;
        var _zeros = /^0+/;
        
        var _fromStringToMoney = function (string) {
            return $filter("currency")((_fromStringToNumber(string)/100).toFixed(2), "");
            //return $filter("currency")((_fromStringToNumber(string)/100).toFixed(2));
        };
        
        var _fromStringToNumber = function (string) {
            if (!string) return 0;
            return string.toString().replace(_otherCharacters, '').replace(_zeros, '') || 0;
        }
        
        return {
            fromStringToMoney: _fromStringToMoney
        };
    }])
    .directive("setModelOnChange", function() {
        return {
            require: "ngModel",
            link: function postLink(scope,elem,attrs,ngModel) {
            elem.on("change", function(e) {
                console.log("on change (from directive)", e);  
                var files = elem[0].files;
                ngModel.$setViewValue(files);
            })
            }
        }
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-success " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    });


/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}
angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/atendimento/consultar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Consulta de Atendimento</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Atendimento</a></li><li class=\"active\"><strong>Consulta</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-user\"></i> Contato</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Nome</label><div class=\"col-lg-5\"><input type=\"text\" disabled=\"disabled\" ng-model=\"atendimentoController.atendimento.contato.nome\" class=\"form-control\"></div><label class=\"col-lg-1 control-label\">CPF</label><div class=\"col-lg-5\"><input type=\"text\" disabled=\"disabled\" ng-model=\"atendimentoController.atendimento.contato.cpf\" class=\"form-control\"></div></div></form></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\"><h5><i class=\"fa fa-comments\"></i> Atendimento</h5></div><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Data</label><div class=\"col-lg-5\"><input type=\"text\" disabled=\"disabled\" ng-model=\"atendimentoController.atendimento.dataAtendimento\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Assunto</label><div class=\"col-lg-5\"><input type=\"text\" disabled=\"disabled\" ng-model=\"atendimentoController.atendimento.assunto\" class=\"form-control\"></div><label class=\"col-lg-1 control-label\">Origem</label><div class=\"col-lg-5\"><input type=\"text\" disabled=\"disabled\" ng-model=\"atendimentoController.atendimento.origem.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Descrição</label><div class=\"col-lg-11\"><textarea disabled=\"disabled\" ng-model=\"atendimentoController.atendimento.descricao\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" rows=\"8\" maxlength=\"500\" aria-invalid=\"false\">\r\n                                </textarea></div></div><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Situação</label><div class=\"col-lg-5\"><input type=\"text\" disabled=\"disabled\" ng-model=\"atendimentoController.atendimento.situacao.nome\" class=\"form-control\"></div><label class=\"col-lg-1 control-label\">Responsável</label><div class=\"col-lg-5\"><input type=\"text\" disabled=\"disabled\" ng-model=\"atendimentoController.atendimento.responsavel.nome\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-map\"></i> Local de Referência</h5></div><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Referência</label><div class=\"col-lg-5\"><input type=\"text\" disabled=\"disabled\" ng-model=\"atendimentoController.atendimento.enderecoReferencia\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Mapa</label><div class=\"col-lg-11\"><leaflet lf-center=\"mapProjects\" markers=\"markers\" width=\"100%\" height=\"280px\"></leaflet></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-primary\"><h5><i class=\"fa fa-folder\"></i> Documentos</h5></div><div class=\"ibox-content\"><br><div class=\"col-lg-12\" cg-busy=\"atendimentoController.uploadPromise\"><div class=\"file-box\" ng:repeat=\"p in atendimentoController.atendimento.arquivos\"><div class=\"file\"><a href=\"\" ng-click=\"tarefaConsulta.edit(p)\"><span class=\"corner\"></span><div class=\"image\" ng-hide=\"{{p.tipo != \'img\'}}\"><img alt=\"image\" class=\"img-responsive\" data-ng-src=\"{{p.base64}}\"></div><div class=\"icon\" ng-hide=\"{{p.tipo == \'img\'}}\"><i class=\"fa fa-file\"></i></div><div class=\"file-name\">{{ p.nome | limitTo: 20 }}{{p.nome.length > 20 ? \'...\' : \'\'}}</div></a></div></div></div><div style=\"clear: both;\"></div></div></div></div></div></div>");
$templateCache.put("app/catalogo/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Catálogo</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Catálogo</a></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-edit\"></i> Configurar</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Identificador</label><table><tr><td><input type=\"text\" maxlength=\"250\" ng-model=\"controller.identificador\" placeholder=\"\" class=\"form-control\"></td><td><b>.kyvva.com</b></td></tr></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 160px;\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Atualizar</button></div></div></div></div></div>");
$templateCache.put("app/exportar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Exportar Dados</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li class=\"active\"><strong>Exportar Dados</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" cg-busy=\"controller.contatoPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-file-excel-o\"></i> Exportar Dados</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxEndereco\" class=\"ibox-content\" cg-busy=\"controller.cepPromise\"><b>Os arquivos são gerados no formato Excel.</b><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 99%\">Arquivo</th></tr></thead><tbody><tr><td>Clientes</td><td style=\"text-align: center; white-space: nowrap\"><a style=\"width: 180px;\" ng-click=\"controller.getClientes()\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-download\"></i> Download</a></td></tr><tr><td>Produtos</td><td style=\"text-align: center; white-space: nowrap\"><a style=\"width: 180px;\" ng-click=\"controller.getProdutos()\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-download\"></i> Download</a></td></tr><tr><td>Serviços</td><td style=\"text-align: center; white-space: nowrap\"><a style=\"width: 180px;\" ng-click=\"controller.getServicos()\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-download\"></i> Download</a></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/main/main.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\" ng-if=\"!home.isAssinante\"><div class=\"col-lg-12\"><div class=\"alert alert-danger\"><b>Atenção:</b> Este portal é exclusivo para assinantes do aplicativo.</div></div></div><div class=\"row\"><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" cg-busy=\"home.indicadoresPromise\"><div class=\"ibox-title\"><span class=\"label label-primary pull-right\">clientes</span><h5>Clientes</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{home.indicadores.clientes}}</h1><small>cadastrados</small></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" cg-busy=\"home.indicadoresPromise\"><div class=\"ibox-title\"><span class=\"label label-warning pull-right\">agenda</span><h5>Agendamentos</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{home.indicadores.agendamentos}}</h1><small>para hoje</small></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" cg-busy=\"home.indicadoresPromise\"><div class=\"ibox-title\"><span class=\"label label-success pull-right\">pedidos</span><h5>Pedidos</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{home.indicadores.pedidos}}</h1><div class=\"stat-percent font-bold text-success\">{{homeController.indicador_atendimentos_pendentes}} <i class=\"fa fa-comments\"></i></div><small>pendentes</small></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" cg-busy=\"home.indicadoresPromise\"><div class=\"ibox-title\"><span class=\"label label-success pull-right\">vendas</span><h5>Vendas</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{home.indicadores.faturamentoMes}}</h1><div class=\"stat-percent font-bold text-success\">{{homeController.indicador_atendimentos_pendentes}} <i class=\"fa fa-comments\"></i></div><small>no mês</small></div></div></div></div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 15px;\" cg-busy=\"home.clientesPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-area-chart\"></i> Novos Clientes</h5></div><div id=\"boxPendentes\" class=\"ibox-content\"><canvas class=\"chart chart-bar\" height=\"150\" chart-colors=\"home.graficoCliente.colors\" chart-data=\"home.graficoCliente.data\" chart-labels=\"home.graficoCliente.labels\" chart-series=\"home.graficoCliente.series\" chart-click=\"home.graficoCliente.onClick\" chart-options=\"home.chartOptions\"></canvas></div></div></div><div class=\"col-lg-6\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 15px;\" cg-busy=\"home.vendasPromise\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-area-chart\"></i> Vendas</h5></div><div id=\"boxPendentes\" class=\"ibox-content\"><canvas class=\"chart chart-line\" height=\"150\" chart-colors=\"home.graficoVenda.colors\" chart-data=\"home.graficoVenda.data\" chart-labels=\"home.graficoVenda.labels\" chart-series=\"home.graficoVenda.series\" chart-click=\"home.graficoVenda.onClick\" chart-options=\"home.chartReaisOptions\"></canvas></div></div></div></div></div>");
$templateCache.put("app/reset_senha/index.html","<style>\r\n    body\r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 15px; padding-bottom: 0px;\"><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-title success-bg\"><h5><i class=\"fa fa-lock\"></i> Recuperação de senha</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Informe seu e-mail cadastrado no aplicativo para receber o procedimento de reinicialçização da senha de acesso.</label><br></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail de cadastro</label> <input type=\"password\" maxlength=\"10\" ng-model=\"alterarSenhaController.registro.email\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"form-group\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 240px;\" ng-click=\"alterarSenhaController.enviar()\"><i class=\"fa fa-arrow-right\"></i> Enviar</button></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/usuario/alterar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Alterar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Alterar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Informações</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Nome\" placeholder=\"Nome completo\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Login\" placeholder=\"Login para acesso\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Email\" placeholder=\"E-mail\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Telegram</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.TelegramUser\" placeholder=\"Usuário do Telegram\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"usuarioAlteracao.alterar()\">ATUALIZAR</button></div></div></div></div></div>");
$templateCache.put("app/usuario/alterarsenha.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Alterar Senha</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Alterar Senha</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Alteração de Senha</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha antiga</label><div class=\"col-lg-4\"><input type=\"password\" maxlength=\"12\" ng-model=\"controller.oldPassword\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nova senha</label><div class=\"col-lg-4\"><input type=\"password\" maxlength=\"12\" ng-model=\"controller.newPassword\" class=\"form-control\"></div></div><div class=\"form-group\" style=\"margin-bottom: 0px;\"><div class=\"col-lg-6\" style=\"text-align: right\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar Senha</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/usuario/autenticar.html","<style>\r\n    body \r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"middle-box text-center animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px; margin-top: 30px;\"><div style=\"padding-right: 25px; padding-left: 25px;\"><div style=\"margin-top: 10px; margin-bottom: 0px;\"><img height=\"240px\" width=\"100%\" style=\"margin-bottom: 0px\" src=\"assets/images/icons/logo.jpg\"></div><div style=\"height: 16px;\"></div><b style=\"font-size: 16px;\">Controle de Clientes</b><div style=\"height: 10px;\"></div><p>Entre com sua conta</p><form class=\"m-t-xs\" role=\"form\" cg-busy=\"main.loginPromise\"><div class=\"form-group\"><input ng-model=\"main.usuario.Login\" type=\"text\" class=\"form-control\" placeholder=\"E-mail\" required=\"\"></div><div class=\"form-group\" style=\"text-align: right;\"><input ng-model=\"main.usuario.Password\" type=\"password\" class=\"form-control\" placeholder=\"Senha\" required=\"\"></div><button type=\"submit\" ng-click=\"main.login()\" class=\"btn btn-success block full-width\">Login</button></form><a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=com.plandesk.customersapp&hl=pt_BR&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1\"><img style=\"width: 160px;\" alt=\"Disponível no Google Play\" src=\"https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png\"></a><div style=\"height: 8px;\"></div></div></div></div></div></div></div>");
$templateCache.put("app/usuario/cadastrar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Informações</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Nome\" placeholder=\"Nome completo\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Login\" placeholder=\"Login para acesso\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Email\" placeholder=\"E-mail\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Password\" placeholder=\"Senha\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"usuarioCadastro.incluir()\">SALVAR</button></div></div></div></div></div>");
$templateCache.put("app/usuario/pesquisar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"><a class=\"btn btn-sm btn-success\" ng-click=\"usuarioPesquisa.incluir()\">NOVO USUÁRIO</a></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Resultado</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 40%\">Nome</th><th style=\"width: 30%\">Login</th><th style=\"width: 30%\">E-mail</th></tr></thead><tbody><tr ng:repeat=\"p in usuarioPesquisa.items\"><td>{{p.nome}}</td><td>{{p.login}}</td><td>{{p.Email}}</td><td style=\"text-align: center;\"><a ng-click=\"usuarioPesquisa.alterar(p)\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div><ul ng-if=\"usuarioPesquisa.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === 1}\"><a ng-click=\"usuarioPesquisa.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === 1}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in usuarioPesquisa.pager.pages\" ng-class=\"{active:usuarioPesquisa.pager.currentPage === page}\"><a ng-click=\"usuarioPesquisa.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === usuarioPesquisa.pager.totalPages}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === usuarioPesquisa.pager.totalPages}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/agenda/calendario/index.html","<div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5><i class=\"fa fa-calendar\"></i> Agendamentos</h5><div class=\"ibox-tools\"><button class=\"btn btn-xs btn-primary\" type=\"button\" ng-click=\"controller.novo()\"><i class=\"fa fa-plus\"></i> Novo Agendamento</button></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-12\"><div ui-calendar=\"uiConfig.calendar\" ng-model=\"eventSources\" ng-if=\"eventSources.length > 0\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/atendimento/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Atendimento</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Atendimento</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDados\', \'boxDados\')\"><h5><i class=\"fa fa-user\"></i> Contato</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDados\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDados\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Nome</label><div class=\"col-lg-5\"><input type=\"text\" disabled=\"\" ng-model=\"controller.contato.Nome\" class=\"form-control\"></div><label class=\"col-lg-1 control-label\">CPF</label><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"controller.contato.CPF\" disabled=\"\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-comments\"></i> Dados do Atendimento</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Assunto</label><div class=\"col-lg-5\"><input type=\"text\" maxlength=\"50\" ng-model=\"controller.atendimento.assunto\" placeholder=\"Assunto do atendimento\" class=\"form-control\"></div><label class=\"col-lg-1 control-label\">Origem</label><div class=\"col-lg-5\"><select class=\"form-control\" ng-model=\"controller.atendimento.origem\" ng-options=\"item.id as item.valor for item in controller.origensAtendimento\"></select></div></div><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Data</label><div class=\"col-lg-5\"><input type=\"date\" ng-model=\"controller.atendimento.dataAtendimento\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Descrição</label><div class=\"col-lg-11\"><textarea ng-model=\"controller.atendimento.descricao\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" rows=\"8\" maxlength=\"500\" placeholder=\"Informe detalhes do atendimento\" aria-invalid=\"false\">\r\n                                </textarea></div></div><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Situação</label><div class=\"col-lg-5\"><select class=\"form-control\" ng-model=\"controller.atendimento.situacao\" ng-options=\"item.id as item.valor for item in controller.situacoesAtendimento\"></select></div><label class=\"col-lg-1 control-label\">Responsável</label><div class=\"col-lg-5\"><select class=\"form-control\" ng-model=\"controller.atendimento.responsavel.viewId\" ng-options=\"item.viewId as item.nome for item in controller.usuarios\"></select></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxLocal\', \'boxLocal\')\"><h5><i class=\"fa fa-map-marker\"></i> Local de Referência</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxLocal\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxLocal\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Referência</label><div class=\"col-lg-6\"><div class=\"input-group\"><input type=\"text\" maxlength=\"200\" ng-model=\"controller.atendimento.enderecoReferencia\" ng-blur=\"controller.consultarLocal()\" class=\"form-control\"> <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span></div></div></div><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Mapa</label><div class=\"col-lg-11\"><leaflet lf-center=\"mapProjects\" markers=\"markers\" width=\"100%\" height=\"280px\"></leaflet></div></div><div class=\"form-group\"><label class=\"col-lg-1 control-label\">Latitude</label><div class=\"col-lg-5\"><input type=\"text\" disabled=\"\" ng-model=\"controller.atendimento.latitude\" class=\"form-control\"></div><label class=\"col-lg-1 control-label\">Longitude</label><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"controller.atendimento.longitude\" disabled=\"\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumento\', \'boxDocumento\')\"><h5><i class=\"fa fa-folder\"></i> Documentos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDocumento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDocumento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"form-group\"><div class=\"col-lg-6\"><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><div class=\"form-control\" data-trigger=\"fileinput\"><i class=\"glyphicon glyphicon-file fileinput-exists\"></i> <span class=\"fileinput-filename\"></span></div><span class=\"input-group-addon btn btn-file btn-primary\" style=\"background-color: #1ab394; color: white;\"><span class=\"fileinput-new\"><i class=\"fa fa-upload\"></i> Enviar Arquivo</span> <span class=\"fileinput-exists\"><i class=\"fa fa-upload\"></i> Enviar Arquivo</span> <input type=\"file\" name=\"...\" onchange=\"angular.element(this).scope().uploadFile(this.files)\"></span></div></div></div><br><br><div class=\"col-lg-12\" cg-busy=\"controller.uploadPromise\"><div class=\"file-box\" ng:repeat=\"p in controller.atendimento.arquivos\"><div class=\"file\"><a href=\"\" ng-click=\"tarefaConsulta.edit(p)\"><span class=\"corner\"></span><div class=\"image\" ng-hide=\"{{p.tipo != \'img\'}}\"><img alt=\"image\" class=\"img-responsive\" data-ng-src=\"{{p.base64}}\"></div><div class=\"icon\" ng-hide=\"{{p.tipo == \'img\'}}\"><i class=\"fa fa-file\"></i></div><div class=\"file-name\">{{ p.nome | limitTo: 20 }}{{p.nome.length > 20 ? \'...\' : \'\'}}</div></a></div></div></div><div style=\"clear: both;\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.incluir()\"><i class=\"fa fa-save\"></i> Salvar</button></div></div></div></div></div>");
$templateCache.put("app/atendimento/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Atendimento</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Atendimento</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Contato</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Atendimentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 35%\">Assunto</th><th style=\"width: 15%\">Origem</th><th style=\"width: 1%\">Situação</th><th style=\"width: 20%\">Contato</th><th style=\"width: 15%\">Usuário</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.assunto}}</td><td>{{p.origemTexto}}</td><td><button ng-if=\"p.situacao == 1\" style=\"width: 120px;\" class=\"btn btn-xs btn-rounded btn-warning\">{{p.situacaoTexto}}</button> <button ng-if=\"p.situacao == 2\" style=\"width: 120px;\" class=\"btn btn-xs btn-rounded btn-success\">{{p.situacaoTexto}}</button> <button ng-if=\"p.situacao == 3\" style=\"width: 120px;\" class=\"btn btn-xs btn-rounded btn-primary\">{{p.situacaoTexto}}</button></td><td>{{p.contato.nome}}</td><td>{{p.responsavel.nome}}</td><td style=\"text-align: center; white-space: nowrap\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cliente/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Clientes</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cliente</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-user\"></i> Dados do Cliente</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Cliente</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.nome\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Celular</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.celular\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.telefone\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.email\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Nascimento</label> <input type=\"date\" ng-model=\"controller.registro.dataNascimento\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Sexo</label><select class=\"form-control\" ng-model=\"controller.registro.sexo\"><option ng-value=\"1\">Não informado</option><option ng-value=\"2\">Masculino</option><option ng-value=\"3\">Feminino</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Observação</label> <textarea class=\"form-control\" ng-model=\"controller.registro.observacao\" rows=\"2\" maxlength=\"1000\"></textarea></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumentos\', \'boxDocumentos\')\"><h5><i class=\"fa fa-file\"></i> Documentos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDocumentos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDocumentos\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" mask=\"999.999.999-99\" ng-model=\"controller.registro.cpf\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">RG</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.rg\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.registro.cnpj\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxEndereco\" class=\"ibox-content\" cg-busy=\"controller.cepPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label><div class=\"input-group\"><input type=\"text\" maxlength=\"100\" ng-model=\"controller.registro.enderecoCep\" ng-blur=\"controller.consultarCep()\" mask=\"99999-999\" class=\"form-control\"> <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.enderecoLogradouro\" placeholder=\"Logradouro\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" maxlength=\"100\" ng-model=\"controller.registro.enderecoNumero\" placeholder=\"Número\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" maxlength=\"100\" ng-model=\"controller.registro.enderecoComplemento\" placeholder=\"Complemento\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.registro.enderecoBairro\" placeholder=\"Bairro\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.registro.enderecoCidade\" placeholder=\"Cidade\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Estado</label> <input type=\"text\" ng-model=\"controller.registro.enderecoEstado\" placeholder=\"Estado\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFoto\', \'boxFoto\')\"><h5><i class=\"fa fa-photo\"></i> Foto</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFoto\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFoto\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><input type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this.files)\" class=\"form-control\"><br><img class=\"img-responsive\" ng-if=\"controller.foto != null\" ng-src=\"{{controller.foto}}\"></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button ng-if=\"controller.isUpdate\" class=\"btn btn-md btn-danger\" type=\"button\" style=\"float: left;\" ng-click=\"controller.excluir()\"><i class=\"fa fa-trash\"></i> Excluir Registro</button> <button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar Informações</button></div></div></div></div></div>");
$templateCache.put("app/cliente/importar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Importação de Clientes via arquivo CSV</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Clientes</a></li><li class=\"active\"><strong>Importar CSV</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.validarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-file\"></i> Enviar Arquivo</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-12\">Para realizar a importação do cadastro de seus clientes via arquivo CSV, primeiramente baixe o modelo do arquivo .csv clicando neste link:<br><br><a class=\"btn btn-warning\" href=\"../../../assets/files/modelo_importar_clientes.csv\" download=\"modelo_importar_cliente.csv\"><i class=\"fa fa-download\"></i> BAIXAR MODELO DE ARQUIVO</a><br><br>Após preencher o arquivo com os dados de seus clientes, faça o envio utilizando o botão abaixo:<br><br></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Selecionar arquivo CSV:</label> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarItem()\" placeholder=\"\" accept=\".csv\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.registros.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>Celular</th><th>Telefone</th><th>E-mail</th><th>CPF</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.nome}}</td><td>{{p.celular}}</td><td>{{p.telefone}}</td><td>{{p.email}}</td><td>{{p.cpf}}</td></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.importar()\"><i class=\"fa fa-save\"></i> Importar Clientes</button></div></div></div></div></div>");
$templateCache.put("app/cliente/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Clientes</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cliente</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" mask=\"999.999.999-99\" ng-model=\"controller.filtro.cpf\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>Celular</th><th>E-mail</th><th>CPF</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.nome}}</td><td>{{p.celular}}</td><td>{{p.email}}</td><td>{{p.cpf}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cobranca/pendentes/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pendentes</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cobrança</a></li><li class=\"active\"><strong>Pendentes</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cliente</label> <input type=\"text\" ng-model=\"controller.filtro.cliente\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Tipo</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Forma Pagamento</th><th class=\"white-bg\">Cliente</th><th class=\"white-bg\">Situação</th><th class=\"white-bg\">Venda</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td class=\"ng-binding\">{{ p.dataVencimento | date: \'dd/MM/yyyy\' }}</td><td class=\"ng-binding\">{{ p.tipoPagamentoTexto }}</td><td class=\"ng-binding\">{{ p.valor | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.formaPagamentoTexto }}</td><td class=\"ng-binding\">{{ p.agenda != null ? p.agenda.cliente.nome : p.venda.cliente.nome }}</td><td class=\"ng-binding\" style=\"width: 130px;\"><button ng-class=\"p.situacao == 1 ? \'btn-warning\' : \'btn-primary\'\" class=\"btn btn-xs btn-block\">{{p.situacaoTexto}}</button></td><td class=\"ng-binding\">{{ p.agenda != null ? \'Agenda\' : (\"#\" + p.venda.numero) }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.consultarVenda(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Consultar</button> <button ng-click=\"controller.removerPagamento(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cobranca/areceber/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>A Receber</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cobrança</a></li><li class=\"active\"><strong>A Receber</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.filtro.numero\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Número</th><th>Data</th><th>Total</th><th>Cliente</th><th>Situação</th><th>Usuário</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>#{{p.numero}}</td><td>{{p.dataVenda | date: \'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{p.valorTotal | currency : \'R$ \' : 2}}</td><td>{{p.cliente.nome}} {{p.cliente.cpf != null && p.cliente.cpf != \'\' ? \' (\' + p.cliente.cpf + \')\' : \'\'}}</td><td style=\"width: 130px;\"><button ng-class=\"p.situacaoPagamento == 2 ? \'btn-primary\' : (p.situacaoPagamento == 5 ? \'btn-danger\' : (p.situacaoPagamento == 3 ? \'btn-success\' : \'btn-warning\'))\" class=\"btn btn-xs btn-block btn-rounded\">{{p.situacaoPagamentoTexto}}</button></td><td>{{p.usuarioCadastro.nome}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a> <a ng-click=\"controller.alterar(p)\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cobranca/vencidos/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Vencidos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cobrança</a></li><li class=\"active\"><strong>Vencidos</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cliente</label> <input type=\"text\" ng-model=\"controller.filtro.cliente\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Tipo</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Forma Pagamento</th><th class=\"white-bg\">Cliente</th><th class=\"white-bg\">Situação</th><th class=\"white-bg\">Venda</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td class=\"ng-binding\">{{ p.dataVencimento | date: \'dd/MM/yyyy\' }}</td><td class=\"ng-binding\">{{ p.tipoPagamentoTexto }}</td><td class=\"ng-binding\">{{ p.valor | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.formaPagamentoTexto }}</td><td class=\"ng-binding\">{{ p.agenda != null ? p.agenda.cliente.nome : p.venda.cliente.nome }}</td><td class=\"ng-binding\" style=\"width: 130px;\"><button ng-class=\"p.situacao == 1 ? \'btn-warning\' : \'btn-primary\'\" class=\"btn btn-xs btn-block\">{{p.situacaoTexto}}</button></td><td class=\"ng-binding\">{{ p.agenda != null ? \'Agenda\' : (\"#\" + p.venda.numero) }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.consultarVenda(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Consultar</button> <button ng-click=\"controller.removerPagamento(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cobranca/recebidos/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Recebidos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Cobrança</a></li><li class=\"active\"><strong>Recebidos</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cliente</label> <input type=\"text\" ng-model=\"controller.filtro.cliente\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Ano</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.anoFiltro\"><option value=\"2021\">2021</option><option value=\"2022\">2022</option><option value=\"2023\">2023</option><option value=\"2024\">2024</option><option value=\"2025\">2025</option><option value=\"2026\">2026</option></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Mês</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.mesFiltro\"><option value=\"1\">Janeiro</option><option value=\"2\">Feveiro</option><option value=\"3\">Março</option><option value=\"4\">Abril</option><option value=\"5\">Maio</option><option value=\"6\">Junho</option><option value=\"7\">Julho</option><option value=\"8\">Agosto</option><option value=\"9\">Setembro</option><option value=\"10\">Outubro</option><option value=\"11\">Novembro</option><option value=\"12\">Dezembro</option></select></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Tipo</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Forma Pagamento</th><th class=\"white-bg\">Cliente</th><th class=\"white-bg\">Situação</th><th class=\"white-bg\">Venda</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td class=\"ng-binding\">{{ p.dataVencimento | date: \'dd/MM/yyyy\' }}</td><td class=\"ng-binding\">{{ p.tipoPagamentoTexto }}</td><td class=\"ng-binding\">{{ p.valor | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.formaPagamentoTexto }}</td><td class=\"ng-binding\">{{ p.agenda != null ? p.agenda.cliente.nome : p.venda.cliente.nome }}</td><td class=\"ng-binding\" style=\"width: 130px;\"><button ng-class=\"p.situacao == 1 ? \'btn-warning\' : \'btn-primary\'\" class=\"btn btn-xs btn-block\">{{p.situacaoTexto}}</button></td><td class=\"ng-binding\">{{ p.agenda != null ? \'Agenda\' : (\"#\" + p.venda.numero) }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.consultarVenda(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Consultar</button> <button ng-click=\"controller.removerPagamento(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">Gestão de Clientes v1.0.0</div><div><strong>Copyright</strong> &copy; 2021</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/loading.html","<div style=\"background-image:url(\'assets/images/icons/loading.gif\');background-size: 50px 50px;margin: 0 auto;background-position:50% 20px;background-repeat:no-repeat\"></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><div style=\"text-align: center;\"><img alt=\"image\" width=\"100px\" class=\"img-circle\" src=\"assets\\images\\icons\\icon_rb.png\"> <span class=\"block m-t-md\"><strong class=\"font-bold\" style=\"color: white;\">{{main.userName}}</strong></span> <span class=\"text-muted text-xs block\">{{main.empresaName}}</span></div></div><div class=\"logo-element\">CLI</div></li><li ui-sref-active=\"active\"><a ui-sref=\"index.main\" href=\"#/index/main\"><i class=\"fa fa-home\"></i> <span class=\"nav-label\">Home</span></a></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-user\"></i> <span class=\"nav-label\">Clientes</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.cliente_cadastrar\">Cadastrar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cliente_pesquisar\">Pesquisar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-tags\"></i> <span class=\"nav-label\">Produtos</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.produto_cadastrar\">Cadastrar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.produto_pesquisar\">Pesquisar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.categorias\">Categorias</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-list\"></i> <span class=\"nav-label\">Serviços</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.servico_cadastrar\">Cadastrar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.servico_pesquisar\">Pesquisar</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"index.agenda_calendario\"><i class=\"fa fa-calendar\"></i> <span class=\"nav-label\">Agendamentos</span></a></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-ticket\"></i> <span class=\"nav-label\">Pedidos</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.venda_cadastrar({viewId: null, tipo: 1})\">Cadastrar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.venda_pesquisar({tipo: 1})\">Pesquisar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-edit\"></i> <span class=\"nav-label\">Orçamentos</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.venda_cadastrar({viewId: null, tipo: 2})\">Cadastrar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.venda_pesquisar({tipo: 2})\">Pesquisar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-dollar\"></i> <span class=\"nav-label\">Vendas</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.venda_cadastrar({viewId: null, tipo: 0})\">Cadastrar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.venda_pesquisar({tipo: 0})\">Pesquisar</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-money\"></i> <span class=\"nav-label\">Cobrança</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.cobranca_pendentes\">Pendentes</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cobranca_vencidos\">Vencidos</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cobranca_recebidos\">Recebidos</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-area-chart\"></i> <span class=\"nav-label\">Relatórios</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.relatorio_vendas\">Vendas</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.relatorio_vendas_lucro\">Vendas / Lucro</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.relatorio_produtos_vendas\">Produtos / Vendas</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.relatorio_servicos_vendas\">Serviços / Vendas</a></li></ul></li><li ui-sref-active=\"active\" ng-show=\"main.role == \'1\'\"><a ui-sref=\"index.exportar_dados\"><i class=\"fa fa-file-excel-o\"></i> <span class=\"nav-label\">Exportar Dados</span></a></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-show=\"main.role == \'1\'\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-wrench\"></i> <span class=\"nav-label\">Configurações</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.empresa_cadastrar\">Empresa</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.logo_cadastrar\">Logo da Empresa</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.catalogo_cadastrar\">Catálogo Digital</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.config_documento\">Documentos</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.usuarios_pesquisar\">Usuários</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-user\"></i> <span class=\"nav-label\">Minha Conta</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.alterarsenha\">Alterar Senha</a></li></ul></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span><form role=\"search\" class=\"navbar-form-custom\" method=\"post\" action=\"\"><div class=\"form-group\"><input type=\"text\" placeholder=\"\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li><a ui-sref=\"login.autenticar\"><i class=\"fa fa-sign-out\"></i> Log out</a></li></ul></nav></div>");
$templateCache.put("app/config/documento/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Personalização Documentos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Documentos</a></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxTemplate\', \'boxTemplate\')\"><h5><i class=\"fa fa-edit\"></i> Template</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxTemplate\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxTemplate\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><select class=\"form-control\" ng-change=\"controller.changeTemplate()\" ng-model=\"controller.registro.templateId\"><option ng-value=\"7\">Classic</option><option ng-value=\"4\">Basic I</option><option ng-value=\"11\">Basic II</option><option ng-value=\"6\">Basic I Purple</option><option ng-value=\"8\">Basic I DarkBlue</option><option ng-value=\"9\">Basic I Green</option><option ng-value=\"5\">Basic I Blue</option></select></div></div><div class=\"row\"><div class=\"col-sm-6\"><img height=\"240px\" width=\"150px\" style=\"margin-bottom: 0px; margin-top: 10px;\" src=\"{{controller.templateUrl}}\"></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-edit\"></i> Dados da Empresa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.nome\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.cnpj\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.telefone\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.email\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Website</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.website\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">WhatsApp</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.whatsApp\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Facebook</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.facebook\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Instagram</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.instagram\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxConfig\', \'boxConfig\')\"><h5><i class=\"fa fa-edit\"></i> Configurações</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxConfig\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxConfig\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Exibir CPF/CNPJ do Cliente?</label><select class=\"form-control\" ng-model=\"controller.registro.isExibirCPFCliente\"><option value=\"{{true}}\" ng-selected=\"controller.registro.isExibirCPFCliente === true\">Sim</option><option value=\"{{false}}\" ng-selected=\"controller.registro.isExibirCPFCliente === false\">Não</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Exibir Celular do Cliente?</label><select class=\"form-control\" ng-model=\"controller.registro.isExibirCelularCliente\"><option value=\"{{true}}\" ng-selected=\"controller.registro.isExibirCelularCliente === true\">Sim</option><option value=\"{{false}}\" ng-selected=\"controller.registro.isExibirCelularCliente === false\">Não</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Exibir Endereço do Cliente?</label><select class=\"form-control\" ng-model=\"controller.registro.isExibirEnderecoCliente\"><option value=\"{{true}}\" ng-selected=\"controller.registro.isExibirEnderecoCliente === true\">Sim</option><option value=\"{{false}}\" ng-selected=\"controller.registro.isExibirEnderecoCliente === false\">Não</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Exibir Descrição dos Produtos/Serviços?</label><select class=\"form-control\" ng-model=\"controller.registro.isExibirDescricaoProdServ\"><option value=\"{{true}}\" ng-selected=\"controller.registro.isExibirDescricaoProdServ === true\">Sim</option><option value=\"{{false}}\" ng-selected=\"controller.registro.isExibirDescricaoProdServ === false\">Não</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Exibir Foto dos Produtos?</label><select class=\"form-control\" ng-model=\"controller.registro.isExibirFotoProduto\"><option value=\"{{true}}\" ng-selected=\"controller.registro.isExibirFotoProduto === true\">Sim</option><option value=\"{{false}}\" ng-selected=\"controller.registro.isExibirFotoProduto === false\">Não</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Exibir Foto dos Serviços?</label><select class=\"form-control\" ng-model=\"controller.registro.isExibirFotoServico\"><option value=\"{{true}}\" ng-selected=\"controller.registro.isExibirFotoServico === true\">Sim</option><option value=\"{{false}}\" ng-selected=\"controller.registro.isExibirFotoServico === false\">Não</option></select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 160px;\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Atualizar</button></div></div></div></div></div>");
$templateCache.put("app/config/empresa/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Empresa</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Empresa</a></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-edit\"></i> Dados da Empresa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome da Empresa</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.nome\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.cnpj\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-edit\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxEndereco\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label><div class=\"input-group\"><input type=\"text\" maxlength=\"100\" ng-model=\"controller.registro.enderecoCep\" ng-blur=\"controller.consultarCep()\" mask=\"99999-999\" class=\"form-control\"> <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span></div></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.enderecoLogradouro\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.enderecoNumero\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.enderecoComplemento\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.enderecoBairro\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.enderecoCidade\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Estado</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.enderecoEstado\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 160px;\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Atualizar</button></div></div></div></div></div>");
$templateCache.put("app/config/usuario/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Usuários</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Configurações</a></li><li class=\"active\"><strong>Usuários</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>E-mail</th><th>Tipo</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.nome}}</td><td>{{p.email}}</td><td>{{p.isAdmin ? \'Administrador\' : \'Normal\'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.editar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/contato/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Contato</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Contato</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" cg-busy=\"controller.contatoPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFoto\', \'boxFoto\')\"><h5><i class=\"fa fa-photo\"></i> Foto</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFoto\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFoto\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\" ng-if=\"controller.contato.foto != null\"><div class=\"col-sm-6\"><div class=\"form-group\"><img alt=\"image\" width=\"240px\" class=\"img-responsive\" data-ng-src=\"{{controller.contato.foto.base64}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Anexar Foto</label> <input type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this.files)\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDados\', \'boxDados\')\"><h5><i class=\"fa fa-user\"></i> Dados Pessoais</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDados\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDados\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.contato.nome\" placeholder=\"Nome completo\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" maxlength=\"100\" ng-model=\"controller.contato.cpf\" mask=\"999.999.999-99\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Nascimento</label> <input type=\"date\" ng-model=\"controller.contato.dataNascimento\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Sexo</label><select class=\"form-control\" ng-model=\"controller.contato.sexo\"><option selected=\"selected\" value=\"0\">Não informado</option><option value=\"1\">Masculino</option><option value=\"2\">Feminino</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label><div class=\"input-group\"><input type=\"text\" maxlength=\"250\" ng-model=\"controller.contato.email\" placeholder=\"E-mail\" class=\"form-control\"> <span class=\"input-group-addon\"><i class=\"fa fa-envelope\"></i></span></div></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Celular</label><div class=\"input-group\"><input type=\"text\" maxlength=\"100\" ng-model=\"controller.contato.celular\" mask=\"(99) 99999-9999\" class=\"form-control\"> <span class=\"input-group-addon\"><i class=\"fa fa-mobile\"></i></span></div></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone</label><div class=\"input-group\"><input type=\"text\" maxlength=\"100\" ng-model=\"controller.contato.telefone\" mask=\"(99) 99999-9999\" class=\"form-control\"> <span class=\"input-group-addon\"><i class=\"fa fa-phone\"></i></span></div></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Empresa</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.contato.empresaAtuacao\" placeholder=\"Empresa\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxEndereco\" class=\"ibox-content\" cg-busy=\"controller.cepPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label><div class=\"input-group\"><input type=\"text\" maxlength=\"100\" ng-model=\"controller.contato.enderecoCep\" ng-blur=\"controller.consultarCep()\" mask=\"99999-999\" class=\"form-control\"> <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" maxlength=\"250\" disabled=\"disabled\" ng-model=\"controller.contato.enderecoLogradouro\" placeholder=\"Logradouro\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" maxlength=\"100\" ng-model=\"controller.contato.enderecoNumero\" placeholder=\"Número\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" maxlength=\"100\" ng-model=\"controller.contato.enderecoComplemento\" placeholder=\"Complemento\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.contato.enderecoBairro\" disabled=\"disabled\" placeholder=\"Bairro\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.contato.enderecoCidade\" placeholder=\"Cidade\" disabled=\"disabled\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Estado</label> <input type=\"text\" disabled=\"disabled\" ng-model=\"controller.contato.enderecoEstado\" placeholder=\"Estado\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Latitude</label> <input type=\"text\" ng-model=\"controller.contato.enderecoLatitude\" disabled=\"disabled\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Longitude</label> <input type=\"text\" disabled=\"disabled\" ng-model=\"controller.contato.enderecoLongitude\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><leaflet lf-center=\"mapProjects\" markers=\"markers\" width=\"100%\" height=\"280px\"></leaflet></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.incluir()\"><i class=\"fa fa-save\"></i> Salvar</button></div></div></div></div></div>");
$templateCache.put("app/contato/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Contato</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Contato</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"><a class=\"btn btn-sm btn-success\" ng-click=\"controller.incluir()\"><i class=\"fa fa-user-plus\"></i> Novo contato</a></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Contato</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" ng-model=\"controller.filtro.cpf\" class=\"form-control\" mask=\"999.999.999-99\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.filtro.email\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.contatosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Resultado</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\">ID</th><th style=\"width: 35%\">Nome</th><th style=\"width: 15%\">CPF</th><th style=\"width: 15%\">Data Nascimento</th><th style=\"width: 20%\">E-mail</th><th style=\"width: 15%\">Celular</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>#{{p.id}}</td><td>{{p.nome}}</td><td>{{p.cpf}}</td><td>{{(p.dataNascimento != \'0001-01-01T00:00:00\' ? p.dataNascimento : \'\') | date: \'dd/MM/yyyy\'}}</td><td>{{p.email}}</td><td>{{p.celular}}</td><td style=\"text-align: center; white-space: nowrap\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-search\"></i> Visualizar</a> <a ng-click=\"controller.incluirAtendimento(p)\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-comments\"></i> Atendimento</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/config/logo/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Logotipo</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Logotipo</a></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-edit\"></i> Configurar</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><input type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this.files)\" class=\"form-control\"><br><img style=\"max-width: 550px\" ng-src=\"{{\'data:image/png;base64,\'+controller.logo.base64}}\"></div></div></div></div></div></div></div>");
$templateCache.put("app/mapa/contato/index.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h7><i class=\"fa fa-map-marker\"></i> LOCALIZAÇÃO DOS CONTATOS</h7></div><div class=\"ibox-content\" cg-busy=\"mapaController.contatosMapPromise\"><leaflet lf-center=\"mapProjects\" markers=\"markers\" layers=\"layers\" width=\"100%\" height=\"480px\"></leaflet></div></div></div></div></div>");
$templateCache.put("app/objetivo/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Solicitação</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Solicitação</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-comments\"></i> Dados da Solicitação</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.nome\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Projeto</label><select class=\"form-control\" ng-model=\"controller.registro.tipo\"><option ng-value=\"1\">Departamental</option><option ng-value=\"2\">Corporativo</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Objetivo do Projeto</label> <textarea ng-model=\"controller.registro.descricao\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" rows=\"8\" maxlength=\"500\" placeholder=\"\" aria-invalid=\"false\">\r\n                                </textarea></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Motivo/Origem da Demanda</label> <textarea ng-model=\"controller.registro.motivoDemanda\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" rows=\"2\" maxlength=\"500\" placeholder=\"\" aria-invalid=\"false\">\r\n                                </textarea></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Áreas Envolvidas</label> <textarea ng-model=\"controller.registro.areasEnvolvidas\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" rows=\"2\" maxlength=\"500\" placeholder=\"\" aria-invalid=\"false\">\r\n                                </textarea></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Classificação do Projeto</label><select class=\"form-control\" ng-model=\"controller.registro.classificacao\"><option ng-value=\"1\">Vital (afeta diretamente o cliente)</option><option ng-value=\"2\">Muito Importante (afeta a imagem da empresa)</option><option ng-value=\"3\">Importante (os que não se enquadram nos anteriores)</option><option ng-value=\"4\">Produção (sistemas de apoio a produção)</option></select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxSolicitante\', \'boxSolicitante\')\"><h5><i class=\"fa fa-user\"></i> Solicitante</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxSolicitante\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxSolicitante\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Área</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.solicitanteArea\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Gestor</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.solicitanteGestor\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Contato</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.solicitanteContato\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Escopo de Atuação</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.solicitanteEscopoAtuacao\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxGestoraInfo\', \'boxGestoraInfo\')\"><h5><i class=\"fa fa-user\"></i> Gestora da Informação</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxGestoraInfo\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxGestoraInfo\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Área</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.gestoraInfoArea\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Gestor</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.gestoraInfoGestor\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Contato</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.gestoraInfoContato\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Escopo de Atuação</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.gestoraInfoEscopoAtuacao\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success collapsed\" ng-click=\"controller.showhide(\'iconBoxProjetos\', \'boxProjetos\')\"><h5><i class=\"fa fa-line-chart\"></i> Projetos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxProjetos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxProjetos\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"></th><th>Projeto</th><th style=\"width: 1px; white-space: nowrap;\">Data de Início</th><th style=\"width: 1px; white-space: nowrap;\">Data de Término</th><th>Responsável</th><th>Tarefas</th><th>% Concluído</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.projetos\"><td>#{{p.id}}</td><td>{{p.nome}}</td><td style=\"white-space: nowrap;\">{{(p.dataInicio == \'0001-01-01T00:00:00\' ? \'não informado\' : p.dataInicio) | date: \'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{(p.dataTermino == \'0001-01-01T00:00:00\' ? \'não informado\' : p.dataTermino) | date: \'dd/MM/yyyy\'}}</td><td>{{p.usuarioResponsavel.nome}}</td><td>{{p.tarefas != null ? p.tarefas.length : \'0\'}}</td><td style=\"width: 180px\"><table style=\"width: 180px;\"><tr><td style=\"width: 150px;\"><div class=\"progress progress-mini\"><div ng-style=\"{ \'width\': p.percentualCalculado + \'%\' }\" class=\"progress-bar\"></div></div></td><td style=\"width: 5px;\">&nbsp;</td><td style=\"width: 50px; white-space: nowrap; text-align: right;\">{{p.percentualCalculado | number:2}} %</td></tr></table></td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a href=\"#/index/projeto_cadastrar/{{p.viewId}}\" target=\"_blank\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-lg-12\" style=\"text-align: right; padding-top: 10px;\"><button ng-click=\"controller.adicionarProjeto()\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-plus\"></i> Adicionar Novo Projeto</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumento\', \'boxDocumento\')\"><h5><i class=\"fa fa-folder\"></i> Documentos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDocumento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDocumento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"form-group\"><div class=\"col-lg-6\"><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><div class=\"form-control\" data-trigger=\"fileinput\"><i class=\"glyphicon glyphicon-file fileinput-exists\"></i> <span class=\"fileinput-filename\"></span></div><span class=\"input-group-addon btn btn-file btn-primary\" style=\"background-color: #1ab394; color: white;\"><span class=\"fileinput-new\"><i class=\"fa fa-upload\"></i> Enviar Arquivo</span> <span class=\"fileinput-exists\"><i class=\"fa fa-upload\"></i> Enviar Arquivo</span> <input type=\"file\" name=\"...\" onchange=\"angular.element(this).scope().uploadFile(this.files)\"></span></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.uploadPromise\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"></th><th>Arquivo</th><th>Nível</th><th>Tipo</th><th>Usuário</th><th>Data Inclusão</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.arquivos\"><td>{{p.id != null ? \'#\' + p.id : \'Novo\'}}</td><td>{{p.nome}}</td><td><button ng-if=\"p.nivel == \'Solicitação\'\" class=\"btn btn-xs btn-success btn-block btn-rounded\">{{p.nivel}}</button> <button ng-if=\"p.nivel == \'Projeto\'\" class=\"btn btn-xs btn-primary btn-block btn-rounded\">{{p.nivel}}</button> <button ng-if=\"p.nivel == \'Tarefa\'\" class=\"btn btn-xs btn-warning btn-block btn-rounded\">{{p.nivel}}</button></td><td>{{p.typeFile | cut:true:30:\' ...\'}}</td><td>{{p.usuario.nome}}</td><td>{{p.dataCadastro | date: \'dd/MM/yyyy\'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.downloadFile(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-download\"></i> Download</a></td></tr></tbody></table></div></div></div><div style=\"clear: both;\"></div></div></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxHistorico\', \'boxHistorico\')\"><h5><i class=\"fa fa-clock-o\"></i> Histórico</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxHistorico\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxHistorico\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.uploadPromise\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 250px;\"><table class=\"table table-bordered\"><thead><tr><th>Data</th><th>Histórico</th><th>Usuário</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.historico\"><td style=\"width: 1px; white-space: nowrap;\">{{p.dataCadastro | date: \'dd/MM/yyyy HH:mm\'}}</td><td>{{p.descricao}}</td><td>{{p.usuario.nome}}</td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button ng-if=\"controller.isUpdate\" class=\"btn btn-md btn-danger\" type=\"button\" style=\"float: left;\" ng-click=\"controller.excluir()\"><i class=\"fa fa-trash\"></i> Excluir Registro</button> <button ng-if=\"controller.isUpdate\" class=\"btn btn-md btn-warning\" type=\"button\" ng-click=\"controller.arquivar()\"><i class=\"fa fa-inbox\"></i> Arquivar Solicitação</button> <button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar Informações</button></div></div></div></div></div>");
$templateCache.put("app/objetivo/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Solicitações</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Solicitação</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Solicitação</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"></th><th>Solicitação</th><th>% Concluído</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>#{{p.id}}</td><td>{{p.nome}}</td><td style=\"width: 200px\"><table style=\"width: 200px;\"><tr><td style=\"width: 150px;\"><div class=\"progress progress-mini\"><div ng-style=\"{ \'width\': p.percentualCalculado + \'%\' }\" class=\"progress-bar\"></div></div></td><td style=\"width: 5px;\">&nbsp;</td><td style=\"width: 50px; white-space: nowrap; text-align: right;\">{{p.percentualCalculado | number:2}} %</td></tr></table></td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/pedido/imprimir/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pedidos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Pedido</a></li><li class=\"active\"><strong>Visualizar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.arquivo}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div>");
$templateCache.put("app/pedido/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pedido {{controller.registro != null && controller.registro.numero != null ? \'#\' + controller.registro.numero.toString() : \'\'}}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Pedido</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-list\"></i> Dados do Pedido</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-7\"><div class=\"form-group\"><label class=\"col-form-label\">Cliente</label><select class=\"form-control\" ng-disabled=\"controller.isUpdate\" ng-model=\"controller.registro.cliente.viewId\" ng-options=\"item.viewId as item.nome for item in controller.clientes\"></select></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Data do Pedido</label> <input type=\"date\" maxlength=\"250\" ng-model=\"controller.registro.dataPedido\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Observação</label> <textarea class=\"form-control\" ng-model=\"controller.registro.observacao\" rows=\"2\" maxlength=\"1000\"></textarea></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumentos\', \'boxDocumentos\')\"><h5><i class=\"fa fa-file\"></i> Produtos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDocumentos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDocumentos\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Produto</label><select class=\"form-control\" ng-model=\"controller.produto\" ng-options=\"item as item.nome for item in controller.produtos\"></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Quantidade</label> <input type=\"number\" maxlength=\"4\" ng-model=\"controller.quantidadeProduto\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-block btn-primary\" ng-click=\"controller.adicionarProduto()\"><i class=\"fa fa-plus\"></i> Adicionar</button></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Produto</th><th class=\"white-bg\">Quantidade</th><th class=\"white-bg\">Valor Unitário</th><th class=\"white-bg\">Valor Total</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.registro.produtos\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.quantidade }}</td><td class=\"ng-binding\">{{ p.valorUnitario | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.quantidade * p.valorUnitario | currency : \'R$ \' : 2 }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.removerProduto(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxServicos\', \'boxServicos\')\"><h5><i class=\"fa fa-file\"></i> Serviços</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxServicos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxServicos\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Serviço</label><select class=\"form-control\" ng-model=\"controller.servico\" ng-options=\"item as item.nome for item in controller.servicos\"></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Quantidade</label> <input type=\"number\" maxlength=\"4\" ng-model=\"controller.quantidadeServico\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-block btn-primary\" ng-click=\"controller.adicionarServico()\"><i class=\"fa fa-plus\"></i> Adicionar</button></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Produto</th><th class=\"white-bg\">Quantidade</th><th class=\"white-bg\">Valor Unitário</th><th class=\"white-bg\">Valor Total</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.registro.servicos\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.quantidade }}</td><td class=\"ng-binding\">{{ p.valorUnitario | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.quantidade * p.valorUnitario | currency : \'R$ \' : 2 }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.removerServico(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-dollar\"></i> Total do Pedido</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxEndereco\" class=\"ibox-content\" cg-busy=\"controller.cepPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Adicional</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.registro.valorAdicional\" ng-blur=\"controller.calcular()\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Desconto</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.registro.valorDesconto\" ng-change=\"controller.calcular()\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Total do Pedido</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.valorTotal | currency : \'R$ \' : 2}}\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar Informações</button></div></div></div></div></div>");
$templateCache.put("app/pedido/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pedidos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Pedido</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.filtro.numero\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Cliente</label> <input type=\"text\" ng-model=\"controller.filtro.cliente\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Número</th><th>Data da Venda</th><th>Valor da Venda</th><th>Cliente</th><th>Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>#{{p.numero}}</td><td>{{p.dataPedido | date: \'dd/MM/yyyy\'}}</td><td>{{p.valorTotal | currency : \'R$ \' : 2}}</td><td>{{p.cliente.nome}} {{p.cliente.cpf != null && p.cliente.cpf != \'\' ? \' (\' + p.cliente.cpf + \')\' : \'\'}}</td><td style=\"width: 120px;\"><button ng-class=\"p.situacao == 1 ? \'btn-warning\' : (p.situacao == 4 ? \'btn-danger\' : (p.situacao == 5 ? \'btn-primary\' : \'btn-success\'))\" class=\"btn btn-xs btn-block btn-rounded\">{{p.situacaoTexto}}</button></td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a> <a ng-click=\"controller.alterar(p)\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/orcamento/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Orçamento {{controller.registro != null && controller.registro.numero != null ? \'#\' + controller.registro.numero.toString() : \'\'}}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Orçamento</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-list\"></i> Dados do Orçamento</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-7\"><div class=\"form-group\"><label class=\"col-form-label\">Cliente</label><select class=\"form-control\" ng-disabled=\"controller.isUpdate\" ng-model=\"controller.registro.cliente.viewId\" ng-options=\"item.viewId as item.nome for item in controller.clientes\"></select></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Data do Pedido</label> <input type=\"date\" maxlength=\"250\" ng-model=\"controller.registro.dataPedido\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Observação</label> <textarea class=\"form-control\" ng-model=\"controller.registro.observacao\" rows=\"2\" maxlength=\"1000\"></textarea></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumentos\', \'boxDocumentos\')\"><h5><i class=\"fa fa-file\"></i> Produtos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDocumentos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDocumentos\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Produto</label><select class=\"form-control\" ng-model=\"controller.produto\" ng-options=\"item as item.nome for item in controller.produtos\"></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Quantidade</label> <input type=\"number\" maxlength=\"4\" ng-model=\"controller.quantidadeProduto\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-block btn-primary\" ng-click=\"controller.adicionarProduto()\"><i class=\"fa fa-plus\"></i> Adicionar</button></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Produto</th><th class=\"white-bg\">Quantidade</th><th class=\"white-bg\">Valor Unitário</th><th class=\"white-bg\">Valor Total</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.registro.produtos\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.quantidade }}</td><td class=\"ng-binding\">{{ p.valorUnitario | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.quantidade * p.valorUnitario | currency : \'R$ \' : 2 }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.removerProduto(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxServicos\', \'boxServicos\')\"><h5><i class=\"fa fa-file\"></i> Serviços</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxServicos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxServicos\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Serviço</label><select class=\"form-control\" ng-model=\"controller.servico\" ng-options=\"item as item.nome for item in controller.servicos\"></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Quantidade</label> <input type=\"number\" maxlength=\"4\" ng-model=\"controller.quantidadeServico\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-block btn-primary\" ng-click=\"controller.adicionarServico()\"><i class=\"fa fa-plus\"></i> Adicionar</button></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Produto</th><th class=\"white-bg\">Quantidade</th><th class=\"white-bg\">Valor Unitário</th><th class=\"white-bg\">Valor Total</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.registro.servicos\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.quantidade }}</td><td class=\"ng-binding\">{{ p.valorUnitario | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.quantidade * p.valorUnitario | currency : \'R$ \' : 2 }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.removerServico(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-dollar\"></i> Total do Pedido</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxEndereco\" class=\"ibox-content\" cg-busy=\"controller.cepPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Adicional</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.registro.valorAdicional\" ng-blur=\"controller.calcular()\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Desconto</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.registro.valorDesconto\" ng-change=\"controller.calcular()\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Total do Pedido</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.valorTotal | currency : \'R$ \' : 2}}\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar Informações</button></div></div></div></div></div>");
$templateCache.put("app/orcamento/imprimir/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Orçamentos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Orçamento</a></li><li class=\"active\"><strong>Visualizar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.arquivo}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div>");
$templateCache.put("app/orcamento/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Orçamentos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Orçamento</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.filtro.numero\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Cliente</label> <input type=\"text\" ng-model=\"controller.filtro.cliente\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Número</th><th>Data do Orçamento</th><th>Valor Total</th><th>Cliente</th><th>CPF</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>#{{p.numero}}</td><td>{{p.dataPedido | date: \'dd/MM/yyyy\'}}</td><td>{{p.valorTotal | currency : \'R$ \' : 2}}</td><td>{{p.cliente.nome}}</td><td>{{p.cliente.cpf != null && p.cliente.cpf != \'\' ? p.cliente.cpf : \'Não informado\'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a> <a ng-click=\"controller.alterar(p)\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/produto/categoria/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Categorias</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Categoria</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"><button class=\"btn btn-success\" ng-click=\"controller.cadastrar()\"><i class=\"fa fa-plus\"></i> Nova Categoria</button></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Categorias</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.nome}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a> <a ng-click=\"controller.excluir(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/produto/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Produtos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Produto</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-user\"></i> Dados do Produto</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.nome\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição</label> <textarea class=\"form-control\" ng-model=\"controller.registro.descricao\" rows=\"4\" maxlength=\"1000\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor de Venda</label> <input type=\"text\" money-mask=\"\" maxlength=\"15\" ng-model=\"controller.registro.valorUnitario\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Categoria</label><select class=\"form-control\" ng-model=\"controller.categoria.viewId\" ng-options=\"item.viewId as item.nome for item in controller.categorias\"><option></option></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor de Compra (Preço de Custo)</label> <input type=\"text\" money-mask=\"\" maxlength=\"15\" ng-model=\"controller.registro.valorCompra\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Código de Barras</label> <input type=\"text\" maxlength=\"15\" ng-model=\"controller.registro.codigoBarras\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFoto\', \'boxFoto\')\"><h5><i class=\"fa fa-photo\"></i> Foto do Produto</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFoto\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFoto\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><input type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this.files)\" class=\"form-control\"><br><img class=\"img-responsive\" ng-if=\"controller.foto != null\" ng-src=\"{{controller.foto}}\"></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEstoque\', \'boxEstoque\')\"><h5><i class=\"fa fa-th-list\"></i> Estoque</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEstoque\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxEstoque\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Estoque Atual</label> <input type=\"number\" ng-disabled=\"controller.isUpdate\" maxlength=\"15\" ng-model=\"controller.registro.estoqueAtual\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><button ng-click=\"controller.estoqueCorrigir()\" class=\"btn btn-danger\" style=\"width: 140px;\"><i class=\"fa fa-edit\"></i> Corrigir</button> <button ng-click=\"controller.estoqueRepor()\" class=\"btn btn-success\" style=\"width: 140px;\"><i class=\"fa fa-plus\"></i> Repor</button> <button ng-click=\"controller.estoqueHistorico()\" class=\"btn btn-primary\" style=\"width: 180px;\"><i class=\"fa fa-th-list\"></i> Movimentações</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button ng-if=\"controller.isUpdate\" class=\"btn btn-md btn-danger\" type=\"button\" style=\"float: left;\" ng-click=\"controller.excluir()\"><i class=\"fa fa-trash\"></i> Excluir Registro</button> <button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar Informações</button></div></div></div></div></div>");
$templateCache.put("app/produto/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Produtos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Produto</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Categoria</label> <input type=\"text\" ng-model=\"controller.filtro.categoria\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 25%;\">Nome</th><th>Descrição</th><th>Categoria</th><th style=\"width: 130px;\">Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.nome}}</td><td>{{p.descricao}}</td><td>{{p.categoria.nome}}</td><td>{{p.valorUnitario | currency : \'R$ \' : 2}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/projeto/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Projeto</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Projeto</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-comments\"></i> Informações do Projeto</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.nome\" placeholder=\"Nome do Projeto\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Solicitação</label><select class=\"form-control\" ng-disabled=\"controller.isUpdate\" ng-model=\"controller.registro.objetivo.viewId\" ng-options=\"item.viewId as item.nome for item in controller.objetivos\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição</label> <textarea ng-model=\"controller.registro.descricao\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" rows=\"8\" maxlength=\"500\" placeholder=\"\" aria-invalid=\"false\">\r\n                                </textarea></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Início</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.registro.dataInicio\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Término</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.registro.dataTermino\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Responsável</label><select class=\"form-control\" ng-model=\"controller.registro.usuarioResponsavel.viewId\" ng-options=\"item.viewId as item.nome for item in controller.usuarios\"></select></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success collapsed\" ng-click=\"controller.showhide(\'iconBoxProjetos\', \'boxProjetos\')\"><h5><i class=\"fa fa-tags\"></i> Tarefas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxProjetos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxProjetos\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"></th><th>Tarefa</th><th style=\"width: 1px; white-space: nowrap;\">Data de Início</th><th style=\"width: 1px; white-space: nowrap;\">Data de Término</th><th style=\"width: 140px;\">Situação</th><th>Responsável</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.tarefas\"><td>#{{p.id}}</td><td>{{p.nome}}</td><td style=\"white-space: nowrap;\">{{(p.dataInicio == \'0001-01-01T00:00:00\' ? \'não informado\' : p.dataInicio) | date: \'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{(p.dataTermino == \'0001-01-01T00:00:00\' ? \'não informado\' : p.dataTermino) | date: \'dd/MM/yyyy\'}}</td><td><button ng-if=\"p.situacao == 1\" class=\"btn btn-xs btn-warning btn-block btn-rounded\">Pendente</button> <button ng-if=\"p.situacao == 2\" class=\"btn btn-xs btn-primary btn-block btn-rounded\">Concluído</button></td><td>{{p.usuarioResponsavel.nome}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a href=\"#/index/tarefa_cadastrar/{{p.viewId}}\" target=\"_blank\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-lg-12\" style=\"text-align: right; padding-top: 10px;\"><button ng-click=\"controller.replicarProjeto()\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-retweet\"></i> Replicar tarefas</button> <button ng-click=\"controller.adicionarTarefa()\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-plus\"></i> Adicionar nova tarefa</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumento\', \'boxDocumento\')\"><h5><i class=\"fa fa-folder\"></i> Documentos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDocumento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDocumento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"form-group\"><div class=\"col-lg-6\"><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><div class=\"form-control\" data-trigger=\"fileinput\"><i class=\"glyphicon glyphicon-file fileinput-exists\"></i> <span class=\"fileinput-filename\"></span></div><span class=\"input-group-addon btn btn-file btn-primary\" style=\"background-color: #1ab394; color: white;\"><span class=\"fileinput-new\"><i class=\"fa fa-upload\"></i> Enviar Arquivo</span> <span class=\"fileinput-exists\"><i class=\"fa fa-upload\"></i> Enviar Arquivo</span> <input type=\"file\" name=\"...\" onchange=\"angular.element(this).scope().uploadFile(this.files)\"></span></div></div></div><br><br><div class=\"col-lg-12\" cg-busy=\"controller.uploadPromise\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"></th><th>Arquivo</th><th>Nível</th><th>Tipo</th><th>Usuário</th><th>Data Inclusão</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.arquivos\"><td>{{p.id != null ? \'#\' + p.id : \'Novo\'}}</td><td>{{p.nome}}</td><td><button ng-if=\"p.nivel == \'Objetivo\'\" class=\"btn btn-xs btn-success btn-block btn-rounded\">{{p.nivel}}</button> <button ng-if=\"p.nivel == \'Projeto\'\" class=\"btn btn-xs btn-primary btn-block btn-rounded\">{{p.nivel}}</button> <button ng-if=\"p.nivel == \'Tarefa\'\" class=\"btn btn-xs btn-warning btn-block btn-rounded\">{{p.nivel}}</button></td><td>{{p.typeFile | cut:true:30:\' ...\'}}</td><td>{{p.usuario.nome}}</td><td>{{p.dataCadastro | date: \'dd/MM/yyyy\'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.downloadFile(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-download\"></i> Download</a></td></tr></tbody></table></div></div><div style=\"clear: both;\"></div></div></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxHistorico\', \'boxHistorico\')\"><h5><i class=\"fa fa-clock-o\"></i> Histórico</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxHistorico\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxHistorico\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.uploadPromise\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Data</th><th>Histórico</th><th>Usuário</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.historico\"><td style=\"width: 1px; white-space: nowrap;\">{{p.dataCadastro | date: \'dd/MM/yyyy HH:mm\'}}</td><td>{{p.descricao}}</td><td>{{p.usuario.nome}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button ng-if=\"controller.isUpdate\" class=\"btn btn-md btn-danger\" type=\"button\" style=\"float: left;\" ng-click=\"controller.excluir()\"><i class=\"fa fa-trash\"></i> Excluir Registro</button> <button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar</button></div></div></div></div></div>");
$templateCache.put("app/relatorio/produtos_vendas/index.html","<style>\r\n    .text-red\r\n    {\r\n        color: red;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Relatório de Produtos / Vendas</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Relatório</a></li><li class=\"active\"><strong>Vendas</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Ano</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.anoFiltro\"><option value=\"2024\">2024</option><option value=\"2023\">2023</option><option value=\"2022\">2022</option><option value=\"2021\">2021</option><option value=\"2020\">2020</option></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Mês</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.mesFiltro\"><option value=\"1\">Janeiro</option><option value=\"2\">Feveiro</option><option value=\"3\">Março</option><option value=\"4\">Abril</option><option value=\"5\">Maio</option><option value=\"6\">Junho</option><option value=\"7\">Julho</option><option value=\"8\">Agosto</option><option value=\"9\">Setembro</option><option value=\"10\">Outubro</option><option value=\"11\">Novembro</option><option value=\"12\">Dezembro</option></select></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table id=\"tableToExport\" class=\"table table-bordered\"><thead><tr><th style=\"white-space: nowrap;\">Produto</th><th style=\"white-space: nowrap;\">Quantidade - Vendas</th><th style=\"white-space: nowrap;\">Total - Vendas</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.produtoNome}}</td><td>{{p.quantidade}}</td><td>{{p.total | currency : \'R$ \' : 2}}</td></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"text-align: right;\"><button class=\"btn btn-sm btn-primary\" style=\"width: 160px;\" ng-click=\"exportToExcel(\'#tableToExport\')\"><i class=\"fa fa-file-excel-o\"></i> Exportar p/ Excel</button></div></div></div><br></div>");
$templateCache.put("app/projeto/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Projetos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Projeto</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Projeto</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Solicitação</label> <input type=\"text\" ng-model=\"controller.filtro.solicitacao\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Responsável</label> <input type=\"text\" ng-model=\"controller.filtro.responsavel\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"></th><th>Projeto</th><th>Solicitação</th><th style=\"width: 1px; white-space: nowrap;\">Data de Início</th><th style=\"width: 1px; white-space: nowrap;\">Data de Término</th><th>Responsável</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>#{{p.id}}</td><td>{{p.nome}}</td><td>{{p.objetivo.nome}}</td><td style=\"white-space: nowrap;\">{{(p.dataInicio == \'0001-01-01T00:00:00\' ? \'não informado\' : p.dataInicio) | date: \'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{(p.dataTermino == \'0001-01-01T00:00:00\' ? \'não informado\' : p.dataTermino) | date: \'dd/MM/yyyy\'}}</td><td>{{p.usuarioResponsavel.nome}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/relatorio/servicos_vendas/index.html","<style>\r\n    .text-red\r\n    {\r\n        color: red;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Relatório de Serviços / Vendas</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Relatório</a></li><li class=\"active\"><strong>Vendas</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Ano</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.anoFiltro\"><option value=\"2024\">2024</option><option value=\"2023\">2023</option><option value=\"2022\">2022</option><option value=\"2021\">2021</option><option value=\"2020\">2020</option></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Mês</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.mesFiltro\"><option value=\"1\">Janeiro</option><option value=\"2\">Feveiro</option><option value=\"3\">Março</option><option value=\"4\">Abril</option><option value=\"5\">Maio</option><option value=\"6\">Junho</option><option value=\"7\">Julho</option><option value=\"8\">Agosto</option><option value=\"9\">Setembro</option><option value=\"10\">Outubro</option><option value=\"11\">Novembro</option><option value=\"12\">Dezembro</option></select></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table id=\"tableToExport\" class=\"table table-bordered\"><thead><tr><th style=\"white-space: nowrap;\">Serviço</th><th style=\"white-space: nowrap;\">Quantidade - Vendas</th><th style=\"white-space: nowrap;\">Total - Vendas</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.servicoNome}}</td><td>{{p.quantidade}}</td><td>{{p.total | currency : \'R$ \' : 2}}</td></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"text-align: right;\"><button class=\"btn btn-sm btn-primary\" style=\"width: 160px;\" ng-click=\"exportToExcel(\'#tableToExport\')\"><i class=\"fa fa-file-excel-o\"></i> Exportar p/ Excel</button></div></div></div><br></div>");
$templateCache.put("app/relatorio/venda_lucro/index.html","<style>\r\n    .text-red\r\n    {\r\n        color: red;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Relatório de Vendas / Lucro</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Relatório</a></li><li class=\"active\"><strong>Vendas</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Ano</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.anoFiltro\"><option value=\"2023\">2023</option><option value=\"2022\">2022</option><option value=\"2021\">2021</option><option value=\"2020\">2020</option></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Mês</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.mesFiltro\"><option value=\"1\">Janeiro</option><option value=\"2\">Fevereiro</option><option value=\"3\">Março</option><option value=\"4\">Abril</option><option value=\"5\">Maio</option><option value=\"6\">Junho</option><option value=\"7\">Julho</option><option value=\"8\">Agosto</option><option value=\"9\">Setembro</option><option value=\"10\">Outubro</option><option value=\"11\">Novembro</option><option value=\"12\">Dezembro</option></select></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table id=\"tableToExport\" class=\"table table-bordered\"><thead><tr><th style=\"width: 1px; white-space: nowrap;\">Nº Venda</th><th style=\"width: 80px; white-space: nowrap;\">Tipo</th><th style=\"width: 100px; white-space: nowrap;\">Data</th><th style=\"width: 120px; white-space: nowrap;\">Produto</th><th style=\"width: 120px; white-space: nowrap;\">Valor Tabela</th><th style=\"width: 120px; white-space: nowrap;\">Valor Venda</th><th style=\"width: 120px; white-space: nowrap;\">Valor Compra</th><th style=\"width: 120px; white-space: nowrap;\">Qtd. Venda</th><th style=\"width: 120px; white-space: nowrap;\">Margem (%)</th><th style=\"width: 120px; white-space: nowrap;\">Lucro (R$)</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>#{{p.numero}}</td><td>{{p.tipoTexto}}</td><td>{{p.dataVenda | date: \'dd/MM/yyyy\'}}</td><td>{{p.produto}}</td><td>{{p.valorTabela | currency : \'R$ \' : 2}}</td><td>{{p.valorVenda | currency : \'R$ \' : 2}}</td><td>{{p.valorCompra | currency : \'R$ \' : 2}}</td><td>{{p.quantidade}}</td><td>{{ p.lucroUnitario / p.valorVenda * 100 | number : 2 }}%</td><td ng-class=\"p.lucro < 0 ? \'text-red\' : \'\'\">{{p.lucro | currency : \'R$ \' : 2}}</td></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"text-align: right;\"><button class=\"btn btn-sm btn-primary\" style=\"width: 160px;\" ng-click=\"exportToExcel(\'#tableToExport\')\"><i class=\"fa fa-file-excel-o\"></i> Exportar p/ Excel</button></div></div></div><br></div>");
$templateCache.put("app/relatorio/vendas/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Relatório de Vendas</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Relatório</a></li><li class=\"active\"><strong>Vendas</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Usuário</label> <input type=\"text\" ng-model=\"controller.filtro.usuario\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Ano</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.anoFiltro\"><option value=\"2023\">2023</option><option value=\"2022\">2022</option><option value=\"2021\">2021</option><option value=\"2020\">2020</option></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Mês</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.mesFiltro\"><option value=\"1\">Janeiro</option><option value=\"2\">Fevereiro</option><option value=\"3\">Março</option><option value=\"4\">Abril</option><option value=\"5\">Maio</option><option value=\"6\">Junho</option><option value=\"7\">Julho</option><option value=\"8\">Agosto</option><option value=\"9\">Setembro</option><option value=\"10\">Outubro</option><option value=\"11\">Novembro</option><option value=\"12\">Dezembro</option></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo</label><select class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\" ng-model=\"controller.filtro.tipo\"><option value=\"-1\">Todos</option><option value=\"0\">Venda</option><option value=\"1\">Pedido</option><option value=\"2\">Orçamento</option></select></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table id=\"tableToExport\" class=\"table table-bordered\"><thead><tr><th style=\"width: 1px; white-space: nowrap;\">Número</th><th style=\"width: 80px; white-space: nowrap;\">Tipo</th><th style=\"width: 100px; white-space: nowrap;\">Data</th><th style=\"width: 120px; white-space: nowrap;\">Valor Total</th><th>Cliente</th><th>Usuário</th><th>Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>#{{p.numero}}</td><td>{{p.tipoVendaTexto}}</td><td>{{p.dataVenda | date: \'dd/MM/yyyy\'}}</td><td>{{p.valorTotal | currency : \'R$ \' : 2}}</td><td>{{p.cliente.nome}} {{p.cliente.cpf != null && p.cliente.cpf != \'\' ? \' (\' + p.cliente.cpf + \')\' : \'\'}}</td><td>{{p.usuarioCadastro.nome}}</td><td style=\"width: 120px;\"><button ng-class=\"p.situacaoPagamento == 2 ? \'btn-primary\' : \'btn-warning\'\" class=\"btn btn-xs btn-block btn-rounded\">{{p.situacaoPagamentoTexto}}</button></td></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"text-align: right;\"><button class=\"btn btn-sm btn-primary\" style=\"width: 160px;\" ng-click=\"exportToExcel(\'#tableToExport\')\"><i class=\"fa fa-file-excel-o\"></i> Exportar p/ Excel</button></div></div></div><br></div>");
$templateCache.put("app/servico/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Serviços</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Serviço</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-user\"></i> Dados do Serviço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.nome\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição</label> <textarea class=\"form-control\" ng-model=\"controller.registro.descricao\" rows=\"2\" maxlength=\"1000\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Valor do Serviço</label> <input type=\"text\" money-mask=\"\" maxlength=\"15\" ng-model=\"controller.registro.valorUnitario\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button ng-if=\"controller.isUpdate\" class=\"btn btn-md btn-danger\" type=\"button\" style=\"float: left;\" ng-click=\"controller.excluir()\"><i class=\"fa fa-trash\"></i> Excluir Registro</button> <button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar Informações</button></div></div></div></div></div>");
$templateCache.put("app/servico/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Serviços</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Serviço</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>Descrição</th><th>Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.nome}}</td><td>{{p.descricao}}</td><td>{{p.valorUnitario | currency : \'R$ \' : 2}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/tarefa/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Tarefa {{controller.isUpdate ? \'#\' + controller.registro.id : \'\'}}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Tarefa</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-comments\"></i> Informações da Tarefa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.nome\" placeholder=\"Nome da Tarefa\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Projeto</label><select class=\"form-control\" ng-change=\"controller.selecionarProjeto()\" ng-disabled=\"controller.isUpdate\" ng-model=\"controller.registro.projeto.viewId\" ng-options=\"item.viewId as item.nome for item in controller.projetos\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição</label> <textarea ng-model=\"controller.registro.descricao\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" rows=\"8\" maxlength=\"500\" placeholder=\"\" aria-invalid=\"false\">\r\n                                </textarea></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Início</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.registro.dataInicio\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Término</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.registro.dataTermino\"></div></div><div class=\"col-sm-3\" ng-if=\"controller.isUpdate\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label> <input disabled=\"\" class=\"form-control\" ng-model=\"controller.registro.situacaoTexto\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Responsável</label><select class=\"form-control\" ng-model=\"controller.registro.usuarioResponsavel.viewId\" ng-options=\"item.viewId as item.nome for item in controller.usuarios\"></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Predecessora</label><select class=\"form-control\" ng-model=\"controller.registro.predecessora.viewId\" ng-options=\"item.viewId as (\'#\' + item.id + \' - \' + item.nome + \' (\' + item.situacaoTexto + \')\') for item in controller.tarefas\"><option></option></select></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate && controller.registro.dependentes.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success collapsed\" ng-click=\"controller.showhide(\'iconBoxProjetos\', \'boxProjetos\')\"><h5><i class=\"fa fa-tags\"></i> Dependentes</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxProjetos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxProjetos\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"></th><th>Tarefa</th><th style=\"width: 1px; white-space: nowrap;\">Data de Início</th><th style=\"width: 1px; white-space: nowrap;\">Data de Término</th><th style=\"width: 140px;\">Situação</th><th>Responsável</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.dependentes\"><td>#{{p.id}}</td><td>{{p.nome}}</td><td style=\"white-space: nowrap;\">{{(p.dataInicio == \'0001-01-01T00:00:00\' ? \'não informado\' : p.dataInicio) | date: \'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{(p.dataTermino == \'0001-01-01T00:00:00\' ? \'não informado\' : p.dataTermino) | date: \'dd/MM/yyyy\'}}</td><td><button ng-if=\"p.situacao == 1\" class=\"btn btn-xs btn-warning btn-block btn-rounded\">Pendente</button> <button ng-if=\"p.situacao == 2\" class=\"btn btn-xs btn-primary btn-block btn-rounded\">Concluído</button></td><td>{{p.usuarioResponsavel.nome}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a href=\"#/index/tarefa_cadastrar/{{p.viewId}}\" target=\"_blank\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumento\', \'boxDocumento\')\"><h5><i class=\"fa fa-folder\"></i> Documentos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDocumento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDocumento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"form-group\"><div class=\"col-lg-6\"><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><div class=\"form-control\" data-trigger=\"fileinput\"><i class=\"glyphicon glyphicon-file fileinput-exists\"></i> <span class=\"fileinput-filename\"></span></div><span class=\"input-group-addon btn btn-file btn-primary\" style=\"background-color: #1ab394; color: white;\"><span class=\"fileinput-new\"><i class=\"fa fa-upload\"></i> Enviar Arquivo</span> <span class=\"fileinput-exists\"><i class=\"fa fa-upload\"></i> Enviar Arquivo</span> <input type=\"file\" name=\"...\" onchange=\"angular.element(this).scope().uploadFile(this.files)\"></span></div></div></div><br><br><div class=\"col-lg-12\" cg-busy=\"controller.uploadPromise\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"></th><th>Arquivo</th><th>Nível</th><th>Tipo</th><th>Usuário</th><th>Data Inclusão</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.arquivos\"><td>{{p.id != null ? \'#\' + p.id : \'Novo\'}}</td><td>{{p.nome}}</td><td><button ng-if=\"p.nivel == \'Objetivo\'\" class=\"btn btn-xs btn-success btn-block btn-rounded\">{{p.nivel}}</button> <button ng-if=\"p.nivel == \'Projeto\'\" class=\"btn btn-xs btn-primary btn-block btn-rounded\">{{p.nivel}}</button> <button ng-if=\"p.nivel == \'Tarefa\'\" class=\"btn btn-xs btn-warning btn-block btn-rounded\">{{p.nivel}}</button></td><td>{{p.typeFile | cut:true:30:\' ...\'}}</td><td>{{p.usuario.nome}}</td><td>{{p.dataCadastro | date: \'dd/MM/yyyy\'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-if=\"p.id != null\" ng-click=\"controller.downloadFile(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-download\"></i> Download</a></td></tr></tbody></table></div></div><div style=\"clear: both;\"></div></div></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxHistorico\', \'boxHistorico\')\"><h5><i class=\"fa fa-clock-o\"></i> Histórico</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxHistorico\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxHistorico\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.uploadPromise\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Data</th><th>Histórico</th><th>Usuário</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registro.historico\"><td style=\"width: 1px; white-space: nowrap;\">{{p.dataCadastro | date: \'dd/MM/yyyy HH:mm\'}}</td><td>{{p.descricao}}</td><td>{{p.usuario.nome}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button ng-if=\"controller.isUpdate\" class=\"btn btn-md btn-danger\" type=\"button\" ng-click=\"controller.excluir()\"><i class=\"fa fa-trash\"></i> Excluir Tarefa</button><button ng-if=\"!controller.isUpdate\" class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar</button> <button ng-if=\"controller.isUpdate && controller.registro.situacao == 1\" class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar Alterações</button> <button ng-if=\"controller.isUpdate && controller.registro.situacao == 1\" class=\"btn btn-md btn-primary\" type=\"button\" ng-click=\"controller.finalizarTarefa()\"><i class=\"fa fa-save\"></i> Finalizar Tarefa</button></div></div></div></div></div>");
$templateCache.put("app/tarefa/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Tarefas</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Tarefa</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-primary\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Solicitação</label><select class=\"form-control\" ng-change=\"controller.listarProjetos()\" ng-model=\"controller.filtro.objetivo.viewId\" ng-options=\"item.viewId as (\'#\' + item.id + \' - \' +item.nome) for item in controller.objetivos\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Projeto</label><select class=\"form-control\" ng-change=\"controller.pesquisar()\" ng-model=\"controller.filtro.projeto.viewId\" ng-options=\"item.viewId as (\'#\' + item.id + \' - \' +item.nome) for item in controller.projetos\"></select></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"></th><th>Tarefa</th><th style=\"width: 1px; white-space: nowrap;\">Data de Início</th><th style=\"width: 1px; white-space: nowrap;\">Data de Término</th><th>Situação</th><th>Responsável</th><th>Predecessora</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>#{{p.id}}</td><td>{{p.nome}}</td><td style=\"white-space: nowrap;\">{{(p.dataInicio == \'0001-01-01T00:00:00\' ? \'não informado\' : p.dataInicio) | date: \'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{(p.dataTermino == \'0001-01-01T00:00:00\' ? \'não informado\' : p.dataTermino) | date: \'dd/MM/yyyy\'}}</td><td><button ng-if=\"p.situacao == 1\" class=\"btn btn-xs btn-warning btn-block btn-rounded\">Pendente</button> <button ng-if=\"p.situacao == 2\" class=\"btn btn-xs btn-primary btn-block btn-rounded\">Concluído</button></td><td>{{p.usuarioResponsavel.nome}}</td><td>{{p.predecessora.nome}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/venda/cadastrar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>{{controller.titulo}} {{controller.registro != null && controller.registro.numero != null ? \'#\' + controller.registro.numero.toString() : \'\'}}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>{{controller.titulo}}</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-list\"></i> Informações</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-7\"><div class=\"form-group\"><label class=\"col-form-label\">Cliente</label> <button class=\"btn btn-primary btn-block btn-outline\" ng-click=\"controller.selecionarCliente()\"><i class=\"fa fa-user\"></i> {{controller.registro.cliente != null && controller.registro.cliente.nome != null? controller.registro.cliente.nome : \'Selecionar cliente\'}}</button></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"date\" maxlength=\"250\" ng-model=\"controller.registro.dataVenda\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Observação</label> <textarea class=\"form-control\" ng-model=\"controller.registro.observacao\" rows=\"2\" maxlength=\"1000\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label><select ng-disabled=\"controller.restricaoSituacaoVenda\" class=\"form-control\" ng-model=\"controller.registro.situacaoPagamento\"><option ng-value=\"1\">Pendente</option><option ng-value=\"3\">Em Andamento</option><option ng-value=\"2\">Finalizado</option><option ng-value=\"5\">Cancelado</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Registro</label><select class=\"form-control\" ng-model=\"controller.registro.tipoVenda\"><option ng-value=\"0\">Venda</option><option ng-value=\"1\">Pedido</option><option ng-value=\"2\">Orçamento</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-if=\"controller.tipo == 0\"><label class=\"col-form-label\">Forma do Pagamento</label><select class=\"form-control\" ng-model=\"controller.registro.formaPagamento\"><option ng-value=\"0\">Não informado</option><option ng-value=\"1\">Dinheiro</option><option ng-value=\"2\">Cartão de Débito</option><option ng-value=\"3\">Cartão de Crédito à Vista</option><option ng-value=\"4\">Cartão de Crédito Parcelado</option><option ng-value=\"5\">Transferência Bancária</option><option ng-value=\"6\">Boleto</option><option ng-value=\"7\">Cheque</option><option ng-value=\"8\">PIX</option><option ng-value=\"9\">Outro</option></select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumentos\', \'boxDocumentos\')\"><h5><i class=\"fa fa-tags\"></i> Produtos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDocumentos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDocumentos\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Produto</label> <button class=\"btn btn-primary btn-block btn-outline\" ng-click=\"controller.selecionarProdutoModal()\">{{controller.produto != null && controller.produto.nome != null ? controller.produto.nome : \'Selecionar produto\'}}</button></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Quantidade</label> <input type=\"number\" maxlength=\"4\" ng-model=\"controller.quantidadeProduto\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.valorProduto\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-block btn-success\" ng-click=\"controller.adicionarProduto()\"><i class=\"fa fa-plus\"></i> Adicionar</button></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Produto</th><th class=\"white-bg\">Quantidade</th><th class=\"white-bg\">Valor Unitário</th><th class=\"white-bg\">Valor Total</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.registro.produtos\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.quantidade }}</td><td class=\"ng-binding\">{{ p.valorUnitario | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.quantidade * p.valorUnitario | currency : \'R$ \' : 2 }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.removerProduto(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxServicos\', \'boxServicos\')\"><h5><i class=\"fa fa-tags\"></i> Serviços</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxServicos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxServicos\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Serviço</label> <button class=\"btn btn-primary btn-block btn-outline\" ng-click=\"controller.selecionarServicoModal()\">{{controller.servico != null && controller.servico.nome != null ? controller.servico.nome : \'Selecionar serviço\'}}</button></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Quantidade</label> <input type=\"number\" maxlength=\"4\" ng-model=\"controller.quantidadeServico\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.valorServico\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-block btn-success\" ng-click=\"controller.adicionarServico()\"><i class=\"fa fa-plus\"></i> Adicionar</button></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Produto</th><th class=\"white-bg\">Quantidade</th><th class=\"white-bg\">Valor Unitário</th><th class=\"white-bg\">Valor Total</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.registro.servicos\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.quantidade }}</td><td class=\"ng-binding\">{{ p.valorUnitario | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.quantidade * p.valorUnitario | currency : \'R$ \' : 2 }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.removerServico(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-dollar\"></i> Total</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxEndereco\" class=\"ibox-content\" cg-busy=\"controller.cepPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Adicional</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.registro.valorAdicional\" ng-blur=\"controller.calcular()\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Desconto</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.registro.valorDesconto\" ng-change=\"controller.calcular()\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Total</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.valorTotal | currency : \'R$ \' : 2}}\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxPagamento\', \'boxPagamento\')\"><h5><i class=\"fa fa-book\"></i> Pagamentos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxPagamento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxPagamento\" class=\"ibox-content\" cg-busy=\"controller.cepPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Data</th><th class=\"white-bg\">Tipo</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Forma Pagamento</th><th class=\"white-bg\">Situação</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.pagamentos\"><td class=\"ng-binding\">{{ p.dataVencimento | date: \'dd/MM/yyyy\' }}</td><td class=\"ng-binding\">{{ p.tipoPagamentoTexto }}</td><td class=\"ng-binding\">{{ p.valor | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.formaPagamentoTexto }}</td><td class=\"ng-binding\" style=\"width: 130px;\"><button ng-class=\"p.situacao == 1 ? \'btn-warning\' : \'btn-primary\'\" class=\"btn btn-xs btn-block\">{{p.situacaoTexto}}</button></td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.editarPagamento(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i> Editar</button> <button ng-click=\"controller.removerPagamento(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div><div class=\"row\"><br><div class=\"col-lg-12\" style=\"text-align: right; padding-top: 0px;\"><button ng-click=\"controller.visualizarRecibo()\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-file\"></i> Visualizar Recibo</button> <button ng-click=\"controller.adicionarPagamento()\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-plus\"></i> Adicionar Pagamento</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar Informações</button></div></div></div></div></div>");
$templateCache.put("app/venda/cadastrar_old/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>{{controller.titulo}} {{controller.registro != null && controller.registro.numero != null ? \'#\' + controller.registro.numero.toString() : \'\'}}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>{{controller.titulo}}</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-list\"></i> Informações</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-7\"><div class=\"form-group\"><label class=\"col-form-label\">Cliente</label><select class=\"form-control\" ng-disabled=\"controller.isUpdate\" ng-model=\"controller.registro.cliente.viewId\" ng-options=\"item.viewId as item.nome for item in controller.clientes\"></select></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"date\" maxlength=\"250\" ng-model=\"controller.registro.dataVenda\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Observação</label> <textarea class=\"form-control\" ng-model=\"controller.registro.observacao\" rows=\"2\" maxlength=\"1000\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label><select ng-disabled=\"main.restricaoCadastroProduto\" class=\"form-control\" ng-model=\"controller.registro.situacaoPagamento\"><option ng-value=\"1\">Pendente</option><option ng-value=\"2\">Finalizado</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Registro</label><select class=\"form-control\" ng-model=\"controller.registro.tipoVenda\"><option ng-value=\"0\">Venda</option><option ng-value=\"1\">Pedido</option><option ng-value=\"2\">Orçamento</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-if=\"controller.tipo == 0\"><label class=\"col-form-label\">Forma do Pagamento</label><select class=\"form-control\" ng-model=\"controller.registro.formaPagamento\"><option ng-value=\"0\">Não informado</option><option ng-value=\"1\">Dinheiro</option><option ng-value=\"2\">Cartão de Débito</option><option ng-value=\"3\">Cartão de Crédito à Vista</option><option ng-value=\"4\">Cartão de Crédito Parcelado</option><option ng-value=\"5\">Transferência Bancária</option><option ng-value=\"6\">Boleto</option><option ng-value=\"7\">Cheque</option><option ng-value=\"8\">PIX</option><option ng-value=\"9\">Outro</option></select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDocumentos\', \'boxDocumentos\')\"><h5><i class=\"fa fa-file\"></i> Produtos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDocumentos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDocumentos\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Produto</label><select class=\"form-control\" ng-model=\"controller.produto\" ng-change=\"controller.selecionarProduto()\" ng-options=\"item as item.nome for item in controller.produtos\"></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Quantidade</label> <input type=\"number\" maxlength=\"4\" ng-model=\"controller.quantidadeProduto\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.valorProduto\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-block btn-primary\" ng-click=\"controller.adicionarProduto()\"><i class=\"fa fa-plus\"></i> Adicionar</button></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Produto</th><th class=\"white-bg\">Quantidade</th><th class=\"white-bg\">Valor Unitário</th><th class=\"white-bg\">Valor Total</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.registro.produtos\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.quantidade }}</td><td class=\"ng-binding\">{{ p.valorUnitario | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.quantidade * p.valorUnitario | currency : \'R$ \' : 2 }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.removerProduto(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxServicos\', \'boxServicos\')\"><h5><i class=\"fa fa-file\"></i> Serviços</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxServicos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxServicos\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Serviço</label><select class=\"form-control\" ng-model=\"controller.servico\" ng-change=\"controller.selecionarServico()\" ng-options=\"item as item.nome for item in controller.servicos\"></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Quantidade</label> <input type=\"number\" maxlength=\"4\" ng-model=\"controller.quantidadeServico\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.valorServico\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-block btn-primary\" ng-click=\"controller.adicionarServico()\"><i class=\"fa fa-plus\"></i> Adicionar</button></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Produto</th><th class=\"white-bg\">Quantidade</th><th class=\"white-bg\">Valor Unitário</th><th class=\"white-bg\">Valor Total</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.registro.servicos\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.quantidade }}</td><td class=\"ng-binding\">{{ p.valorUnitario | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.quantidade * p.valorUnitario | currency : \'R$ \' : 2 }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.removerServico(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-dollar\"></i> Total</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxEndereco\" class=\"ibox-content\" cg-busy=\"controller.cepPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Adicional</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.registro.valorAdicional\" ng-blur=\"controller.calcular()\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Desconto</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.registro.valorDesconto\" ng-change=\"controller.calcular()\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Total</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.valorTotal | currency : \'R$ \' : 2}}\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar Informações</button></div></div></div></div></div>");
$templateCache.put("app/venda/imprimir/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Visualizar</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li class=\"active\"><strong>Visualizar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.arquivo}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div>");
$templateCache.put("app/venda/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>{{controller.titulo}}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>{{controller.titulo}}</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.filtro.numero\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Cliente</label> <input type=\"text\" ng-model=\"controller.filtro.cliente\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cadastrado por</label> <input type=\"text\" ng-model=\"controller.filtro.usuario\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.atendimentosPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Registros</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Número</th><th>Data</th><th>Total</th><th>Cliente</th><th>Situação</th><th>Usuário</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>#{{p.numero}}</td><td>{{p.dataVenda | date: \'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{p.valorTotal | currency : \'R$ \' : 2}}</td><td>{{p.cliente.nome}} {{p.cliente.cpf != null && p.cliente.cpf != \'\' ? \' (\' + p.cliente.cpf + \')\' : \'\'}}</td><td style=\"width: 130px;\"><button ng-class=\"p.situacaoPagamento == 2 ? \'btn-primary\' : (p.situacaoPagamento == 5 ? \'btn-danger\' : (p.situacaoPagamento == 3 ? \'btn-success\' : \'btn-warning\'))\" class=\"btn btn-xs btn-block btn-rounded\">{{p.situacaoPagamentoTexto}}</button></td><td>{{p.usuarioCadastro.nome}}</td><td style=\"text-align: center; white-space: nowrap; width: 1px;\"><a ng-click=\"controller.visualizar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a> <a ng-click=\"controller.alterar(p)\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/usuario/esqueci_senha/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Esqueceu a sua senha?</h5><small class=\"font-bold\">Informe seu e-mail de cadastro para alteração de senha.</small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"email\" maxlength=\"100\" ng-model=\"controller.registro.login\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.enviarPromise\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.enviar()\"><i class=\"fa fa-arrow-right\"></i> Enviar</button></div>");
$templateCache.put("app/agenda/calendario/consultar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Detalhes do Agendamento</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white; padding-bottom: 10px;\" cg-busy=\"controller.registrosPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Data do Agendamento</label> <input ng-model=\"controller.registro.dataAgenda\" type=\"date\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Horário</label> <input ng-model=\"controller.registro.horaAgenda\" mask=\"99:99\" type=\"text\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Duração</label> <input type=\"number\" ng-model=\"controller.registro.duracao\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label><select class=\"form-control\" ng-model=\"controller.registro.status\" ng-disabled=\"!controller.isUpdate\"><option ng-value=\"0\">Pendente</option><option ng-value=\"1\">Finalizado</option><option ng-value=\"2\">Cancelado</option><option ng-value=\"3\">Cliente não compareceu</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Cliente</label><select class=\"form-control\" ng-disabled=\"controller.isUpdate\" ng-model=\"controller.registro.cliente.viewId\" ng-options=\"item.viewId as item.nome for item in controller.clientes\"></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Profissional</label><select class=\"form-control\" ng-model=\"controller.registro.responsavel.viewId\" ng-options=\"item.viewId as item.nome for item in controller.usuarios\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Observação</label> <textarea ng-model=\"controller.registro.observacao\" class=\"form-control\" rows=\"2\"></textarea></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxServicos\', \'boxServicos\')\"><h5><i class=\"fa fa-tags\"></i> Serviços</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxServicos\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxServicos\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Serviço</label> <button class=\"btn btn-primary btn-block btn-outline\" ng-click=\"controller.selecionarServicoModal()\">{{controller.servico != null && controller.servico.nome != null ? controller.servico.nome : \'Selecionar serviço\'}}</button></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Quantidade</label> <input type=\"number\" maxlength=\"4\" ng-model=\"controller.quantidadeServico\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.valorServico\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-block btn-success\" ng-click=\"controller.adicionarServico()\"><i class=\"fa fa-plus\"></i> Adicionar</button></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Produto</th><th class=\"white-bg\">Quantidade</th><th class=\"white-bg\">Valor Unitário</th><th class=\"white-bg\">Valor Total</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.registro.servicos\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.quantidade }}</td><td class=\"ng-binding\">{{ p.valorUnitario | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.quantidade * p.valorUnitario | currency : \'R$ \' : 2 }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.removerServico(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-dollar\"></i> Total</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxEndereco\" class=\"ibox-content\" cg-busy=\"controller.cepPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Adicional</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.registro.valorAdicional\" ng-blur=\"controller.calcular()\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Desconto</label> <input type=\"text\" money-mask=\"\" maxlength=\"100\" ng-model=\"controller.registro.valorDesconto\" ng-change=\"controller.calcular()\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor Total</label> <input type=\"text\" disabled=\"\" value=\"{{controller.registro.valorTotal | currency : \'R$ \' : 2}}\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.isUpdate\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxPagamento\', \'boxPagamento\')\"><h5><i class=\"fa fa-book\"></i> Pagamentos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxPagamento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxPagamento\" class=\"ibox-content\" cg-busy=\"controller.cepPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 370px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Data</th><th class=\"white-bg\">Tipo</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Forma Pagamento</th><th class=\"white-bg\">Situação</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.pagamentos\"><td class=\"ng-binding\">{{ p.dataVencimento | date: \'dd/MM/yyyy\' }}</td><td class=\"ng-binding\">{{ p.tipoPagamentoTexto }}</td><td class=\"ng-binding\">{{ p.valor | currency : \'R$ \' : 2 }}</td><td class=\"ng-binding\">{{ p.formaPagamentoTexto }}</td><td class=\"ng-binding\" style=\"width: 130px;\"><button ng-class=\"p.situacao == 1 ? \'btn-warning\' : \'btn-primary\'\" class=\"btn btn-xs btn-block\">{{p.situacaoTexto}}</button></td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.editarPagamento(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i> Editar</button> <button ng-click=\"controller.removerPagamento(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-lg-12\" style=\"text-align: right; padding-top: 0px;\"><button ng-click=\"controller.adicionarPagamento()\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-plus\"></i> Adicionar Pagamento</button></div></div></div></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> {{controller.isUpdate ? \'Atualizar\' : \'Cadastrar\'}}</button></div>");
$templateCache.put("app/produto/categoria/cadastro/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Categoria</h5><small class=\"font-bold\">Informações da categoria</small></div><div class=\"modal-body\" style=\"padding-top: 20px;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" maxlength=\"150\" ng-model=\"controller.registro.nome\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição</label> <input type=\"text\" maxlength=\"250\" ng-model=\"controller.registro.descricao\" placeholder=\"\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button style=\"width: 180px;\" type=\"button\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div>");
$templateCache.put("app/produto/estoque/corrigir/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Estoque</h5><small class=\"font-bold\">Corrigir quantidade</small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Quantidade</label> <input type=\"number\" maxlength=\"15\" ng-model=\"controller.quantidade\" placeholder=\"\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button style=\"width: 180px;\" type=\"button\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div>");
$templateCache.put("app/produto/estoque/historico/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Estoque</h5><small class=\"font-bold\">Movimentações</small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Data</th><th>Quantidade</th><th>Tipo</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{p.dataCadastro | date: \'dd/MM/yyyy HH:mm\'}}</td><td>{{p.estoqueAtual}}</td><td>{{p.tipoMovimentacaoTexto}}</td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/produto/estoque/repor/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Reposição</h5><small class=\"font-bold\">Reposição na quantidade em estoque</small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Estoque Atual</label> <input type=\"number\" disabled=\"\" maxlength=\"15\" ng-model=\"controller.estoqueAtual\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Quantidade</label> <input type=\"number\" maxlength=\"15\" ng-click=\"controller.calcularTotal()\" ng-change=\"controller.calcularTotal()\" ng-model=\"controller.quantidade\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Estoque Atualizado</label> <input type=\"number\" disabled=\"\" maxlength=\"15\" ng-model=\"controller.estoqueAtualizado\" placeholder=\"\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button style=\"width: 180px;\" type=\"button\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div>");
$templateCache.put("app/relatorio/cliente/aniversario/index.html","");
$templateCache.put("app/projeto/modal/cadastrar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Criar Novo Projeto</h5><small class=\"font-bold\">Informe os dados para a criação do novo projeto.</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.nome\" placeholder=\"Nome do Projeto\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Objetivo</label> <input type=\"text\" class=\"form-control\" ng-model=\"controller.registro.objetivo.nome\" disabled=\"\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição</label> <textarea ng-model=\"controller.registro.descricao\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" rows=\"8\" maxlength=\"500\" placeholder=\"\" aria-invalid=\"false\">\r\n                </textarea></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Início</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.registro.dataInicio\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Término</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.registro.dataTermino\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Responsável</label><select class=\"form-control\" ng-model=\"controller.registro.usuarioResponsavel.viewId\" ng-options=\"item.viewId as item.nome for item in controller.usuarios\"></select></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.salvarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Criar Projeto</button></div>");
$templateCache.put("app/projeto/modal/replicar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Replicar Tarefas</h5><small class=\"font-bold\">Módulo para a replicação de tarefas de um determinado projeto.</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Projeto Modelo</label><select class=\"form-control\" ng-model=\"controller.projetoModelo\" ng-options=\"item as item.nome for item in controller.projetos\"></select></div></div></div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"></th><th>Tarefas</th></tr></thead><tbody><tr ng:repeat=\"p in controller.projetoModelo.tarefas\"><td><input icheck=\"\" type=\"checkbox\" ng-model=\"p.isSelecionado\"></td><td>{{p.nome}}</td></tr></tbody></table></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.salvarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.replicarTarefas()\"><i class=\"fa fa-arrow-right\"></i> Replicar Tarefas</button></div>");
$templateCache.put("app/tarefa/modal/cadastrar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Criar Nova Tarefa</h5><small class=\"font-bold\">Informe os dados para a criação do nova tarefa.</small></div><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.nome\" placeholder=\"Nome da Tarefa\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Projeto</label> <input type=\"text\" class=\"form-control\" ng-model=\"controller.registro.projeto.nome\" disabled=\"\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição</label> <textarea ng-model=\"controller.registro.descricao\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" rows=\"8\" maxlength=\"500\" placeholder=\"\" aria-invalid=\"false\">\r\n                </textarea></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Início</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.registro.dataInicio\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Término</label> <input type=\"date\" class=\"form-control\" ng-model=\"controller.registro.dataTermino\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Responsável</label><select class=\"form-control\" ng-model=\"controller.registro.usuarioResponsavel.viewId\" ng-options=\"item.viewId as item.nome for item in controller.usuarios\"></select></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.salvarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Criar Tarefa</button></div>");
$templateCache.put("app/venda/cadastrar/recibo/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Recibo</h5></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.arquivo}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-pink2\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/venda/cadastrar/modal/addpagamento/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Pagamentos</h5><small class=\"font-bold\">Informações do pagamento</small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Pagamento</label><select class=\"form-control\" ng-model=\"controller.registro.tipoPagamento\"><option ng-value=\"1\">À Vista</option><option ng-value=\"2\">Parcelado</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Forma de Pagamento</label><select class=\"form-control\" ng-model=\"controller.registro.formaPagamento\"><option ng-value=\"0\">Não Informado</option><option ng-value=\"1\">Dinheiro</option><option ng-value=\"2\">Cartão de Débito</option><option ng-value=\"3\">Cartão de Crédito</option><option ng-value=\"5\">Transferência Bancária</option><option ng-value=\"6\">Boleto</option><option ng-value=\"7\">Cheque</option><option ng-value=\"8\">PIX</option><option ng-value=\"9\">Outro</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" money-mask=\"\" maxlength=\"15\" ng-model=\"controller.valor\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\" ng-if=\"controller.registro.tipoPagamento == 1\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label><select class=\"form-control\" ng-model=\"controller.registro.situacao\"><option ng-value=\"1\">Pendente</option><option ng-value=\"2\">Pago</option></select></div></div><div class=\"col-sm-6\" ng-if=\"controller.registro.tipoPagamento == 2\"><div class=\"form-group\"><label class=\"col-form-label\">Nº Parcelas</label> <input type=\"number\" maxlength=\"100\" ng-model=\"controller.registro.quantidade\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Data do Pagamento</label> <input type=\"date\" maxlength=\"50\" ng-model=\"controller.registro.dataPagamento\" placeholder=\"\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button style=\"width: 180px;\" type=\"button\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Salvar</button></div>");
$templateCache.put("app/venda/cadastrar/modal/pagamento/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Pagamentos</h5><small class=\"font-bold\">Informações do pagamento</small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Pagamento</label><select class=\"form-control\" ng-model=\"controller.registro.tipoPagamento\" disabled=\"\"><option ng-value=\"1\">À Vista</option><option ng-value=\"2\">Parcelado</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Forma de Pagamento</label><select class=\"form-control\" ng-model=\"controller.registro.formaPagamento\"><option ng-value=\"0\">Não Informado</option><option ng-value=\"1\">Dinheiro</option><option ng-value=\"2\">Cartão de Débito</option><option ng-value=\"3\">Cartão de Crédito</option><option ng-value=\"5\">Transferência Bancária</option><option ng-value=\"6\">Boleto</option><option ng-value=\"7\">Cheque</option><option ng-value=\"8\">PIX</option><option ng-value=\"9\">Outro</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" money-mask=\"\" maxlength=\"15\" ng-model=\"controller.valor\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label><select class=\"form-control\" ng-model=\"controller.registro.situacao\"><option ng-value=\"1\">Pendente</option><option ng-value=\"2\">Pago</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Data do Pagamento</label> <input type=\"date\" maxlength=\"50\" ng-model=\"controller.registro.dataPagamento\" placeholder=\"\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button style=\"width: 180px;\" type=\"button\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div>");
$templateCache.put("app/venda/cadastrar/modal/produto/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Produto</h5><small class=\"font-bold\">Selecione um produto para adicionar à venda.</small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Pesquisar produto:</label> <input ng-model=\"controller.filtro.pesquisa\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control\" placeholder=\"Digite para pesquisar...\"></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.consultaPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>Valor Unitário</th><th>Estoque</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{p.nome}}</td><td>{{p.valorUnitarioTexto}}</td><td ng-class=\"p.estoqueAtual <= 0 ? \'text-danger\' : \'\'\">{{p.estoqueAtual}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/venda/cadastrar/modal/cliente/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Cliente</h5><small class=\"font-bold\">Selecione um cliente para registrar a venda.</small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Pesquisar cliente:</label> <input ng-model=\"controller.filtro.pesquisa\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control\" placeholder=\"Digite para pesquisar...\"></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.consultaPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>CPF</th><th>Celular</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{p.nome}}</td><td>{{p.cpf}}</td><td>{{p.celular}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/venda/cadastrar/modal/servico/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Serviço</h5><small class=\"font-bold\">Selecione um serviço para adicionar à venda.</small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Pesquisar serviço:</label> <input ng-model=\"controller.filtro.pesquisa\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control\" placeholder=\"Digite para pesquisar...\"></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.consultaPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>Valor Unitário</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{p.nome}}</td><td>{{p.valorUnitarioTexto}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");}]);